import React, { Component } from "react";
import { Link } from "react-router-dom";
import { callApi } from "../../utils/api";
import Select from "react-select";
import DocumentNumber from "./DocumentNumber";
import ReactFileReader from "react-file-reader";
import {
  ADMIN_ROLE,
  FRONTOFFICE_ROLE,
} from "../../utils/role";
import {
  ToastsStore,
} from "react-toasts";
import { FaRegEdit } from "react-icons/fa";
import { getFileStatus } from "../../utils/fileStatus";
import QueryTree from "./QueryTree";
import QueryTableComponent from "./QueryTableComponent";
import { cloneDeep } from "lodash";
import moment from "moment";
import { saveAs } from "file-saver";
import { notifyToUser } from "../../utils/firebase";
import { pushnotificationApi } from "../../utils/pushNotify";
import DashUploadDocument from "./DashUploadDocument";
import QueryTray from "./QueryTray";
import CountdownTimer from "./CountdownTimer";
import App from "../../App";
import { isEmpty } from "lodash";
//new qeury table start
import QueryTable from "./QueryTable";
import QueryAdd from "./QueryAdd";
import ReplyQuery from "./ReplyQuery";
//new qeury table end
import "../../components/file/filedash.css";
import { FaRegFilePdf } from "react-icons/fa6";
import { PiFileDocDuotone, PiMicrosoftExcelLogoDuotone } from "react-icons/pi";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import downloadChecklistPDF from "./downloadChecklistPDF";
import downloadChecklistEXCEL from "./downloadChecklistExcel";
import PreviewChecklist from "./PreviewChecklist";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { Modal, message, Alert, List } from 'antd';

declare var $: any;

const REQUERY_DATE_FORMATS = ["DD-MM-YYYY HH:mm:ss.SSS", "DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601];

/** Tray rows use their own primary key as id. Only a numeric linked query id is a real parent. */
function parentIdForRaise(data: any) {
  if (!data || typeof data !== "object") return "";
  const isTrayItem = Array.isArray(data.partialDocuments) || data.savedOn !== undefined || data.tray_query_id !== undefined;
  if (isTrayItem) {
    const linked = String(data.queryId || "").trim();
    return /^\d+$/.test(linked) ? linked : "";
  }
  const explicit = data.query_id !== undefined && data.query_id !== null ? String(data.query_id).trim() : "";
  if (explicit !== "" && explicit !== "0" && explicit !== "extra-document") return explicit;
  const rowId = data.id !== undefined && data.id !== null ? String(data.id).trim() : "";
  return /^\d+$/.test(rowId) ? rowId : "";
}

/** Re-query rows: always stamp with current time; parent link uses query.id only. */
function buildRequeryDetailItem(reply: any, parentTreeQueryId: string | number) {
  const parentId = String(parentTreeQueryId ?? "").trim();
  const created_date = moment().format("DD-MM-YYYY HH:mm:ss");
  const filter_date = moment().format("DD-MM-YYYY HH:mm:ss.SSS");
  return {
    query: reply?.query,
    review: reply?.review,
    other_review: reply?.other_review,
    location: reply?.location,
    query_id: parentId,
    created_date,
    filter_date,
  };
}

/** Rows selected via checkbox in client query table — never treat query_id as created_date. */
function sanitizeMultiSelectedQueryItem(item: any) {
  if (!item || typeof item !== "object") return item;
  const qid = String(item.query_id ?? "").trim();
  const isRequery = qid !== "" && qid !== "0";
  const raw = item.created_date != null && item.created_date !== "" ? String(item.created_date).trim() : "";
  let created_date: string;
  if (isRequery || !raw || /^\d{1,9}$/.test(raw) || (qid && raw === qid)) {
    created_date = moment().format("DD-MM-YYYY HH:mm:ss");
  } else {
    const parsed = moment(raw, REQUERY_DATE_FORMATS, true);
    created_date = parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm:ss") : moment().format("DD-MM-YYYY HH:mm:ss");
  }
  return { ...item, created_date };
}

const particularList = [
  { label: "Original", value: "original" },
  { label: "Xerox", value: "xerox" },
];

const TOAST_FIT_CONTENT_CLASS = "toast-fit-content";
const showFitContentWarning = (message: string) =>
  ToastsStore.warning(message, 5000, TOAST_FIT_CONTENT_CLASS);
const showFitContentError = (message: string) =>
  ToastsStore.error(message, 5000, TOAST_FIT_CONTENT_CLASS);

export interface DocumentDetail {
  total: number;
  yettoopen: number;
  submitted: number;
  inprogress: number;
}

//new qeury table start
interface OriginalObject {
  id: string;
  name: string;
  parent_id: string;
  title: string;
  raice_by: string;
  to: string;
  status: string;
  reason: string;
  d_request_reason: string;
  d_officer_reason: string;
  deviation_status: string;
  location: string;
  created_date: string;
  query_received_date?: string;
  received_date?: string;
  query_received_by?: string;
  received_by?: string;
  serial_no: string | number;
  children: OriginalObject[];
}
interface FlattenedObject {
  id: string; name: string; parent_id: string; title: string;
  raice_by: string; to: string; status: string; reason: string;
  d_request_reason: string; d_officer_reason: string;
  deviation_status: string; location: string; created_date: string;
  query_received_date?: string;
  received_date?: string;
  query_received_by?: string;
  received_by?: string;
  serial_no: string | number;
  [key: string]: any;
}
interface QueryItem {
  query: string; location: string; review: string;
  other_review: string; created_date: string; is_checked: boolean;
}
interface ReQueryItem {
  query: string; location: string; review: string;
  query_id: string; other_review: string; created_date: string;
}
//new qeury table end

interface AllProps { match: any; history: any; }
interface RectificationData {
  id: string; file_id: string; reason: string; whatWrong: string;
  whatChange: string; status: string; created_by: string;
  created_dt: string; rectify_status: string; count: string; completed_dt: string;
}

class FileDashboard extends Component<AllProps> {
  textareaRef: React.RefObject<any>;
  constructor(props) {
    super(props);
    this.textareaRef = React.createRef();
  }
  query: any = React.createRef();
  startTime: any;
  documentFormat = {
    base: "", base_url: "", docNoYear: "", particular: "xerox",
    type: "", isValid: true, doc_type: "", isPdfCompress: 'off', query_id: "", query_label: "",
    query_raised_at: "", query_received_at: "",
  };
  state = {
    showModal: false,
    base: [],
    docToPreview: "",
    type: "",
    workfileEnable: true,
    inreasonRE: "",
    selectVal: false,
    queryRecived: "",
    setResponse: true,
    showThepopup: true,
    other: {},
    ec_doc: {},
    rev_rec_doc: {},
    queries: [],
    file_status: "0",
    info: {
      verify_officer: "", deviation_officer: "", rectify_officer: "",
      process_officer: "", query_validation_officer_name: "",
      all_query_validation_officer_names: "", dverify_officer: "",
      app_id: "", propertyAddress: "", doc_request: "", file_name: "",
      file_status: "", file_grade: "", verify: "", report_status: "",
      pending: "", closed: "", total: "", bank_name: "", product_name: "",
      login_time: "", opinion_type: "", vtaken_status: "", taken_status: "",
      query_taken_status: "", hold_date: "", noquery_status: "",
      rectify_noquery_status: "", rectify_status: "", vetting_complete_status: '',
      rtaken_status: "", is_query_validate: "",
      vetting_file_no: '', org_bank_id: "", lawhands_branch: "", productId: "",
      bank_product: "", responsible_branch_staff: "",
      isShowDeviationSummary: false, is_marked_file: false,
    },
    reason: "",
    step: 0,
    bank_templates: [],
    bank_id: 0,
    isbtnload: false,
    office_users: [],
    remote_users: [],
    remote_cc_users: [],
    multiSelectedQuery: [],
    repliedQueries: [],
    queryBase: [],
    isNewFile: false,
    queryPayload: { requery: [], resend: [] },
    previewDoc: "",
    tempdocToPreview: "",
    queryLoading: false,
    queryQues: [],
    oldQueryQues: [],
    quesSubmitted: false,
    isFlowChartUploading: false,
    flowChartPreview: "",
    updateDownloadData: { reasonForDownload: [], updatedDetails: [] },
    checkListLog: [],
    action: "",
    uploadFile: { base64: "", fileList: [{ name: "" }] },
    isAutoMailLogShown: false,
    isCheckListLogShown: false,
    isReasonForDownloadShown: false,
    isUpdateDownloadShown: false,
    date: "",
    hours: 0, minutes: 0, seconds: 0, intime: 0, curentDate: 0,
    in_reason: "", outreason: "", docNoYear: "",
    categoriesList: [], categoriesType: "", particular: "",
    newquery: [], uploadbtn: false,
    initialTimeInMinutes: 0, updatedRemainingTime: 0,
    doc_count: 0, blockdownload: "", showTitle: true,
    iscomplete: false, isprocesscomplete: false,
    reasons: [], query_tree_length: 0, isLoading: false,
    deeds: [], holdDetails: [],
    //new query table start
    isRaiseQueryShown: false,
    newQueryList: [] as QueryItem[],
    isReplyRaiseQueryShown: false,
    replyQueryList: [] as QueryItem[],
    reQueryList: [] as ReQueryItem[],
    queryTableData: [],
    showPopup: false,
    selectedQueryname: "", selectedQuerytitle: "", selectedQueryid: "",
    //new query table end
    deviationTakenQuerys: [], isdeviationLoading: false,
    deviationReason: "", isverifycomplete: false, isrectifycomplete: false,
    Rectify_files: [] as RectificationData[],
    isFileRefresh: false, isrectificationComplete: true,
    LHBranchCode: "", pdfToPreview: "", pageDynamic: [],
    fileNotCompleteMsg: { __html: "" },
    deviationSummaryList: [], deviationTrainingToWhomList: [],
    deviationTrainingAreaList: [],
    deviationSummaryDetails: {
      deviationRequired: false, deviationTaken: '', deviationSummary: [],
      knowledgeAssessment: '0', trainingNeeded: '', trainingToWhom: [],
      trainingArea: [], specialFileNeeded: '',
      showOtherFields: { deviationSummary: false, trainingToWhom: false, trainingArea: false },
    },
    isDeviationSummaryLoading: false,
    isGlobalPdfCompress: '', globalPdfCompressQuality: '',
    isFrontOfficePdfCompressShow: '', isSroEcPdfCompressQuality: '',
    isOnlineEcPdfCompressQuality: '',
    selectedChecklistItem: null,
    selectedFiles: { pdf: false, word: false, preliminary: false },
    hasCheckedItem: false,
    isUploadModalVisible: false,
    reportSendPayload: null,
    mailDetails: null, uploading: false,
    uploadPendingExpandedId: "",
    uploadPendingMenuQuery: null,
    uploadHintQuery: null,
    uploadHintText: "",
    queryHintMap: {},
    queryHintDateMap: {},
    queryHintCreatedByMap: {},
    queryReceivedDocMap: {},
    queryReceivedDocCreatedByMap: {},
    bankWithLawhadnsBranch: [], autoMailTriggerLog: [],
    newQueryValidatedList: [] as QueryItem[],
    uploadSelectedQueryIds: [] as string[],
    queryTrayItems: [] as any[],
    uploadSendMailPreviewOpen: false,
    uploadSendMailPreviewQueries: [] as any[],
    uploadTrayExpandedId: "",
    uploadTraySelectedIds: [] as string[],
    isTraySaving: false,
    trayPendingMailModalOpen: false,
    trayPendingMailQueries: [] as any[],
    trayPendingMailSending: false,
    trayPendingMailBlockActive: false,
    isQueryTrayFeatureEnabled: false,
  };

  async componentDidMount() {
    this.fetchPdfSettings();
    this.getBranchCode();
    this.getPageDynamicData();
    this.blockdownload();
    this.getQueryTree();
    this.getFileDashboard();
    this.listreason();
    this.getQueryTable();
    this.getStepStatus();
    this.getDeeds();
    this.getRectifyFiles();
    this.getQueryHints();
    this.getQueryReceivedDocs();
    this.getQueryTrayFeatureStatus();
    this.getDeviationDropdownLists();
    this.getThreadMailDetails();
    this.getBankWithLawhandsBranch();
    this.fetchQueryNotes();

    if (localStorage.getItem("BankTemplate")) {
      var bankTemp: any = localStorage.getItem("BankTemplate");
      this.setState({ bank_templates: JSON.parse(bankTemp) });
    } else {
      this.getTemplates();
    }
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) { this.getInTime(); }
    window.addEventListener("beforeunload", this._confirm);
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = this._backConfirm;
    localStorage.setItem("currentfileId", JSON.stringify(this.props.match.params.id));
    localStorage.setItem("dashboard_status", "1");
    var inreasonRE: any = localStorage.getItem("in_reason");
    this.setState({ inreasonRE: JSON.parse(inreasonRE) });
    const isPopupFromWIP: any = localStorage.getItem("isPopupFromWIP");
    if (isPopupFromWIP == "true") { this.checkProcessFile(); }
    window.addEventListener("popstate", this.handlePopState);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id === this.props.match.params.id) return;
    localStorage.setItem("currentfileId", JSON.stringify(this.props.match.params.id));
    this.setState({
      base: [],
      multiSelectedQuery: [],
      newquery: [],
      newQueryList: [],
      replyQueryList: [],
      reQueryList: [],
      queryPayload: { requery: [], resend: [] },
      queryTrayItems: [],
      queryTableData: [],
      uploadTraySelectedIds: [],
      uploadTrayExpandedId: "",
      uploadSelectedQueryIds: [],
    }, () => {
      this.getFileDashboard();
      this.getQueryTable();
      this.getQueryTree();
      this.getQueryTrayFeatureStatus();
      this.getQueryHints();
      this.getQueryReceivedDocs();
    });
  }

  countdownTimerRef: CountdownTimer | null = null;
  appRef: App | null = null;

  getBankWithLawhandsBranch() {
    callApi("GET", "bank_branch_get_management.php")
      .then((res) => res.data)
      .then((result) => { this.setState({ bankWithLawhadnsBranch: result.data }); })
      .catch((err) => { console.log(err); });
  }

  getThreadMailDetails = () => {
    let req = {
      action: "get_file_with_emails",
      file_id: this.props.match.params.id,
      page: 1, limit: 5
    };
    callApi("POST", "fetch_query_received_mail_details.php", req)
      .then((res) => res.data)
      .then((response: any) => {
        if (response.success) {
          const { files } = response;
          const processedFiles = files.map((file, index) => ({
            s_no: index + 1, file_id: file.file_no, file_name: file.file_name,
            app_id: file.app_id, branch_name: file.branch_name,
            borrower_name: file.borrower_name, bank_name: file.bank_name,
            created_date: file.created_date_formatted, file_status: file.file_status,
            total_emails: file.total_emails, total_attachments: file.total_attachments,
            emails: file.emails, query_received_to: file.process_officer,
            query_raised_dt: file.query_raised_dt,
            received_dt: this.getLatestEmailDate(file),
            login_dt: file.created_date_formatted,
          }));
          this.setState({
            mailDetails: processedFiles && processedFiles.length > 0 ? processedFiles[0] : null,
          });
        } else {
          this.setState({ mailDetails: [] });
        }
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Error loading files");
        this.setState({ files: [], totalFiles: 0, totalPages: 0, totalDataCount: 0 });
      });
  };

  getLatestEmailDate(file: any): string {
    if (file.emails && file.emails.length > 0) {
      const latestEmail = file.emails[0];
      return latestEmail.received_at_formatted ||
        moment(latestEmail.received_at).format('DD-MM-YYYY/HH:mm');
    }
    return "No emails";
  }

  fetchPdfSettings = () => {
    callApi("POST", "pdf_category.php")
      .then((res) => res.data)
      .then((response: any) => {
        if (response.result && response.data) {
          const isGlobalPdfCompress = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.status == '1';
          const globalPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.quality;
          const isFrontOfficePdfCompressShow = response.data['Pdf document']?.find((item: any) => item.name == 'In Query Upload Show/Hide')?.status == '1';
          const isSroEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'SRO Encumbrance Certificate')?.quality;
          const isOnlineEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'Online Encumbrance Certificate')?.quality;
          this.setState({ isGlobalPdfCompress, isFrontOfficePdfCompressShow, globalPdfCompressQuality, isSroEcPdfCompressQuality, isOnlineEcPdfCompressQuality });
        }
      })
      .catch((err) => { console.log(err); ToastsStore.error("Failed to load PDF settings"); });
  };

  handlePopState = (type?: any) => {
    setTimeout(() => {
      const fileurl: any = localStorage.getItem("url");
      if (fileurl == "") {
        localStorage.removeItem("currentfileId");
        localStorage.setItem("returnBack", JSON.stringify(true));
        $("#in_time").modal("hide");
        this.props.history.push("/inprogress-file");
      } else if (type == "back") {
        this.props.history.push(fileurl);
      }
    }, 1500);
  };

  componentWillUnmount() {
    if (this.countdownTimerRef) { this.countdownTimerRef.clearInterval(); }
    if (this.appRef) { this.appRef.getTimerZero(); }
    var inreasonRe = localStorage.getItem("in_reason");
    if (inreasonRe) {
      window.removeEventListener("beforeunload", this._confirm);
      window.onpopstate = this._confirm;
    }
    const process_office_id: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");
    if (process_office_id == userid1) {
      this.timeUpdate(this.props.match.params.id, "file_dash_out");
    }
    localStorage.setItem("from_deviation", JSON.stringify(false));
    this.cleanupStaleModalOverlays();
    setTimeout(() => this.cleanupStaleModalOverlays(), 100);
  }

  blockdownload = () => {
    callApi("POST", "block_download_status.php", { file_idfk: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { this.setState({ blockdownload: response["responseJson"].data[0].block_download_status }); })
      .catch((err) => { console.log(err); });
  };
  getRectifyFiles = () => {
    this.setState({ isFileRefresh: false });
    callApi("POST", "get_rectify_data.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { this.setState({ Rectify_files: response.data, isFileRefresh: true }); })
      .catch((err) => { console.log(err); });
  };
  getBranchCode = () => {
    callApi("POST", "get_branch_code.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { this.setState({ LHBranchCode: response.data[0].lawhands_branch }); })
      .catch((err) => { console.log(err); });
  };
  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res.data)
      .then((result) => { this.setState({ pageDynamic: result?.responseJson?.data }); })
      .catch((err) => { console.log(err); });
  };

  getQueryTrayFeatureStatus = () => {
    callApi("POST", "feature_get.php")
      .then((res) => res.data)
      .then((response: any) => {
        const features = Array.isArray(response?.data) ? response.data : [];
        const queryTrayFeature = features.find((item: any) => String(item?.id || "") === "6");
        const isQueryTrayFeatureEnabled = String(queryTrayFeature?.status || "0") === "1";
        this.setState({ isQueryTrayFeatureEnabled });
        if (isQueryTrayFeatureEnabled) {
          this.getQueryTrayItems();
        } else {
          this.setState({
            queryTrayItems: [],
            uploadTrayExpandedId: "",
            uploadTraySelectedIds: [],
            trayPendingMailModalOpen: false,
            trayPendingMailQueries: [],
            trayPendingMailBlockActive: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isQueryTrayFeatureEnabled: false,
          queryTrayItems: [],
          uploadTrayExpandedId: "",
          uploadTraySelectedIds: [],
          trayPendingMailModalOpen: false,
          trayPendingMailQueries: [],
          trayPendingMailBlockActive: false,
        });
      });
  };

  isTakenWorkflowStatus = (value: any) => String(value ?? "").trim() === "1";

  isFileTakenInActiveWorkflow = () => {
    const info = this.state.info || {};
    return (
      this.isTakenWorkflowStatus(info.taken_status) ||
      this.isTakenWorkflowStatus(info.vtaken_status) ||
      this.isTakenWorkflowStatus(info.rtaken_status) ||
      this.isTakenWorkflowStatus(info.is_query_validate)
    );
  };

  hasPageDynamicAccess = (pageName: string) =>
    Array.isArray(this.state.pageDynamic) &&
    this.state.pageDynamic.some((page: any) => page?.page_name === pageName && page?.status == true);

  canShowMoveToProcessButton = () =>
    this.hasPageDynamicAccess("Move to Process Button");

  canShowSaveToTrayButton = () =>
    this.state.isQueryTrayFeatureEnabled &&
    !this.isFileTakenInActiveWorkflow() &&
    this.hasPageDynamicAccess("Save In Tray Button") &&
    this.getPendingQueriesForTrayMail(
      this.state.queryTableData || [],
      this.state.queryTrayItems || []
    ).length > 0;

  getQueryTable = () => {
    let req = { fod_fk: this.props.match.params.id };
    callApi("POST", "query_table.php", req)
      .then((res) => res.data)
      .then(async (response) => {
        if (response) {
          const data = response.result;
          const flatData: any = await this.flattenData(data);
          const flattenedJson: FlattenedObject[] = await this.flattenObjects(flatData);
          this.setState({ queryTableData: flattenedJson });
          this.getQueryHints();
        }
      })
      .catch((err) => { console.log(err); });
  };
  normalizeQueryStatus = (status: any) => String(status ?? "").trim().toLowerCase();
  getQueryStatusValue = (query: any) => query?.status ?? query?.details?.status ?? "";
  isCompletedQueryStatus = (status: any) => {
    const value = this.normalizeQueryStatus(status);
    return value === "3" || value === "completed" || value === "closed";
  };
  isQueryReceivedQueryStatus = (status: any) => {
    const value = this.normalizeQueryStatus(status);
    return value === "2" || value === "query received" || value === "query_received";
  };
  flattenData = (data) => {
    const result: FlattenedObject[] = [];
    const flatten = (node) => {
      const { children, ...rest } = node;
      const details = rest?.details || {};
      // Query API can return core fields inside `details`; merge those so status checks are consistent.
      result.push({ ...details, ...rest, status: rest?.status ?? details?.status, children: [] });
      if (children && children.length > 0) { children.forEach((child) => flatten(child)); }
    };
    data.forEach((item) => flatten(item));
    return result;
  };
  flattenObjects(originalObjects: OriginalObject[]): FlattenedObject[] {
    const flattened: FlattenedObject[] = [];
    const flatten = (object: OriginalObject) => {
      if (!this.isCompletedQueryStatus(object.status)) {
        flattened.push({
          id: object.id, name: object.name, parent_id: object.parent_id,
          title: object.title, raice_by: object.raice_by, to: object.to,
          status: object.status, reason: object.reason, location: object.location,
          created_date: object.created_date, serial_no: object.serial_no,
          query_received_date: object.query_received_date,
          received_date: object.received_date,
          query_received_by: object.query_received_by,
          received_by: object.received_by,
          d_request_reason: object.d_request_reason, d_officer_reason: object.d_officer_reason,
          deviation_status: object.deviation_status,
        });
        if (object.children && object.children.length > 0) {
          object.children.forEach((child) => flatten(child));
        }
      }
    };
    originalObjects.forEach((obj) => flatten(obj));
    return flattened;
  }
  getLatestQueryTableDataForValidation = async () => {
    try {
      const req = { fod_fk: this.props.match.params.id };
      const response = await callApi("POST", "query_table.php", req).then((res) => res.data);
      if (response?.result) {
        const flatData: any = await this.flattenData(response.result);
        const flattenedJson: FlattenedObject[] = await this.flattenObjects(flatData);
        return flattenedJson;
      }
    } catch (error) {
      console.log(error);
    }
    return this.state.queryTableData || [];
  };
  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then((res) => res.data)
      .then((response) => { if (response.data && response.data.length) { this.setState({ deeds: response.data }); } })
      .catch((err) => { console.log(err); });
  };
  getQueryTree = () => {
    callApi("POST", "query_tree.php", { fod_fk: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { if (response) { this.setState({ query_tree_length: response.length }); } })
      .catch((err) => { console.log(err); });
  };
  listreason = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "query_reason_get.php")
      .then((res) => res.data)
      .then((response) => { this.setState({ reasons: response.data }); })
      .catch((err) => { console.log(err); });
  };
  OPenToaster = () => { ToastsStore.success("Please Select The Bank Template"); };
  _backConfirm = async () => { };
  openUploadModal = () => {
    this.getCategories();
    this.getQueryTable();
    this.getQueryReceivedDocs();
    this.getQueryTrayItems();
  };
  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => { this.setState({ categoriesList: response.data }); })
      .catch((err) => { console.log(err); });
  };
  _confirm = (e) => {
    const confirmationMessage = this.state.trayPendingMailBlockActive
      ? "Pending queries must be sent by mail before you leave this page."
      : "o/";
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  };
  previousPop = () => { $("#in_time").modal("show"); $("#another-reason").modal("hide"); };
  previousPage = (type?: any) => {
    const fileurl: any = localStorage.getItem("url");
    $("#in_time").modal("hide");
    if (type == "autoback") localStorage.removeItem("currentfileId");
    localStorage.removeItem("thisPopup");
    localStorage.removeItem("isPopupFromWIP");
    this.props.history.push(`${fileurl}`);
    localStorage.removeItem("url");
    if (type == "back") {
      localStorage.setItem("filedashboardback", "true");
      localStorage.removeItem("currentfileId");
      localStorage.removeItem("BankTemplate");
    }
  };
  getInTime = () => {
    if (localStorage.getItem("thisPopup")) {
      $("#in_time").modal("show");
      let date = new Date();
      let curentDate = date.toLocaleDateString();
      localStorage.setItem("Intimedate", JSON.stringify(curentDate));
      var Railway = date.getMinutes();
      if (Railway < 10) {
        var TotalMinutes = "0" + Railway;
        let intime = date.getHours() + ":" + TotalMinutes;
        localStorage.setItem("IntimeGet", JSON.stringify(intime));
      } else {
        let intime: any = date.getHours() + ":" + date.getMinutes();
        this.setState({ intime: intime });
        localStorage.setItem("IntimeGet", JSON.stringify(intime));
      }
      let intime = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("IntimeGet", JSON.stringify(intime));
    } else {
      $("#in_time").modal("hide");
    }
  };
  SubmitREsponse = () => {
    localStorage.removeItem("filedashboardback");
    if (this.state.in_reason == "") {
      this.setState({ selectVal: true });
    } else {
      localStorage.setItem("filenumber", this.state.info.file_name);
      localStorage.setItem("inreasonlive", this.state.in_reason);
      localStorage.removeItem("thisPopup");
      const isPopupFromWIP: any = localStorage.getItem("isPopupFromWIP");
      if (isPopupFromWIP == "true") { this.checkProcessFile("onSubmit"); } else { this.liveinsert(); }
      let in_reason = this.state.in_reason;
      localStorage.setItem("in_reason", JSON.stringify(in_reason));
      this.processEodInsert();
    }
  };
  processEodInsert = () => {
    const userid1: any = localStorage.getItem("user1");
    const intime: any = localStorage.getItem("IntimeGet");
    let date = new Date();
    let outdate = date.toLocaleDateString();
    let obj = {
      file_id: this.props.match.params.id, user_id: JSON.parse(userid1),
      in_reason: this.state.in_reason, intime: JSON.parse(intime), insert_date: outdate,
    };
    callApi("POST", "process_eod_insert.php", obj)
      .then(res => res.data)
      .then(response => {
        if (response.status == 200) {
          const { insert_id } = response;
          localStorage.setItem("ProcessEodInsertID", JSON.stringify(insert_id));
        }
      }).catch((err) => { console.log(err); this.setState({ isLoading: false }); });
  };
  checkProcessFile = (type?: any) => {
    const isPopupFromWIP: any = localStorage.getItem("isPopupFromWIP");
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    let payload = {
      user_id: userId, file_no: this.props.match.params.id,
      ...(isPopupFromWIP && { flag: isPopupFromWIP }),
    };
    callApi("POST", "checkAutoAssignFile.php", payload)
      .then((res) => res.data)
      .then((response) => {
        if (response.response_Code == 200) {
          if (type == "onSubmit") this.liveinsert();
          localStorage.removeItem("isPopupFromWIP");
        } else {
          localStorage.removeItem("isPopupFromWIP");
          toast.error(response.message, { autoClose: 5000 });
          setTimeout(() => { this.previousPage("autoback"); }, 2000);
        }
      })
      .catch((err) => { console.log(err); });
  };
  liveinsert = () => {
    this.setState({ isLoading: true });
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["team_type"] : "";
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role = user ? JSON.parse(user)["teamType"] : "";
    const role_type = user ? JSON.parse(user)["roleType"] : "";
    const user_name = user ? JSON.parse(user)["userName"] : "";
    const bankName: any = localStorage.getItem("bankName");
    localStorage.setItem("fileNamCode", this.state.info.file_name);
    let dateTime = new Date();
    let curentTime = dateTime.toLocaleTimeString();
    const textRay = `Currently working on File No : ${this.props.match.params.id}`;
    let obj = {
      file_no: this.state.info.file_name, in_time: curentTime,
      reason: this.state.in_reason, user_id: userId, user_name: user_name,
      team_type: role, role_type: role_type, working_process: textRay, bank_name: bankName,
    };
    callApi("POST", "live_track_insert.php", obj)
      .then((res) => res.data)
      .then((response) => { $("#in_time").modal("hide"); $("#another-reason").modal("hide"); this.setState({ isLoading: false }); })
      .catch((err) => { console.log(err); ToastsStore.error("Your Reason Not Stored"); this.setState({ isLoading: false }); });
  };
  onchangeReason = (e: any) => {
    if (e.target.value == "other") {
      this.setState({ showModal: true }, () => { this.textareaRef.current.focus(); });
      this.setState({ in_reason: "", selectVal: false });
      $("#in_time").modal("hide");
      $("#another-reason").modal("show");
    } else if (e.target.value == "select") {
      this.setState({ setResponse: false });
    } else {
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };
  getFlowChart = () => {
    callApi("POST", "get_flow_chart.php", { fileId: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data[0]) { this.setState({ flowChartPreview: response.data[0].fileContent || "" }); }
        else { this.setState({ flowChartPreview: "" }); }
      });
  };
  getQueries = () => {
    callApi("POST", "query_get.php", { fod_fk: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { this.setState({ queries: response.data }); })
      .catch((err) => { console.log(err); });
  };
  getUsers = () => {
    const remote_users: any = [];
    callApi("POST", "office_details.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        response.data.map((user) => { remote_users.push({ email: user.email, name: user.name }); });
        this.setState({ office_users: response.data, remote_users, remote_cc_users: remote_users });
      });
  };
  getQueryQuestion = () => {
    callApi("POST", "query_question_get.php")
      .then((res) => res.data)
      .then((response) => { this.setState({ queryQues: response.data, oldQueryQues: JSON.parse(JSON.stringify(response.data)) }); });
  };
  getTemplates = () => {
    callApi("POST", "file_dash_temp.php")
      .then((res) => res.data)
      .then((response) => {
        let banks = response.data;
        const vetting = banks.filter((item) => item.name.split(" ").pop() != "Vetting");
        this.setState({ bank_templates: vetting });
        localStorage.setItem("BankTemplate", JSON.stringify(vetting));
      })
      .catch((err) => { console.log(err); });
  };
  initDocumentDetail = () => ({ total: 0, yettoopen: 0, submitted: 0, inprogress: 0 });
  getFileDashboard = () => {
    const userid1: any = localStorage.getItem("user1");
    const user_id = JSON.parse(userid1);
    callApi("POST", "file_dash.php", { branch_idfk: this.props.match.params.id, user_id })
      .then((res) => res.data)
      .then((response) => {
        const state = response.data;
        const process_officer: any = localStorage.getItem("process_office_id");
        const userid1: any = localStorage.getItem("user1");
        const take_file: any = localStorage.getItem("takenfile_id");
        const getfileId: any = localStorage.getItem("currentfileId");
        if (response.info && response.info.length) {
          if (process_officer == userid1 && take_file == getfileId) {
            if (response.info[0].target_min == 0) { $("#balance-time").modal("show"); }
            else {
              let initialTimeInMinutes: any = localStorage.getItem("updatedRemainingTime");
              if (initialTimeInMinutes > 0) { this.setState({ initialTimeInMinutes }); }
              else if (response.info) { this.setState({ initialTimeInMinutes: response.info[0].target_min }); }
              else { this.setState({ initialTimeInMinutes: 0 }); }
            }
          }
          state.info = response.info[0];
          state.bank_id = state.info.bank_id;
          localStorage.setItem("file_d_grade", state.info.file_d_grade);
          localStorage.setItem("user_d_grade", state.info.user_d_grade);
          localStorage.setItem("mail-bank", JSON.stringify(state.info.mail_to_bank));
          this.setState({ doc_count: response.info[0].doc_count });
          this.setState({ workfileEnable: state.bank_id == 0 });
        }
        this.setState({ ...state });
      })
      .catch((err) => { console.log(err); });
  };
  getStepStatus = () => {
    callApi("POST", "file_status_steps.php", { id: this.props.match.params.id })
      .catch((res) => res.data)
      .then((response) => { if (response.data.step) { this.setState({ step: response.data.step }); } })
      .catch((err) => { console.log(err); });
  };
  confirmUpdateFileStatus = (file_status) => {
    if (this.state.info.file_status === "0") {
      this.setState({ reason: "" });
      $("#reason-modal").modal("show");
      const info = this.state.info;
      info.file_status = file_status;
      this.setState({ info });
      return;
    } else {
      file_status = this.state.info.file_status === "0" ? file_status : "0";
      this.updateFileStatus(file_status);
    }
  };
  submitReason = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "reason_create.php", {
      userId, action: this.state.info.file_status === "3" ? "hold" : "reject",
      reason: this.state.reason, fod_fk: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => { $("#reason-modal").modal("hide"); this.updateFileStatus(this.state.info.file_status); })
      .catch((err) => { console.log(err); });
  };
  updateFileStatus = (file_status) => {
    callApi("POST", "file_status.php", { id: this.props.match.params.id, file_status })
      .then((res) => res.data)
      .then((response) => { this.getFileDashboard(); })
      .catch((err) => { console.log(err); });
  };
  handleFullyQueryReceived = () => {
    if (!window.confirm("Move this file to queue (Fully Query Received)? File will be unassigned and set to Query Received status.")) return;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const fileId = this.props.match.params.id;
    callApi("POST", "fully_query_received.php", { file_id: fileId, user_id: userId })
      .then((res) => res.data)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message || "File moved to queue (Fully Query Received).", { autoClose: 5000 });
          this.props.history.push("/query-validation-inprogress");
        } else { toast.error(response.message || "Failed to move file.", { autoClose: 5000 }); }
      })
      .catch((err) => { console.log(err); toast.error("Failed to move file to queue.", { autoClose: 5000 }); });
  };
  handleMoveToQueue = () => {
    if (!window.confirm("Move this file to queue?")) return;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const fileId = this.props.match.params.id;
    callApi("POST", "move_to_queue.php", { file_id: fileId, user_id: userId })
      .then((res) => res.data)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message || "File moved to queue.", { autoClose: 5000 });
          this.props.history.push("/query-validation-inprogress");
        }
      })
      .catch((err) => { console.log(err); toast.error("Failed to move file to queue.", { autoClose: 5000 }); });
  };
  modifyQueryStatus = (modal) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "query_close.php", { id: modal.query_id, status: modal.query_status === "Pending" ? 3 : 0, userId })
      .then((res) => res.data)
      .then((response) => { this.getFileDashboard(); this.getQueryTable(); })
      .catch((err) => { console.log(err); });
  };
  handleChange = (e, propName?, fieldType?) => {
    let fieldName = fieldType === "singleselect" ? propName : e.target.name;
    let fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
    this.setState({ [fieldName]: fieldValue });
    if (fieldName !== "reason") { this.saveTemplate(fieldValue); }
  };
  handleChange1 = (e: any) => { const info: any = this.state.info; info[e.target.name] = e.target.value; this.setState({}); };
  handleChange2 = (e: any) => { const info: any = this.state.info; info[e.target.name] = e.target.value; this.setState({}); };
  saveDocNo = (e: any) => { this.setState({ docNoYear: e.target.value }); };
  saveTemplate = (val) => {
    callApi("POST", "bank_temp_save.php", { id: this.props.match.params.id, bank_id: val })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ workfileEnable: false });
        localStorage.removeItem("BankTemplate"); localStorage.removeItem("overviewDocument");
        this.getQueries(); this.getFileDashboard();
      })
      .catch((err) => { console.log(err); });
  };
  uploadFlowchart = (files: any, type: string) => {
    this.setState({ isFlowChartUploading: true });
    const base: any = [];
    files.base64.map((file: any, index: number) => { base.push({ base: file, details: files.fileList[index], type }); });
    if (files.base64.length) {
      callApi("POST", "flow_chart_add.php", {
        fileId: this.props.match.params.id,
        fileName: files.fileList[0].name,
        fileContent: base[0].base.split(",")[1],
      })
        .then((res) => { this.setState({ isFlowChartUploading: false }, () => { this.getFlowChart(); }); ToastsStore.success("File(s) Uploaded Successully"); })
        .catch((err) => { this.setState({ isFlowChartUploading: false }); });
    }
  };
  deleteFlowChart = () => {
    this.setState({ isFlowChartUploading: true });
    callApi("POST", "delete_flow_chart.php", { fileId: this.props.match.params.id })
      .then((res) => { this.setState({ isFlowChartUploading: false }, () => { this.getFlowChart(); }); ToastsStore.success("File(s) Deleted Successully"); })
      .catch((err) => { this.setState({ isFlowChartUploading: false }); });
  };

  uploadFiles = () => {
    this.uploadDocumentsToProcess()
      .then((result) => {
        if (result?.success) {
          this.finishAfterSuccessfulProcessMove(result.uploadedCount || 0, false);
        }
      })
      .catch(() => {
        this.setState({ isbtnload: false, uploadbtn: false });
      });
  };

  uploadDocumentsToProcess = () => {
    const isValid = this.validateDocuments();
    if (!isValid) {
      ToastsStore.error("Please fill in all fields for this document"); 
      return Promise.resolve({ success: false, uploadedCount: 0 });
    }

    this.setState({ isbtnload: true, uploadbtn: true });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const flag_status = this.state.info.file_status == "7" ? 1 : 0;
    const api = this.state.info.file_status == "10" ? "verification_doc_file_upload.php" : "doc_file_upload.php";
    const uploadedCount = Number(this.state.base.length);

    return callApi("POST", api, {
      id: this.props.match.params.id,
      uploadfile: this.state.base,
      flag_status,
      type: "process",
      userId,
    })
      .then((res) => res.data)
      .then((responseData) => {
        if (responseData.success === true) {
          return { success: true, uploadedCount, flag_status };
        }
        this.setState({ uploadbtn: false, isbtnload: false });
        ToastsStore.error("File(s) Not Uploaded");
        return { success: false, uploadedCount: 0 };
      })
      .catch(() => {
        this.setState({ isbtnload: false, uploadbtn: false });
        ToastsStore.error("File(s) Not Uploaded");
        return { success: false, uploadedCount: 0 };
      });
  };

  moveQueryTrayToProcess = (applyStatus = true) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const flag_status = this.state.info.file_status == "7" ? 1 : 0;

    return callApi("POST", "query_tray_move_to_process.php", {
      file_id: this.props.match.params.id,
      user_id: userId,
      flag_status,
      type: "process",
      apply_status: applyStatus,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response?.result) {
          this.setState({
            queryTrayItems: response.data || [],
            uploadTraySelectedIds: [],
          });
          return response;
        }
        showFitContentError(response?.message || "Unable to move query tray to process");
        return null;
      })
      .catch(() => {
        showFitContentError("Unable to move query tray to process");
        return null;
      });
  };

  finishAfterSuccessfulProcessMove = (uploadedCount = 0, trayOnly = false) => {
    let updatedRemainingTime: any = localStorage.getItem("updatedRemainingTime");
    let updatedtime = Math.round(updatedRemainingTime);
    const doc_count = uploadedCount > 0
      ? Number(uploadedCount) + Number(this.state.doc_count)
      : Number(this.state.doc_count);

    const finalize = (onAfterFinalize?: () => void) => {
      const isQueryRaisedFile = this.state.info.file_status == "7";
      const statusLogPromise = isQueryRaisedFile
        ? this.timeUpdate(this.props.match.params.id, "query receive")
        : (this.state.info.file_status != "10"
          ? this.timeUpdate(this.props.match.params.id, "before query raise")
          : Promise.resolve(null));

      statusLogPromise.finally(() => {
        this.setState({ isbtnload: false, uploadbtn: false, base: [] });
        $("#upload-modal").modal("hide");
        const notifyData = {
          fileId: this.props.match.params.id,
          title: `${this.props.match.params.id}Query Upload`,
          notifyType: "message",
          updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        };
        const user2: any = localStorage.getItem("user");
        const userId2 = user2 ? JSON.parse(user2)["userId"] : "";
        pushnotificationApi(notifyData, userId2);
        const sendNotification = (storageKey: string) => {
          const stored: any = localStorage.getItem(storageKey);
          const parsed = stored ? JSON.parse(stored) : [];
          if (Array.isArray(parsed) && parsed.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, parsed);
            callApi("POST", "pushnotification.php", { user_id: parsed.join(","), ...notifyData }).catch(() => { });
          }
        };
        sendNotification("branch_manager");
        sendNotification("Query_officer");
        sendNotification("scan_officer");
        sendNotification("process_manager");
        ToastsStore.success(trayOnly ? "Query tray moved to process successfully." : "File(s) Uploaded Successully");
        this.getQueryTable();
        this.getQueryReceivedDocs();
        this.getQueryTrayItems();
        if (typeof onAfterFinalize === "function") {
          onAfterFinalize();
        }
      });
    };

    if (uploadedCount > 0) {
      const request = { file_id: this.props.match.params.id, doc_count, balance_min: updatedtime };
      const isQueryRaisedFile = this.state.info.file_status == "7";
      callApi("POST", "file_time.php", request)
        .then((res) => res.data)
        .then((response) => {
          if (response.status == "200") {
            const reloadAfterStatusLog = () => {
              if (this.countdownTimerRef) {
                this.countdownTimerRef.clearInterval();
              }
              localStorage.removeItem("updatedRemainingTime");
              window.location.reload();
            };
            if (isQueryRaisedFile) {
              this.timeUpdate(this.props.match.params.id, "query receive").finally(reloadAfterStatusLog);
              return;
            }
            reloadAfterStatusLog();
            return;
          }
          finalize();
        })
        .catch(() => finalize());
    } else {
      finalize(() => window.location.reload());
    }
  };

  handleMoveToProcessFromFooter = async () => {
    if (!this.canShowMoveToProcessButton()) {
      return;
    }

    const baseDocs = this.state.base || [];
    const trayItems = this.state.queryTrayItems || [];
    const hasUploadableDocs = this.hasUploadableBaseDocs(baseDocs);
    const hasTrayItems = trayItems.length > 0;
    const queryTableData = await this.getLatestQueryTableDataForValidation();
    const unhandledPendingQueries = this.getUnhandledPendingUploadQueries(trayItems, queryTableData);

    if (unhandledPendingQueries.length > 0) {
      showFitContentError(
        "Please upload a document, add a hint, or save to tray for all pending queries before moving to process."
      );
      return;
    }

    const activePendingQueries = this.getActivePendingUploadQueries(trayItems, queryTableData);
    const pendingAddressedByHintOnly =
      activePendingQueries.length > 0 &&
      activePendingQueries.every((query: any, index: number) => this.hasQueryHintForUpload(query, index, trayItems));

    if (!hasUploadableDocs && !hasTrayItems && !pendingAddressedByHintOnly) {
      showFitContentError("Upload documents or save queries to tray before moving to process.");
      return;
    }

    if (hasUploadableDocs && !this.validateDocuments()) {
      ToastsStore.error("Please fill in all fields for this document");
      return;
    }

    this.setState({ uploadbtn: true });

    const uploadPromise = hasUploadableDocs
      ? this.uploadDocumentsToProcess()
      : Promise.resolve({ success: true, uploadedCount: 0 });

    uploadPromise.then((uploadResult) => {
      if (!uploadResult?.success) {
        this.setState({ uploadbtn: false });
        return;
      }

      if (!hasTrayItems) {
        this.finishAfterSuccessfulProcessMove(uploadResult.uploadedCount || 0, false);
        return;
      }

      const isQueryRaisedFile = this.state.info.file_status == "7";
      const applyTrayStatus = isQueryRaisedFile || !(uploadResult.uploadedCount > 0);

      this.moveQueryTrayToProcess(applyTrayStatus).then((trayResult) => {
        if (!trayResult?.result) {
          this.setState({ uploadbtn: false });
          if (uploadResult.uploadedCount) {
            showFitContentWarning("Documents uploaded, but query tray could not be moved to process.");
          }
          return;
        }
        this.finishAfterSuccessfulProcessMove(uploadResult.uploadedCount || 0, !uploadResult.uploadedCount);
      });
    });
  };

  validateDocuments = () => {
    let base: any = this.state.base;
    let isValid = true;
    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      const hasFile = Boolean(document?.base_url || document?.base);
      if (!hasFile) {
        base[i].isValid = true;
        continue;
      }
      const docValid = this.isDocumentReadyForUpload(document);
      isValid = isValid && docValid;
      base[i].isValid = docValid;
    }
    return isValid;
  };
  timeUpdate = (fileid, type) => {
    const loginuser: any = localStorage.getItem("user1");
    let req: any = {};
    if (type == "query receive") { req = { query_received_by: JSON.parse(loginuser), id: fileid, reason: "Query Received", created_by: JSON.parse(loginuser), color: "#edada0" }; }
    else if (type == "query raise") { req = { query_raised_by: JSON.parse(loginuser), id: fileid, reason: "Query Raised", created_by: JSON.parse(loginuser), color: "#afa5bd" }; }
    else if (type == "before query raise") { req = { id: fileid, reason: "Scan File Upload", created_by: JSON.parse(loginuser), reason_status: 1 }; }
    return callApi("POST", "time_update.php", req)
      .then((res) => res.data)
      .catch(() => null);
  };
  handleChangeCategory = (e, propName?, fieldType?) => {
    let fieldName = fieldType === "singleselect" ? propName : e.target.name;
    let fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
    if (fieldName === "category") { this.setState({ type: fieldValue }); }
    if (fieldName === "particular") { this.setState({ [fieldName]: fieldValue }); }
  };
  selectUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_users;
    if (e.target.checked) { remote_users.push({ email: user.email, name: user.name }); }
    else { remote_users = remote_users.filter((itm) => itm.email !== user.email); }
    this.setState({ remote_users });
  };
  selectCcUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_cc_users;
    if (e.target.checked) { remote_users.push({ email: user.email, name: user.name }); }
    else { remote_users = remote_users.filter((itm) => itm.email !== user.email); }
    this.setState({ remote_cc_users: remote_users });
  };
  addItem = (): void => { };
  handleFiles = (files: any) => {
    let baseFile: any = this.state.queryBase || [];
    const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
    if (Number(fileSize) > 26214400) { ToastsStore.error("File(s) size shouldn't exceed 25 MB"); }
    else {
      files.base64.map((file: any, index: number) => {
        baseFile.push({ file, fileType: files.fileList[index].type, fileName: files.fileList[index].name });
      });
      this.setState({ queryBase: [...baseFile] });
    }
  };
  deleteDoc = (modal, index) => {
    const baseFile: never[] = cloneDeep(this.state.queryBase);
    baseFile.splice(index, 1);
    this.setState({ queryBase: [...baseFile] });
  };
  previewDoc = (file) => { this.setState({ previewDoc: file }); };
  setSelectedItem = (item: any) => {
    const itemList = Array.isArray(item) ? [...item] : [item];
    this.setState((prevState: any) => {
      const prev = Array.isArray(prevState.multiSelectedQuery) ? prevState.multiSelectedQuery : [];
      const next = [...prev];
      for (let i = 0; i < itemList.length; i++) {
        const it = itemList[i];
        const qid = it?.query_id;
        const idx = next.findIndex((val: any) => val.query_id === qid);
        if (idx >= 0) next.splice(idx, 1);
        else next.push(it);
      }
      return { multiSelectedQuery: next };
    });
  };
  repliedQueries = (queries: any) => {
    this.setState({ repliedQueries: queries, queryPayload: { requery: [], resend: [] } }, () => this.formatData(queries));
  };
  getDeviationQueryData = (queryid, isChecked, data) => {
    const deviationStatus = data?.details?.deviation_status;
    if (isChecked && ["0", "2", "3"].includes(deviationStatus)) {
      this.setState((prevState: any) => ({ deviationTakenQuerys: [...prevState.deviationTakenQuerys, queryid] }));
    } else {
      this.setState((prevState: any) => ({ deviationTakenQuerys: prevState.deviationTakenQuerys.filter((id: any) => id !== queryid) }));
    }
  };
  submitRequeryDeviation = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (!isEmpty(this.state.deviationReason)) {
      let req = { file_id: this.props.match.params.id, query_ids: this.state.deviationTakenQuerys, reason: this.state.deviationReason, user_id: userId };
      callApi("POST", "deviation_request.php", req)
        .then((res) => res.data)
        .then((response) => {
          if (response.statusCode == 200) {
            this.deviationFileLog(this.props.match.params.id);
            this.getQueryTable();
            $("#deviationModal").modal("hide");
            this.setState({ deviationTakenQuerys: [], deviationReason: "" });
          } else { ToastsStore.error(response.message); }
        });
    } else { ToastsStore.error("Please type reason to proceed"); }
  };
  closeDeviationModal = () => { this.setState({ deviationTakenQuerys: [], deviationReason: "" }); };
  handleDeviationReasonChange = (e) => { this.setState({ deviationReason: e.target.value }); };
  getNewQuery = (newquerys: any) => { this.setState({ newquery: newquerys }); };
  formatData = (queries) => {
    const queryData: any = this.state.queryPayload;
    queries.forEach((query) => {
      if (query.hasOwnProperty("replies") && query.replies && query.replies.length > 0) {
        queryData.requery.push(query);
        this.setState({ queryPayload: queryData }, () => { if (query.children.length > 0) { this.formatData(query.children); } });
      } else if (query.children.length > 0) { this.formatData(query.children); }
    });
  };
  saveQuery = (): void => {
    const { multiSelectedQuery, remote_users, queryBase, remote_cc_users, newQueryList, replyQueryList } = this.state;
    const queryData: any = this.state.queryPayload;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const process_office_id: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");
    let querydetail: any[] = (multiSelectedQuery || []).map(sanitizeMultiSelectedQueryItem);
    if (queryData?.requery) {
      queryData.requery.forEach((query) => {
        query.replies.forEach((reply) => {
          querydetail.push(buildRequeryDetailItem(reply, query.id));
        });
      });
    }
    querydetail.push(...this.state.newquery);
    // Include entries raised from ReplyQuery (Raise Query panel).
    querydetail.push(
      ...newQueryList.map((item: any) => ({
        ...item,
        query: item.query,
        review: item.review,
        other_review: item.other_review,
        location: item.location,
        filter_date: item.filter_date || item.created_date,
      }))
    );
    querydetail.push(
      ...replyQueryList.map((item: any) => ({
        ...item,
        query: item.query,
        review: item.review,
        other_review: item.other_review,
        location: item.location,
        filter_date: item.filter_date || item.created_date,
      }))
    );
    querydetail.sort((a, b) => moment(a.filter_date, "DD-MM-YYYY HH:mm:ss").toDate().getTime() - moment(b.filter_date, "DD-MM-YYYY HH:mm:ss").toDate().getTime());
    const payload: any = { querydetail, remote_users, remote_cc_users, user_idfk: userId, fod_fk: this.props.match.params.id, base: queryBase };
    this.setState({ queryLoading: true });
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    const mailToBank: any = localStorage.getItem("mail-bank");
    let apiPath;
    if (userDGrade === "D" || fileDGrade === "D") {
      apiPath = mailToBank === "true" ? "new_query_create.php" : "new_query_create_without_mail.php";
      this.deviationFileLog(this.props.match.params.id);
    } else { apiPath = "new_query_create.php"; }
    callApi("POST", apiPath, payload)
      .then((res) => res.data)
      .then((response) => {
        const blockedMessage = String(response?.message || "").toLowerCase();
        const isQueryBlocked = blockedMessage.includes("cannot raise a query");
        if (response.success == true && !isQueryBlocked) {
          localStorage.setItem("query_raised_status", JSON.stringify(true));
          if (process_office_id == userid1) { this.timeUpdate(this.props.match.params.id, "query raise"); }
          this.setState({ queryLoading: false, quesSubmitted: false });
          $("#send-mail").modal("hide");
          ToastsStore.success(response.message || "Queries added Successully");
          const filterBankLHBranch: any = this.state.bankWithLawhadnsBranch.find((bank: any) =>
            bank?.bank_id == this.state?.info?.org_bank_id &&
            bank?.product_id == this.state?.info?.bank_product &&
            bank?.lawhands_branch == this.state?.info?.lawhands_branch
          );
          const isAutoMail = filterBankLHBranch?.autoMail === '1';
          const preliminaryPDF = filterBankLHBranch?.preliminaryPDF === '1';
          if (isAutoMail && preliminaryPDF) {
            const payload = { file_id: this.props.match.params.id, generate_send_pdf: preliminaryPDF, file_status: "Re-Query Raise Auto Trigger", created_by: userId };
            this.setState({ reportSendPayload: payload }, () => { this.sendUploadPayload(); });
          }
          this.setState(
            {
              queryPayload: { requery: [], resend: [] },
              multiSelectedQuery: [],
              newquery: [],
              replyQueryList: [],
              isReplyRaiseQueryShown: false,
            },
            () => { this.query?.current?.updateQuery?.(); }
          );
          this.getOutTime();
        } else {
          this.setState({ queryLoading: false, quesSubmitted: true });
          ToastsStore.error(response.message || "Unable to raise query. Please try again.");
        }
      })
      .catch((err) => { this.setState({ queryLoading: false, quesSubmitted: true }); ToastsStore.error("Something went Wrong, Please try again!"); });
  };
  getOutTime = async () => {
    let date = new Date();
    localStorage.setItem("startTime", JSON.stringify(date.getTime()));
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) { localStorage.setItem("outtimeGet", JSON.stringify(date.getHours() + ":0" + Railway)); }
    else { localStorage.setItem("outtimeGet", JSON.stringify(date.getHours() + ":" + date.getMinutes())); }
    await this.processEod();
  };
  processEod = () => {
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    const outtime: any = localStorage.getItem("outtimeGet");
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), "seconds");
    let updatedRemainingTime: any = localStorage.getItem("updatedRemainingTime");
    let updatedtime = Math.round(updatedRemainingTime);
    const status: any = localStorage.getItem("dashboard_status");
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    let obj = {
      file_id: JSON.parse(fileid1), user_id: JSON.parse(userid1), in_reason: JSON.parse(inreason),
      out_reason: "Re Queries Raised", intime: JSON.parse(intime), outtime: JSON.parse(outtime),
      insert_date: JSON.parse(outdate), total_seconds: secondsSpent, balance_min: updatedtime,
      dashboard_status: status, insert_id: insertId,
    };
    callApi("POST", "process_eod_insert.php", obj)
      .then((res) => res.data)
      .then((response) => {
        localStorage.removeItem("updatedRemainingTime"); localStorage.removeItem("in_reason");
        localStorage.removeItem("outreason"); localStorage.removeItem("IntimeGet");
        localStorage.removeItem("OutDateGet"); $("#out_reason").modal("hide"); $("#another-reason").modal("hide");
        localStorage.removeItem("currentfileId"); localStorage.removeItem("query_raised_status"); localStorage.removeItem("file_completed_status");
        setTimeout(() => {
          const fileurl: any = localStorage.getItem("url");
          this.props.history.push(fileurl == "" ? "/inprogress-file" : fileurl);
        }, 500);
      })
      .catch((err) => { console.log(err); });
  };
  deviationFileLog = (fileid) => {
    const loginuser: any = localStorage.getItem("user1");
    callApi("POST", "time_update.php", { query_raised_by: JSON.parse(loginuser), id: fileid, reason: "Request for Deviation", created_by: JSON.parse(loginuser), color: "#e03bdda6" })
      .then((res) => res.data).then((response) => { });
  };
  handleAnswerChange = (index, val) => { const queryQues: any = this.state.queryQues; queryQues[index].answer = val; this.setState({ queryQues }); };
  saveQueryQuestion = () => {
    const { queryQues, oldQueryQues } = this.state;
    const user: any = localStorage.getItem("user");
    callApi("POST", "queryverification_checklist.php", { fileNo: this.props.match.params.fileid, currentData: queryQues, oldData: oldQueryQues, loginId: user ? JSON.parse(user)["userId"] : "" })
      .then((res) => res.data).then((response) => { this.setState({ quesSubmitted: true }); }).catch((err) => { });
  };
  getUpdateReasonData = () => {
    const reasonData: any = this.state.updateDownloadData;
    callApi("POST", "dashboard_log.php", { id: this.props.match.params.id, path: "dashboard" })
      .then((res) => res.data)
      .then((result) => { reasonData.reasonForDownload = result.data.reasonForDownload; reasonData.updatedDetails = result.data.updatedDetails; this.setState({ updateDownloadData: reasonData }); })
      .catch((err) => { });
  };
  getcheckListLogData = () => {
    callApi("POST", "checklist_log.php", { id: this.props.match.params.id, path: "dashboard" })
      .then((res) => res.data).then((result) => { this.setState({ checkListLog: result.data.checkListLog }); }).catch((err) => { });
  };
  getAutoMailTriggerLogData = () => {
    callApi("POST", "auto_mail_trigger_log.php", { id: this.props.match.params.id, path: "dashboard" })
      .then((res) => res.data).then((result) => { this.setState({ autoMailTriggerLog: result.data.logList }); }).catch((err) => { });
  };
  documentDownload = (listVal, type) => {
    if (type == "docx") { const name = `${this.state.LHBranchCode}-${this.props.match.params.id}.docx`; Array.isArray(listVal.url) && listVal.url[0].docx && saveAs(listVal.url[0].docx, name); }
    else { const name = `${this.state.LHBranchCode}-${this.props.match.params.id}.pdf`; Array.isArray(listVal.url) && listVal.url[0].pdf && saveAs(listVal.url[0].pdf, name); }
  };
  previewPDF = (url) => { this.setState({ pdfToPreview: url }); };
  renderDetailsCard = (type, listOfData) => {
    return listOfData && listOfData.map((listVal, listIndex) => (
      <div className="row" key={`${listIndex}-${listVal.title}`} style={{ background: listIndex === 0 && type === "UPDATE" ? "#cdffe0" : "#eff3f6", boxShadow: "0 0 0 1px #e2e5e8", borderRadius: "0.25rem", padding: "10px", paddingLeft: "12px", paddingRight: "12px", marginBottom: "15px" }}>
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontWeight: "bold", fontSize: "14px", color: "black", textTransform: "capitalize" }}>{listVal.title || ""}</p>
            {type === "UPDATE" ? (
              <div style={{ display: "flex", gap: "20px" }}>
                {this.state.pageDynamic.map((page: any, index: any) => {
                  if (page.page_name === "PDF Download" && page.status == true) return <FaRegFilePdf key={index} onClick={() => this.documentDownload(listVal, "pdf")} style={{ fontSize: "21px", color: "black", cursor: "pointer" }} />;
                  else if (page.page_name === "DOC Download" && page.status == true && listVal.file_upload_sign == 0) return <PiFileDocDuotone key={index} onClick={() => this.documentDownload(listVal, "docx")} style={{ fontSize: "24px", color: "black", cursor: "pointer" }} />;
                  else if (page.page_name === "PDF Preview" && page.status == true) return <FaEye key={index} data-toggle="modal" data-target="#preview-pdf" style={{ fontSize: "20px", color: "black", cursor: "pointer" }} onClick={() => this.previewPDF(Array.isArray(listVal.url) && listVal.url[0].pdf)} />;
                })}
              </div>
            ) : type === "CHECKLIST" ? (
              <div style={{ display: "flex", gap: "20px" }}>
                <FaRegFilePdf onClick={() => downloadChecklistPDF(listVal)} style={{ fontSize: "21px", color: "black", cursor: "pointer" }} />
                <PiMicrosoftExcelLogoDuotone onClick={() => downloadChecklistEXCEL(listVal)} style={{ fontSize: "24px", color: "black", cursor: "pointer" }} />
                <FaEye data-toggle="modal" data-target="#preview-checklist" style={{ fontSize: "20px", color: "black", cursor: "pointer" }} onClick={() => this.setState({ selectedChecklistItem: listVal })} />
              </div>
            ) : null}
          </div>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              <p style={{ margin: "0px", color: "grey", fontSize: "13px" }}>{moment(listVal.date).format("DD-MM-YYYY hh:mm a")}</p>
              {listVal.officerType && <p style={{ margin: "0px", color: "black", fontSize: "13px", fontWeight: "bold", marginLeft: "10px", marginRight: "10px", textTransform: "capitalize" }}>{listVal.officerType}</p>}
              {listVal.downloadedBy && <p style={{ margin: "0px", fontSize: "13px", color: "grey" }}>{type === "DOWNLOAD" ? "Downloaded By " : "Updated By "} <span style={{ color: "black", fontWeight: "bold" }}>{listVal.downloadedBy || ""}</span></p>}
            </div>
          </div>
        </div>
      </div>
    ));
  };
  renderAutoMailTriggerLogCard = (type, listOfData) => {
    return listOfData && listOfData.map((listVal, listIndex) => (
      <div className="row" key={`${listIndex}-${listVal.title}`} style={{ background: "#eff3f6", boxShadow: "0 0 0 1px #e2e5e8", borderRadius: "0.25rem", padding: "10px", paddingLeft: "12px", paddingRight: "12px", marginBottom: "15px" }}>
        <div style={{ width: "100%" }}>
          <p style={{ fontWeight: "bold", fontSize: "14px", color: "black", textTransform: "capitalize" }}>{listVal.title || ""}</p>
          <p style={{ margin: "0px", color: "grey", fontSize: "13px" }}>{moment(listVal.date).format("DD-MM-YYYY hh:mm a")}</p>
        </div>
      </div>
    ));
  };
  uploadFile = (file: any) => { this.setState({ uploadFile: file }); };
  actionHandle = (action) => { this.setState({ action }); };
  onchange = (e: any) => { this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(), selectVal: false }); };
  validateReason = () => {
    if (this.state.reason === "") { ToastsStore.error("Please Enter Reason"); }
    else { if (this.state.action === "upload") { $("#reason-modal1").modal("hide"); this.uploadDoc(); } }
  };
  uploadDoc = () => {
    $("#reason-modal1").modal("hide");
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = { fileId: this.props.match.params.id, reason: this.state.reason, createdBy: userId, file: this.state.uploadFile.base64.split(",")[1], errorTypes: ["1", "2"], errorSection: ["1", "2"] };
    callApi("POST", "template/tests/upload_log.php", obj)
      .then((res) => res)
      .then((response) => {
        localStorage.removeItem("overviewDocument");
        if (response.status === 200) { this.setState({ isrectificationComplete: false }); ToastsStore.success("Reason saved successfully"); this.clearModal(); this.getUpdateReasonData(); }
        else { this.setState({ isrectificationComplete: true }); ToastsStore.error("Error in storing, Please try again!"); }
      })
      .catch((err) => { console.log(err); });
  };
  clearModal = () => { this.setState({ reason: "" }); };
  editOption = (field: string) => {
    if (field == "propertyAddress") { $(".propertyAddressediticon").hide(); $(".propertyAddressShow").hide(); $(".propertyAddressEdit").show(); $(document).ready(function () { $("#propertyAddress").focus(); }); }
    else { $(".editicon").hide(); $(".appidShow").hide(); $(".appidEdit").show(); $(document).ready(function () { $("#appid").focus(); }); }
  };
  deleteDocumentDetails = (index) => {
    const baseArray = cloneDeep(this.state.base) as any[];
    baseArray.splice(index, 1);
    this.setState({ base: baseArray });
  };
  handleDocumentDetailsChange = (value, index, key) => {
    const invalidDocuments = ["26", "27", "36", "35", "38", "103", "78", "5", "Online Encumbrance Certificate"];
    if (key == "docNoYear") {
      if (!/^[0-9/-]*$/.test(value)) { console.error("Invalid input."); return; }
      let baseArray = cloneDeep(this.state.base);
      (baseArray as any)[index] = { ...(baseArray as any)[index], [key]: value };
      this.setState({ base: baseArray });
    } else {
      let baseArray = cloneDeep(this.state.base);
      if (key == "doc_type" && invalidDocuments.includes(value)) { (baseArray as any)[index] = { ...(baseArray as any)[index], docNoYear: "" }; }
      (baseArray as any)[index] = { ...(baseArray as any)[index], [key]: value };
      this.setState({ base: baseArray });
    }
  };
  handleDocumentFilesChange1 = async (value, index, parentDetails) => {
    const { isGlobalPdfCompress } = this.state;
    this.setState({ isbtnload: true });
    try {
      const fileObj = value.fileList[0];
      let base64 = fileObj.base64 || value.base64;
      if (!fileObj?.type?.includes("pdf")) { return this.uploadAndSync(value, base64, index, parentDetails, null); }
      if (!isGlobalPdfCompress || parentDetails.isPdfCompress != 'on' || fileObj.alreadyCompressed) { return this.uploadAndSync(value, base64, index, parentDetails, null); }
      const { deeds, globalPdfCompressQuality, isSroEcPdfCompressQuality, isOnlineEcPdfCompressQuality }: any = this.state;
      let quality = parentDetails.doc_type === 'SRO Encumbrance Certificate' ? isSroEcPdfCompressQuality || globalPdfCompressQuality
        : parentDetails.doc_type === 'Online Encumbrance Certificate' ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
          : deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality || globalPdfCompressQuality;
      const compressResponse = await compressPdf({ base64, quality });
      fileObj.alreadyCompressed = true;
      const compressedBase64 = compressResponse?.compressedBase64 || base64;
      return this.uploadAndSync(
        { ...value, base64: compressedBase64, fileList: value.fileList },
        compressedBase64,
        index,
        parentDetails,
        compressResponse
      );
    } catch (err) {
      console.error("Error in handleDocumentFilesChange1:", err);
      ToastsStore.error("File processing failed");
      this.setState({ isbtnload: false });
    }
  };
  uploadAndSync = (files, base64, index, parentDetails, compressResponse) => {
    const baseArray = cloneDeep(this.state.base);
    const fileObj = files.fileList[0];
    (baseArray as any)[index] = { ...(baseArray as any)[index], base: fileObj.name, base_url: base64, originalSize: compressResponse?.originalSize || '', compressedSize: compressResponse?.compressedSize || '' };
    this.setState({ base: baseArray, isbtnload: false });
  };
  resolveUploadModalQueryReceivedAt = (query: any) => {
    const fromTree = query?.query_received_date || query?.received_date || "";
    if (fromTree) return fromTree;
    const qid = String(query?.id || "");
    if (!qid) return "";
    const docs = (this.state as any).queryReceivedDocMap?.[qid];
    if (Array.isArray(docs) && docs.length) {
      const latest = [...docs].sort(
        (a: any, b: any) => moment(b?.created_date).valueOf() - moment(a?.created_date).valueOf()
      )[0];
      if (latest?.created_date) return latest.created_date;
    }
    const hintDates = (this.state as any).queryHintDateMap?.[qid];
    if (Array.isArray(hintDates) && hintDates.length) {
      const sorted = [...hintDates].sort(
        (a: string, b: string) =>
          moment(b, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "DD-MM-YYYY HH:mm:ss.SSS", moment.ISO_8601], true).valueOf() -
          moment(a, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "DD-MM-YYYY HH:mm:ss.SSS", moment.ISO_8601], true).valueOf()
      );
      return sorted[0] || "";
    }
    return "";
  };

  addUploadDocument = (selectedQuery?: any) => {
    let baseArray = cloneDeep(this.state.base);
    const queryRaisedAt = selectedQuery?.created_date || "";
    const queryReceivedAt = selectedQuery ? this.resolveUploadModalQueryReceivedAt(selectedQuery) : "";
    const queryId = selectedQuery
      ? String(selectedQuery?.id || selectedQuery?.query_id || selectedQuery?.queryId || "").trim()
      : "";
    (baseArray as any[]).push({
      ...this.documentFormat,
      query_id: queryId,
      query_label: selectedQuery?.title || "",
      query_raised_at: queryRaisedAt,
      query_received_at: queryReceivedAt,
    });
    this.setState({ base: baseArray });
  };

  addUploadDocumentForTray = (trayQuery: any) => {
    const trayId = String(trayQuery?.id || "");
    if (!trayId) return;
    let baseArray = cloneDeep(this.state.base);
    (baseArray as any[]).push({
      ...this.documentFormat,
      query_id: trayId,
      tray_query_id: trayId,
      query_label: trayQuery?.title || "",
      query_raised_at: trayQuery?.created_date || "",
      query_received_at: "",
    });
    this.setState({
      base: baseArray,
      uploadTrayExpandedId: trayId,
    });
  };

  getUploadCategoryLabel = (categoryId: any) => {
    const categoriesList = (this.state.categoriesList || []) as any[];
    const category = categoriesList.find((item) => String(item?.id) === String(categoryId));
    return category?.name || categoryId || "Title Deed";
  };

  getUploadDocumentTypeLabel = (docType: any) => {
    if (!docType) return "";
    const deeds = (this.state.deeds || []) as any[];
    const deed = deeds.find((item) => String(item?.id) === String(docType));
    return deed?.name || docType;
  };

  isDocumentReadyForUpload = (document: any) => {
    if (!document) return false;
    const hasFile = Boolean(document.base_url || document.base || document.doc_name);
    if (!hasFile) return false;

    const invalidDocuments = ["26", "27", "36", "35", "38", "103", "78", "5", "Online Encumbrance Certificate"];
    const docType = String(document.doc_type ?? "").trim();
    const categoryType = String(document.type ?? "").trim();
    const particular = String(document.particular ?? "").trim();

    if (invalidDocuments.includes(docType)) {
      return Boolean(docType && categoryType);
    }
    if (["deed", "mother_doc", "title_deed", "ec_doc"].includes(categoryType)) {
      return Boolean(document.docNoYear && docType && categoryType && particular);
    }
    if (["rev_rec_doc", "sale_agreement"].includes(categoryType)) {
      return Boolean(docType && categoryType && particular);
    }
    return false;
  };

  isTrayStagedDocumentReady = (stagedDoc: any) => this.isDocumentReadyForUpload(stagedDoc);

  getQueryIdsForUploadQuery = (query: any, queryTableData: any[] = this.state.queryTableData || []) => {
    const ids = new Set<string>();
    const queryId = String(query?.id || query?.query_id || query?.queryId || "").trim();
    if (queryId) ids.add(queryId);
    const matchKey = this.getUploadQueryMatchKey(query);
    (queryTableData || []).forEach((row: any) => {
      const rowId = String(row?.id || row?.query_id || row?.queryId || "").trim();
      if (rowId && this.getUploadQueryMatchKey(row) === matchKey) {
        ids.add(rowId);
      }
    });
    return Array.from(ids);
  };

  doesBaseDocBelongToQuery = (doc: any, query: any, index: number) => {
    const docQueryId = String(doc?.query_id || "").trim();
    const queryRowId = this.getUploadQueryRowId(query, index);
    const queryId = String(query?.id || queryRowId);
    if (docQueryId && (docQueryId === queryId || docQueryId === queryRowId)) return true;
    if (docQueryId && this.getQueryIdsForUploadQuery(query).includes(docQueryId)) return true;
    const docLabel = String(doc?.query_label || "").trim().toLowerCase();
    const queryTitle = String(query?.title || "").trim().toLowerCase();
    return Boolean(docLabel && queryTitle && docLabel === queryTitle);
  };

  getTrayStagedUploadEntry = () => {
    const base = (this.state.base || []) as any[];
    const selectedTrayIds = this.state.uploadTraySelectedIds || [];

    if (selectedTrayIds.length === 1) {
      const trayId = String(selectedTrayIds[0]);
      const baseIndex = base.findIndex(
        (doc) => String(doc?.tray_query_id || doc?.query_id || "") === trayId
      );
      if (baseIndex >= 0) {
        return { trayId, baseIndex, stagedDoc: base[baseIndex] };
      }
    }

    const expandedId = String(this.state.uploadTrayExpandedId || "");
    if (expandedId) {
      const baseIndex = base.findIndex(
        (doc) => String(doc?.tray_query_id || doc?.query_id || "") === expandedId
      );
      if (baseIndex >= 0) {
        return { trayId: expandedId, baseIndex, stagedDoc: base[baseIndex] };
      }
    }

    const baseIndex = base.findIndex((doc) => String(doc?.tray_query_id || "").trim());
    if (baseIndex >= 0) {
      const trayId = String(base[baseIndex]?.tray_query_id || base[baseIndex]?.query_id || "");
      return { trayId, baseIndex, stagedDoc: base[baseIndex] };
    }

    return null;
  };

  canSaveTrayDocumentFromHeader = () => {
    const entry = this.getTrayStagedUploadEntry();
    return entry ? this.isTrayStagedDocumentReady(entry.stagedDoc) : false;
  };

  handleSaveTrayDocumentFromHeader = () => {
    const entry = this.getTrayStagedUploadEntry();
    if (!entry) {
      ToastsStore.warning("Use Upload on a tray query and fill the document details first.");
      return;
    }
    this.saveDocumentToQueryTray(entry.trayId, entry.baseIndex);
  };

  saveDocumentToQueryTray = (trayRowId: string, baseIndex: number) => {
    const stagedDoc: any = (this.state.base || [])[baseIndex];
    if (!stagedDoc) {
      ToastsStore.warning("No document found to save.");
      return;
    }
    if (!this.isTrayStagedDocumentReady(stagedDoc)) {
      ToastsStore.warning("Please complete category, document type, particulars, and upload the file before saving.");
      return;
    }

    const trayItem = this.buildTraySaveItemFromTrayRow(trayRowId, stagedDoc);
    if (!trayItem || !trayItem.query_id) {
      ToastsStore.warning("Unable to resolve query tray item.");
      return;
    }

    const stagedDocRef = stagedDoc;
    this.persistQueryTraySave([trayItem], [
      (doc: any) => doc === stagedDocRef || (
        String(doc?.tray_query_id || doc?.query_id || "") === String(trayRowId) &&
        String(doc?.base || "") === String(stagedDocRef?.base || "")
      ),
    ]).then((response) => {
      if (response?.result) {
        ToastsStore.success("Document saved to query tray.");
        this.checkAndShowTrayPendingMailModal(response.data || []);
      }
    });
  };
  validateRequiredFileds = (e) => { this.handleMoveToProcessFromFooter(); };
  closeuploadfile = () => {
    if (this.state.trayPendingMailBlockActive) {
      ToastsStore.warning("Please send mail for pending queries before closing.");
      return;
    }
    this.setState({ base: [] });
  };
  deleteFile = (index) => {
    const baseArray = cloneDeep(this.state.base);
    (baseArray as any)[index] = { ...(baseArray as any)[index], details: {}, base: "" };
    this.setState({ base: baseArray });
  };
  validateQuery = (payload) => {
    let base = payload.querydetail;
    const mailToBank: any = localStorage.getItem("mail-bank");
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    let isValid;
    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      if (document && document.review == "other") {
        if (!document.query || !document.review || !document.other_review) { isValid = false; base[i].isValid = false; }
        else { isValid = true; base[i].isValid = true; }
      } else if (document && document.review != "other") {
        if (!document.query || !document.review) { isValid = false; base[i].isValid = false; }
        else { isValid = true; base[i].isValid = true; }
      }
    }
    if (isValid) {
      if (userDGrade === "D" || fileDGrade === "D") {
        if (mailToBank === "true") { $("#send-mail").modal("show"); } else { this.saveQuery(); }
      } else { $("#send-mail").modal("show"); }
    } else { ToastsStore.error("Please fill all the required fields"); }
  };
  checkRestriction = async () => {
    const response = await callApi("POST", "check_restriction.php", { id: this.props.match.params.id, file_status: 6, flag: "re_query" }).then((res) => res.data);
    if (response.response_Code === 201) { $("#file_not_complete_modal").modal("show"); this.setState({ fileNotCompleteMsg: { __html: response.message } }); return true; }
    return false;
  };
  hasUncheckedPendingWithoutRequery = (queryRows?: any[]) => {
    const sourceRows = Array.isArray(queryRows) ? queryRows : (this.state.queryTableData || []);
    const pendingRows = sourceRows.filter((query: any) => {
      const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
      return !this.isCompletedQueryStatus(status) && !this.isQueryReceivedQueryStatus(status);
    });
    if (!pendingRows.length) {
      return false;
    }

    const checkedIds = new Set(
      (this.state.multiSelectedQuery || [])
        .map((item: any) => String(item?.query_id || ""))
        .filter((id: string) => Boolean(id))
    );
    const requeryIds = new Set<string>();

    (this.state.newQueryList || []).forEach((item: any) => {
      if (item?.query_id) {
        requeryIds.add(String(item.query_id));
      }
    });

    const queryData: any = this.state.queryPayload || {};
    (queryData?.requery || []).forEach((query: any) => {
      const hasReplies = Array.isArray(query?.replies) && query.replies.length > 0;
      const queryId = query?.id || query?.query_id;
      if (hasReplies && queryId) {
        requeryIds.add(String(queryId));
      }
    });

    return pendingRows.some((query: any) => {
      const queryId = String(query?.id || "");
      return Boolean(queryId) && !checkedIds.has(queryId) && !requeryIds.has(queryId);
    });
  };
  updateNewQueryList = async () => {
    const checkRestrict = await this.checkRestriction();
    if (checkRestrict) return;
    const latestQueryTableData = await this.getLatestQueryTableDataForValidation();
    if (this.hasUncheckedPendingWithoutRequery(latestQueryTableData)) {
      ToastsStore.error("Please check or re-query all pending queries before submit");
      return;
    }
    const { multiSelectedQuery, remote_users, queryBase, remote_cc_users, newQueryList, replyQueryList } = this.state;
    const queryData: any = this.state.queryPayload;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const payload: any = {
      querydetail: [
        ...(multiSelectedQuery || []).map(sanitizeMultiSelectedQueryItem),
        ...this.state.newquery,
        ...newQueryList.map((item: any) => ({
          ...item,
          query: item.query,
          review: item.review,
          other_review: item.other_review,
          location: item.location,
          filter_date: item.filter_date || item.created_date,
        })),
        ...replyQueryList.map((item: any) => ({
          ...item,
          query: item.query,
          review: item.review,
          other_review: item.other_review,
          location: item.location,
          filter_date: item.filter_date || item.created_date,
        })),
      ],
      remote_users,
      remote_cc_users,
      user_idfk: userId,
      fod_fk: this.props.match.params.id,
      base: queryBase
    };
    queryData.requery.forEach((query) => {
      query.replies.forEach((reply) => {
        payload.querydetail.push(buildRequeryDetailItem(reply, query.id));
      });
    });
    if (payload && payload.querydetail.length > 0) { this.validateQuery(payload); } else { $("#send-mail").modal("show"); }
    this.getQueryQuestion(); this.getUsers();
  };
  AppidSave = (field: string) => {
    const obj = { fileid: this.props.match.params.id, appid: this.state.info.app_id, propertyAddress: this.state.info.propertyAddress };
    const api = field === "appId" ? "appid_ubdate.php" : "property_address_update.php";
    callApi("POST", api, obj)
      .then((res) => res)
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem("overviewDocument");
          if (field === "appId") { ToastsStore.success("App Id Updated successfully"); $(".appidShow").show(); $(".appidEdit").hide(); $(".editicon").show(); }
          else { ToastsStore.success("Updated successfully"); $(".propertyAddressShow").show(); $(".propertyAddressEdit").hide(); $(".propertyAddressediticon").show(); }
          this.clearModal();
        } else { ToastsStore.error("Error in storing, Please try again!"); }
      })
      .catch((err) => { console.log(err); });
  };
  handleReasonChange = (e) => { this.setState({ reason: e.target.value }); };
  updatedRemainingTime(time) { this.setState({ updatedRemainingTime: time }); }
  overviewtime(type) {
    const loginuser: any = localStorage.getItem("user1");
    var now = new Date();
    const hours = now.getHours(); const minutes = now.getMinutes(); const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(now.toLocaleDateString()).format("YYYY-MM-DD");
    let obj: any = {};
    if (type == "Typing Completed") { obj = { id: this.props.match.params.id, typingcompleted_time: currenttime, typingcompleted_date: currentdate, typingcompleted_by: JSON.parse(loginuser), reason: "Typing Completed", created_by: JSON.parse(loginuser), color: "#edada0" }; }
    else if (type == "Verification") { obj = { id: this.props.match.params.id, reason: "Verification Completed", created_by: JSON.parse(loginuser), color: "#faad4c" }; }
    else { obj = { id: this.props.match.params.id, reason: "Rectification Completed", created_by: JSON.parse(loginuser), color: "rgb(128 222 251)" }; }
    callApi("POST", "time_update.php", obj).then((res) => res.data).then((response) => { });
  }
  completeFlowHandler = (status, type) => {
    this.setState({ showTitle: true });
    if (type == "typing") { this.overviewtime("Typing Completed"); }
    else if (type == "verification") { this.overviewtime("Verification"); }
    else { this.overviewtime("Rectification"); }
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "file_status.php", { id: this.props.match.params.id, file_status: status })
      .then((res) => res)
      .then((response) => {
        this.setState({ showTitle: false });
        if (response.status === 200) {
          $("#confirm-complete").modal("hide"); $("#processComplete").modal("show"); this.setState({ isrectificationComplete: true });
          const user2: any = localStorage.getItem("user");
          const userId2 = user2 ? JSON.parse(user2)["userId"] : "";
          const userName2 = user2 ? JSON.parse(user2)["firstName"] : "";
          const notifyData = { title: `${this.props.match.params.id}Typing Completed By ${userName2}`, notifyType: "message", updatedAt: moment().format("YYYY-MM-DD HH:mm:ss") };
          pushnotificationApi(notifyData, userId2);
          ["branch_manager", "Query_officer", "scan_officer", "process_manager"].forEach((key) => {
            const stored: any = localStorage.getItem(key);
            const parsed = stored ? JSON.parse(stored) : [];
            if (Array.isArray(parsed) && parsed.length > 0) {
              notifyToUser("user", { ...notifyData, notifyType: key === "Query_officer" ? "notify" : "message" }, parsed);
              callApi("POST", "pushnotification.php", { notification_type: "typingcomplete", user_id: parsed.join(","), ...notifyData, reason: `${this.props.match.params.id}Typing Completed` }).catch(() => { });
            }
          });
        } else { ToastsStore.error("Error in completing the file , Please try again!"); }
      })
      .catch((err) => { console.log(err); });
  };
  close = () => { const path = localStorage.getItem("url"); $("#processComplete").modal("hide"); localStorage.removeItem("currentfileId"); setTimeout(() => { this.props.history.push(path); }, 2000); };
  confirmComplete(status, type) { this.setState({ iscomplete: true }, () => { if (this.state.iscomplete == true) { this.completeFlowHandler(status, type); } }); }
  processComplete(val) {
    if (val == "process") { this.setState({ isprocesscomplete: true }); }
    else if (val == "verify") { this.setState({ isverifycomplete: true }); }
    else if (val == "rectify") {
      if (this.state.isrectificationComplete == false) { this.setState({ isrectifycomplete: true }); $("#confirm-complete").modal("show"); }
      else { $("#complete-process").modal("show"); }
    }
  }
  getHold = () => {
    callApi("POST", "hold_file_get.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { if (response) { this.setState({ holdDetails: response.data }); $("#view-reasson").modal("show"); } })
      .catch((err) => { console.log(err); });
  };
  noRaiseQuery = () => {
    callApi("POST", "noraise_query.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => { if (response.statuscode == 200) { ToastsStore.success(response.message); } else { ToastsStore.error(response.message); } $("#no-query").modal("hide"); })
      .catch((err) => { console.log(err); });
  };
  addQueryList = () => {
    const { newQueryList } = this.state;
    newQueryList.push({ query: "", location: "", review: "", is_checked: false, other_review: "", created_date: moment().format("DD-MM-YYYY HH:mm:ss") });
    this.setState({ newQueryList, isRaiseQueryShown: true });
  };
  removeReply = (index) => { const { newQueryList } = this.state; this.setState({ newQueryList: [...newQueryList.slice(0, index), ...newQueryList.slice(index + 1)] }); };
  handleChangequery = (e: any, index: number) => { const { newQueryList } = this.state; newQueryList[index][e.target.name] = e.target.value; this.setState({ newQueryList }); };
  handleDetailsChange = (value: string, key: string, index: number) => { const { newQueryList } = this.state; newQueryList[index][key] = value; this.setState({ newQueryList }); };
  addReplyQueryList = () => {
    const { replyQueryList } = this.state;
    replyQueryList.push({ query: "", location: "", review: "", is_checked: false, other_review: "", created_date: moment().format("DD-MM-YYYY HH:mm:ss") });
    this.setState({ replyQueryList, isReplyRaiseQueryShown: true });
  };
  removeReplyQuery = (index) => { const { replyQueryList } = this.state; this.setState({ replyQueryList: [...replyQueryList.slice(0, index), ...replyQueryList.slice(index + 1)] }); };
  handleReplyQueryChange = (e: any, index: number) => { const { replyQueryList } = this.state; replyQueryList[index][e.target.name] = e.target.value; this.setState({ replyQueryList }); };
  handleReplyDetailsChange = (value: string, key: string, index: number) => { const { replyQueryList } = this.state; replyQueryList[index][key] = value; this.setState({ replyQueryList }); };
  newaddrequery = (data: any) => {
    const { reQueryList, newQueryList } = this.state;
    const parentQueryId = parentIdForRaise(data);
    const newReQueryItem = {
      query: "",
      location: "",
      review: "",
      query_id: parentQueryId,
      other_review: "",
      created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
    };
    this.setState({ reQueryList: [...reQueryList, newReQueryItem], newQueryList: [...newQueryList, newReQueryItem], isRaiseQueryShown: true });
  };
  addrequery = (event: any, data: any, index) => {
    const isChecked = event.target.checked;
    const { reQueryList, newQueryList } = this.state;
    if (isChecked) {
      const newReQueryItem = { query: data.title, location: data.location, review: data.reason, query_id: parentIdForRaise(data), created_date: moment().format("DD-MM-YYYY HH:mm:ss"), is_checked: isChecked };
      this.setState({ reQueryList: [...reQueryList, newReQueryItem], newQueryList: [...newQueryList, newReQueryItem], isRaiseQueryShown: true });
    } else { this.setState({ newQueryList: [...newQueryList.slice(0, index), ...newQueryList.slice(index + 1)] }); }
  };
  CompleteConfirm = (data) => { this.setState({ showPopup: true, selectedQueryname: data.name, selectedQuerytitle: data.title, selectedQueryid: data.id }); };
  Completequery = () => {
    const { selectedQueryid } = this.state;
    const user = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "query_close.php", { id: selectedQueryid, status: 3, userId })
      .then((res) => res.data)
      .then((response) => { this.getQueryTable(); this.setState({ showPopup: false }); })
      .catch((err) => { this.getQueryTable(); this.setState({ showPopup: false }); });
  };
  getDeviationDropdownLists = () => {
    ["deviationSummary", "trainingToWhom", "trainingArea"].forEach((cat) => {
      callApi("POST", "deviation_take_get.php", { category_type: cat })
        .then((res) => res.data)
        .then((response) => {
          if (response?.data) {
            const formattedData = [...response.data.map((item) => ({ label: item.category_value, value: item.id })), { label: "Other", value: "other" }];
            if (cat === "deviationSummary") { this.setState({ deviationSummaryList: formattedData }); }
            else if (cat === "trainingToWhom") { this.setState({ deviationTrainingToWhomList: formattedData }); }
            else if (cat === "trainingArea") { this.setState({ deviationTrainingAreaList: formattedData }); }
          }
        })
        .catch((err) => console.error(err));
    });
  };
  handleDeviationChange = (value, key, type = "text") => {
    this.setState((prevState: any) => {
      const deviationSummaryDetails = { ...prevState.deviationSummaryDetails };
      const showOtherFields = { ...deviationSummaryDetails.showOtherFields };
      if (type === "singleselect") {
        if (value === "other") { showOtherFields[key] = true; deviationSummaryDetails[key] = ""; }
        else { showOtherFields[key] = false; deviationSummaryDetails[key] = value; }
      } else if (type === "multiselect") {
        const selectedValues = value.map((v) => v.value);
        if (selectedValues.includes("other")) { showOtherFields[key] = true; deviationSummaryDetails[key] = ""; }
        else { showOtherFields[key] = false; deviationSummaryDetails[key] = selectedValues; }
      } else { deviationSummaryDetails[key] = value; }
      deviationSummaryDetails.showOtherFields = showOtherFields;
      return { deviationSummaryDetails };
    });
  };
  renderSelectOrInput(label, key, options, type = "singleselect", required = true) {
    const { deviationSummaryDetails } = this.state;
    const value = type === "multiselect"
      ? options.filter((o) => Array.isArray(deviationSummaryDetails[key]) ? deviationSummaryDetails[key].includes(o.value) : false)
      : options.find((o) => o.value === deviationSummaryDetails[key]) || null;
    return (
      <div className="form-group">
        <label>{label} {required && <span style={{ color: "red" }}>*</span>}</label>
        <Select
          options={options} isMulti={type === "multiselect"}
          className={deviationSummaryDetails?.deviationRequired && (deviationSummaryDetails[key] === "" || (Array.isArray(deviationSummaryDetails[key]) && deviationSummaryDetails[key].length === 0)) ? "form-select is-invalid" : "form-select"}
          value={value}
          onChange={(selected) => {
            if (type === "multiselect") { this.handleDeviationChange(selected || [], key, "multiselect"); }
            else { this.handleDeviationChange((selected as any)?.value || "", key, "singleselect"); }
          }}
        />
        {deviationSummaryDetails?.showOtherFields[key] && (
          <input className={deviationSummaryDetails?.deviationRequired && deviationSummaryDetails[key] === "" ? "form-control is-invalid" : "form-control"} placeholder={`Enter Other ${label}...`} value={deviationSummaryDetails[key] || ""} onChange={(e) => this.handleDeviationChange(e.target.value, key)} />
        )}
        <div className="invalid-feedback">*Required Field</div>
      </div>
    );
  }
  deviationSummarySubmit = () => {
    const { deviationTaken, deviationSummary, knowledgeAssessment, trainingNeeded, trainingToWhom, trainingArea, specialFileNeeded } = this.state.deviationSummaryDetails;
    if (isEmpty(deviationTaken) || isEmpty(deviationSummary) || knowledgeAssessment == '' || isEmpty(trainingNeeded) || isEmpty(trainingToWhom) || isEmpty(trainingArea) || isEmpty(specialFileNeeded)) {
      this.setState((prevState: any) => { const updatedDetails = { ...prevState.deviationSummaryDetails, deviationRequired: true }; return { deviationSummaryDetails: updatedDetails }; });
      ToastsStore.error("Required fields are missing."); return;
    }
    this.setState({ isDeviationSummaryLoading: true });
    callApi("POST", "deviation_summary_update.php", { ...this.state.deviationSummaryDetails, fileId: this.props.match.params.id })
      .then(res => res.data)
      .then(response => {
        if (response.success == true) { this.setState({ isDeviationSummaryLoading: false }); ToastsStore.success(response.message); $("#deviationSummary").modal("hide"); this.clearDeviationSummaryState(); this.getFileDashboard(); this.previousPage("back"); }
        else { ToastsStore.error(response.message); }
      }).catch(err => { console.log(err); this.setState({ isDeviationSummaryLoading: false }); });
  };
  clearDeviationSummaryState = () => {
    this.setState({ deviationSummaryDetails: { deviationTaken: '', deviationSummary: [], knowledgeAssessment: '', trainingNeeded: '', trainingToWhom: [], trainingArea: [], specialFileNeeded: '', deviationRequired: false, showOtherFields: {} } });
  };
  handleFileSelect = (fileType) => {
    this.setState((prevState: any) => {
      const newSelectedFiles = { ...prevState.selectedFiles, [fileType]: !prevState.selectedFiles[fileType] };
      return { selectedFiles: newSelectedFiles, hasCheckedItem: Object.values(newSelectedFiles).some(v => v === true) };
    });
  };
  showUploadConfirmation = () => {
    if (!this.state.hasCheckedItem) return;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const selected: string[] = [];
    if (this.state.selectedFiles.pdf) selected.push("PDF");
    if (this.state.selectedFiles.word) selected.push("Word");
    if (this.state.selectedFiles.preliminary) selected.push("Preliminary");
    let selectedFileTypes = selected.length === 3 ? "PDF, Word & Preliminary Legal Manual Trigger" : selected.length === 2 ? `${selected.join(" & ")} Legal Manual Trigger` : `${selected[0]} Legal Manual Trigger`;
    const payload = { file_id: this.props.match.params.id, send_pdf: this.state.selectedFiles.pdf, send_word: this.state.selectedFiles.word, generate_send_pdf: this.state.selectedFiles.preliminary, file_status: selectedFileTypes, created_by: userId };
    this.setState({ isUploadModalVisible: true, reportSendPayload: payload });
  };
  hideUploadConfirmation = () => { this.setState({ isUploadModalVisible: false, reportSendPayload: null, uploading: false }); };
  fetchQueryNotes = () => {
    const payload: any = {};
    if (this.props.match.params.id) payload.fileId = this.props.match.params.id;
    callApi("POST", "query_validation_notes_get.php", payload)
      .then((res) => res.data)
      .then((response) => {
        if (response.success && response.data) {
          const normalizedValidatedQueries = (response.data.querydetail || []).map((item: any) => ({
            ...item,
            query: item?.query || "",
            review: item?.review || item?.reason || "",
            other_review: item?.other_review || "",
            location: item?.location || "",
            created_date: item?.created_date || moment().format("DD-MM-YYYY HH:mm:ss"),
            filter_date: item?.filter_date || item?.created_date || moment().format("DD-MM-YYYY HH:mm:ss.SSS"),
          }));
          this.setState({
            newQueryValidatedList: normalizedValidatedQueries,
            replyQueryList: normalizedValidatedQueries,
            isReplyRaiseQueryShown: normalizedValidatedQueries.length > 0,
          });
        }
      })
      .catch((err) => { console.log(err); });
  };
  sendUploadPayload = async () => {
    this.setState({ uploading: true });
    callApi("POST", "auto_mail_report_send.php", this.state.reportSendPayload)
      .then(res => res.data)
      .then(response => {
        if (response.result == true) {
          this.setState({ selectedFiles: { pdf: false, word: false, preliminary: false }, hasCheckedItem: false, uploading: false });
          ToastsStore.success(response.data.message); this.hideUploadConfirmation();
        } else { ToastsStore.error(response.data.message); }
      }).catch(err => { console.log(err); this.setState({ uploading: false }); });
  };

  getQueryHints = () => {
    callApi("POST", "query_hint_list.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        const hintMap = {};
        const hintDateMap = {};
        const hintCreatedByMap = {};
        if (response?.result && Array.isArray(response.data)) {
          response.data.forEach((item: any) => {
            if (item?.query_id) {
              const key = String(item.query_id);
              if (!Array.isArray(hintMap[key])) hintMap[key] = [];
              if (!Array.isArray(hintDateMap[key])) hintDateMap[key] = [];
              if (item?.hint && String(item.hint).trim()) {
                hintMap[key].push(item.hint);
              }
              const hintDate = item?.updated_date || item?.created_date || "";
              if (hintDate) {
                hintDateMap[key].push(hintDate);
              }
              if (!hintCreatedByMap[key]) {
                const createdBy = String(item?.created_by || "").trim();
                if (createdBy) hintCreatedByMap[key] = createdBy;
              }
            }
          });
        }
        this.setState({ queryHintMap: hintMap, queryHintDateMap: hintDateMap, queryHintCreatedByMap: hintCreatedByMap });
      })
      .catch(() => {
        this.setState({ queryHintMap: {}, queryHintDateMap: {}, queryHintCreatedByMap: {} });
      });
  };

  getQueryReceivedDocs = () => {
    callApi("POST", "query_received_docs_get.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        const docMap = {};
        const docCreatedByMap = {};
        if (response?.result && Array.isArray(response.data)) {
          response.data.forEach((item: any) => {
            const key = String(item?.query_id || "");
            if (!key) return;
            if (!Array.isArray(docMap[key])) docMap[key] = [];
            docMap[key].push(item);
            if (!docCreatedByMap[key]) {
              const createdBy = String(item?.created_by || "").trim();
              if (createdBy) docCreatedByMap[key] = createdBy;
            }
          });
        }
        this.setState({ queryReceivedDocMap: docMap, queryReceivedDocCreatedByMap: docCreatedByMap });
      })
      .catch(() => this.setState({ queryReceivedDocMap: {}, queryReceivedDocCreatedByMap: {} }));
  };

  getQueryTrayItems = () => {
    callApi("POST", "query_tray_list.php", { file_id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        if (response?.result) {
          this.setState({ queryTrayItems: response.data || [] });
        }
      })
      .catch(() => this.setState({ queryTrayItems: [] }));
  };

  hasUploadedDocumentForQuery = (queryId: string) =>
    (this.state.base || []).some(
      (doc: any) =>
        String(doc?.query_id || "") === String(queryId) &&
        !String(doc?.tray_query_id || "").trim() &&
        Boolean(doc?.base_url || doc?.base)
    );

  isQueryReceivedForUploadModal = (query: any) => {
    const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
    if (this.isQueryReceivedQueryStatus(status)) return true;
    const qid = String(query?.id || "");
    if (qid && this.hasUploadedDocumentForQuery(qid)) return true;
    if (qid && Array.isArray((this.state as any).queryReceivedDocMap?.[qid]) && (this.state as any).queryReceivedDocMap[qid].length) {
      return true;
    }
    return false;
  };

  buildTrayDocumentPayload = (doc: any) => ({
    category: this.getUploadCategoryLabel(doc.type),
    document_type: this.getUploadDocumentTypeLabel(doc.doc_type),
    type: String(doc.type || "").trim(),
    doc_type: String(doc.doc_type || "").trim(),
    doc_no_year: doc.docNoYear || doc.doc_no || "",
    particular: doc.particular || "xerox",
    base_url: doc.base_url || "",
    base: doc.base || doc.doc_name || "",
  });

  getReceivedDocsForQuery = (queryId: string, query?: any) => {
    const queryIds = query ? this.getQueryIdsForUploadQuery(query) : [String(queryId)];
    const docs: any[] = [];
    const seen = new Set<string>();
    queryIds.forEach((id) => {
      ((this.state as any).queryReceivedDocMap?.[String(id)] || []).forEach((doc: any) => {
        const key = String(doc?.doc_name || doc?.fileName || doc?.id || "");
        if (!key || seen.has(key)) return;
        seen.add(key);
        docs.push(doc);
      });
    });
    return docs;
  };

  getStagedDocsForQuery = (query: any, index: number) =>
    (this.state.base || []).filter(
      (doc: any) =>
        this.doesBaseDocBelongToQuery(doc, query, index) &&
        !String(doc?.tray_query_id || "").trim()
    );

  isReceivedDocAlreadyInTray = (docName: string, query: any, trayItems: any[] = []) => {
    if (!docName) return false;
    const trayItem = (trayItems || []).find((item: any) => this.isQuerySavedInTray(query, [item]));
    if (!trayItem) return false;
    return (trayItem?.partialDocuments || []).some(
      (doc: any) => String(doc?.fileName || doc?.file_name || "") === String(docName)
    );
  };

  buildTrayDocumentPayloadFromReceivedDoc = (receivedDoc: any, stagedDoc?: any) => {
    if (stagedDoc && this.isTrayStagedDocumentReady(stagedDoc)) {
      return this.buildTrayDocumentPayload(stagedDoc);
    }

    const type = stagedDoc?.type || receivedDoc?.type || "";
    const docType = stagedDoc?.doc_type || receivedDoc?.doc_type || "";
    const docNoYear = stagedDoc?.docNoYear || receivedDoc?.doc_no || receivedDoc?.docNoYear || "";
    const particular = stagedDoc?.particular || receivedDoc?.particular || "xerox";
    const fileName = receivedDoc?.doc_name || receivedDoc?.fileName || stagedDoc?.base || "";

    return {
      category: type ? this.getUploadCategoryLabel(type) : "Document",
      document_type: docType ? this.getUploadDocumentTypeLabel(docType) : fileName || "Document",
      type,
      doc_type: docType,
      doc_no_year: docNoYear,
      particular,
      base_url: stagedDoc?.base_url || "",
      base: fileName,
    };
  };

  buildTraySaveItemsFromReceivedDocs = (pendingQueries: any[], trayItems: any[] = []) => {
    const itemsMap = new Map<string, any>();

    pendingQueries.forEach((query: any, index: number) => {
      const queryId = String(query?.id || this.getUploadQueryRowId(query, index));
      const receivedDocs = this.getReceivedDocsForQuery(queryId, query);
      if (!receivedDocs.length) return;

      const stagedDocs = this.getStagedDocsForQuery(query, index);
      const documents: any[] = [];

      receivedDocs.forEach((receivedDoc: any, docIndex: number) => {
        const docName = receivedDoc?.doc_name || receivedDoc?.fileName || "";
        if (!docName || this.isReceivedDocAlreadyInTray(docName, query, trayItems)) return;

        const stagedDoc =
          stagedDocs.find((doc: any) => String(doc?.base || "") === String(docName)) ||
          stagedDocs[docIndex];
        documents.push(this.buildTrayDocumentPayloadFromReceivedDoc(receivedDoc, stagedDoc));
      });

      if (!documents.length) return;

      const mapKey = queryId || this.getUploadQueryMatchKey(query);
      itemsMap.set(mapKey, {
        query_id: queryId,
        query_title: query?.title || "",
        location: query?.location || "",
        reason: query?.reason || "",
        query_raised_date: query?.created_date || "",
        documents,
      });
    });

    return Array.from(itemsMap.values());
  };

  mergeTraySaveItems = (fromBase: any[], fromReceived: any[]) => {
    const merged = new Map<string, any>();

    fromBase.forEach((item: any) => {
      merged.set(String(item.query_id), {
        ...item,
        documents: [...(item.documents || [])],
      });
    });

    fromReceived.forEach((item: any) => {
      const key = String(item.query_id);
      const existingBases = new Set(
        merged.has(key)
          ? (merged.get(key).documents || []).map((doc: any) => String(doc?.base || ""))
          : []
      );
      const newDocs = (item.documents || []).filter(
        (doc: any) => doc?.base && !existingBases.has(String(doc.base))
      );
      if (!newDocs.length) return;

      if (merged.has(key)) {
        merged.get(key).documents.push(...newDocs);
      } else {
        merged.set(key, { ...item, documents: newDocs });
      }
    });

    return Array.from(merged.values()).filter(
      (item: any) => (item.documents || []).length > 0 || (item.hints || []).length > 0
    );
  };

  getQueryHintsForTray = (queryId: string, query?: any) => {
    const queryIds = query
      ? this.getQueryIdsForUploadQuery(query)
      : [String(queryId)];
    const seen = new Set<string>();
    const texts: string[] = [];
    queryIds.forEach((id) => {
      ((this.state as any).queryHintMap?.[String(id)] || []).forEach((hint: string) => {
        const trimmed = String(hint).trim();
        const key = trimmed.toLowerCase();
        if (!trimmed || seen.has(key)) return;
        seen.add(key);
        texts.push(trimmed);
      });
    });
    return texts.map((hint_text: string) => ({ hint_text }));
  };

  mergeTrayHintPayloads = (existing: any[] = [], incoming: any[] = []) => {
    const seen = new Set(
      (existing || []).map((hint: any) => String(hint?.hint_text || hint?.hint || "").trim().toLowerCase())
    );
    const merged = [...(existing || [])];
    (incoming || []).forEach((hint: any) => {
      const hintText = String(hint?.hint_text || hint?.hint || "").trim();
      const key = hintText.toLowerCase();
      if (!hintText || seen.has(key)) return;
      seen.add(key);
      merged.push(hint);
    });
    return merged;
  };

  enrichTraySaveItemsWithHints = (saveItems: any[], pendingQueries: any[], trayItems: any[] = []) => {
    const merged = new Map<string, any>();

    (saveItems || []).forEach((item: any) => {
      merged.set(String(item.query_id), {
        ...item,
        documents: [...(item.documents || [])],
        hints: [...(item.hints || [])],
      });
    });

    pendingQueries.forEach((query: any, index: number) => {
      const queryId = String(query?.id || this.getUploadQueryRowId(query, index));
      const hints = this.getQueryHintsForTray(queryId, query);
      if (!hints.length) return;

      const inTray = this.isQuerySavedInTray(query, trayItems);
      const trayItem = (trayItems || []).find(
        (item: any) => String(item?.queryId || item?.query_id || "") === queryId
      );

      if (merged.has(queryId)) {
        const existing = merged.get(queryId);
        existing.hints = this.mergeTrayHintPayloads(existing.hints, hints);
        return;
      }

      if (!inTray || trayItem) {
        merged.set(queryId, {
          query_id: queryId,
          query_title: trayItem?.title || query?.title || "",
          location: trayItem?.location || query?.location || "",
          reason: trayItem?.reason || query?.reason || "",
          query_raised_date: trayItem?.query_raised_date || query?.created_date || "",
          documents: [],
          hints,
        });
      }
    });

    return Array.from(merged.values()).filter(
      (item: any) => (item.documents || []).length > 0 || (item.hints || []).length > 0
    );
  };

  buildTraySaveItemsFromPending = (pendingQueries: any[]) => {
    const readyDocs = (this.state.base || []).filter(
      (doc: any) =>
        String(doc?.query_id || "").trim() &&
        !String(doc?.tray_query_id || "").trim() &&
        this.isTrayStagedDocumentReady(doc)
    );

    const itemsMap = new Map<string, any>();
    readyDocs.forEach((doc: any) => {
      const matchedQuery =
        pendingQueries.find((query: any, index: number) =>
          this.doesBaseDocBelongToQuery(doc, query, index)
        ) ||
        (this.state.queryTableData || []).find((query: any, index: number) =>
          this.doesBaseDocBelongToQuery(doc, query, index)
        );
      const query = matchedQuery || {
        id: doc.query_id,
        title: doc.query_label || "",
        location: "",
        reason: "",
      };
      const queryId = String(query?.id || doc?.query_id || "");
      const mapKey = queryId || this.getUploadQueryMatchKey(query);
      if (!itemsMap.has(mapKey)) {
        itemsMap.set(mapKey, {
          query_id: queryId,
          query_title: query?.title || doc?.query_label || "",
          location: query?.location || "",
          reason: query?.reason || "",
          query_raised_date: query?.created_date || "",
          documents: [],
        });
      }
      itemsMap.get(mapKey).documents.push(this.buildTrayDocumentPayload(doc));
    });

    return Array.from(itemsMap.values());
  };

  buildTraySaveItemsFromExtraDocs = () => {
    const extraDocs = (this.state.base || []).filter(
      (doc: any) =>
        !String(doc?.query_id || "").trim() &&
        !String(doc?.tray_query_id || "").trim() &&
        this.isTrayStagedDocumentReady(doc)
    );
    if (!extraDocs.length) return [];

    return [
      {
        query_id: "extra-document",
        query_title: "Extra Document",
        location: "-",
        reason: "Additional document",
        query_raised_date: "",
        documents: extraDocs.map((doc: any) => this.buildTrayDocumentPayload(doc)),
      },
    ];
  };

  buildTraySaveItemFromTrayRow = (trayRowId: string, stagedDoc: any) => {
    const trayItem = (this.state.queryTrayItems || []).find(
      (item: any) => String(item?.id || "") === String(trayRowId)
    );
    if (!trayItem) return null;
    return {
      query_id: String(trayItem?.queryId || trayItem?.query_id || ""),
      query_title: trayItem?.title || "",
      location: trayItem?.location || "",
      reason: trayItem?.reason || "",
      query_raised_date: trayItem?.query_raised_date || trayItem?.created_date || "",
      documents: [this.buildTrayDocumentPayload(stagedDoc)],
    };
  };

  refreshQueryManagementTable = () => {
    this.getQueryTable();
    window.dispatchEvent(new CustomEvent("query-tray-saved"));
  };

  persistQueryTraySave = (items: any[], savedBaseMatchers: ((doc: any) => boolean)[]) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    this.setState({ isTraySaving: true });
    return callApi("POST", "query_tray_save.php", {
      file_id: this.props.match.params.id,
      user_id: userId,
      items,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response?.result) {
          this.setState((prevState: any) => {
            let baseArray = cloneDeep(prevState.base || []);
            savedBaseMatchers.forEach((matcher) => {
              baseArray = baseArray.filter((doc: any) => !matcher(doc));
            });
            return {
              base: baseArray,
              queryTrayItems: response.data || [],
              isTraySaving: false,
            };
          });
          this.refreshQueryManagementTable();
          this.getQueryReceivedDocs();
          return response;
        }
        this.setState({ isTraySaving: false });
        showFitContentError(response?.message || "Unable to save query tray");
        return null;
      })
      .catch(() => {
        this.setState({ isTraySaving: false });
        showFitContentError("Unable to save query tray");
        return null;
      });
  };

  resolveUploadModalQueryRaisedBy = (query: any) => {
    return String(
      query?.raised_by ??
      query?.raice_by ??
      query?.raise_by ??
      query?.created_by ??
      ""
    ).trim();
  };

  resolveUploadModalQueryReceivedBy = (query: any) => {
    const fromQuery = String(query?.query_received_by ?? query?.received_by ?? "").trim();
    if (fromQuery) return fromQuery;
    const qid = String(query?.id || "");
    if (!qid) return "";
    const fromDoc = String((this.state as any).queryReceivedDocCreatedByMap?.[qid] || "").trim();
    if (fromDoc) return fromDoc;
    return String((this.state as any).queryHintCreatedByMap?.[qid] || "").trim();
  };

  normalizeUploadQueryKeyPart = (value: any) => {
    const text = String(value ?? "").trim().toLowerCase();
    return text === "-" || text === "--" ? "" : text;
  };

  getUploadQueryMatchKey = (query: any) =>
    `${this.normalizeUploadQueryKeyPart(query?.title)}|${this.normalizeUploadQueryKeyPart(query?.reason)}|${this.normalizeUploadQueryKeyPart(query?.location)}`;

  findTrayItemForQuery = (query: any, trayItems: any[] = this.state.queryTrayItems || []) => {
    const queryId = String(query?.id || query?.queryId || query?.query_id || "").trim();
    const matchKey = this.getUploadQueryMatchKey(query);
    return (trayItems || []).find((trayItem: any) => {
      const trayQueryId = String(trayItem?.queryId || trayItem?.query_id || "").trim();
      if (queryId && trayQueryId && trayQueryId === queryId) return true;
      return this.getUploadQueryMatchKey(trayItem) === matchKey;
    });
  };

  isQuerySavedInTray = (query: any, trayItems: any[] = []) =>
    Boolean(this.findTrayItemForQuery(query, trayItems));

  getActivePendingUploadQueries = (
    trayItems: any[] = this.state.queryTrayItems || [],
    queryTableData: any[] = this.state.queryTableData || []
  ) =>
    this.buildGroupedPendingUploadQueries(queryTableData).filter((query: any) => {
      const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
      if (this.isCompletedQueryStatus(status)) return false;
      if (this.isQueryReceivedQueryStatus(status)) return false;
      if (this.isQueryReceivedForUploadModal(query)) return false;
      return !this.isQuerySavedInTray(query, trayItems);
    });

  hasQueryHintForUpload = (query: any, index = 0, trayItems: any[] = this.state.queryTrayItems || []) => {
    const queryId = String(query?.id || this.getUploadQueryRowId(query, index));
    const hints = (this.state as any).queryHintMap?.[queryId] || [];
    if (Array.isArray(hints) && hints.some((hint: string) => String(hint).trim())) {
      return true;
    }

    const trayItem = this.findTrayItemForQuery(query, trayItems);
    return Boolean(
      trayItem &&
        Array.isArray(trayItem.partialHints) &&
        trayItem.partialHints.some((hint: any) => String(hint?.hint_text || hint?.hint || hint).trim())
    );
  };

  hasPendingQueryBeenAddressed = (
    query: any,
    index = 0,
    trayItems: any[] = this.state.queryTrayItems || []
  ) => {
    if (this.isQueryReceivedForUploadModal(query)) return true;

    const queryId = String(query?.id || this.getUploadQueryRowId(query, index));

    if (this.isQuerySavedInTray(query, trayItems)) return true;
    if (this.hasQueryHintForUpload(query, index, trayItems)) return true;
    if (this.hasUploadedDocumentForQuery(queryId)) return true;
    if (Array.isArray((this.state as any).queryReceivedDocMap?.[queryId]) && (this.state as any).queryReceivedDocMap[queryId].length) {
      return true;
    }

    const trayItem = this.findTrayItemForQuery(query, trayItems);
    if (
      trayItem &&
      Array.isArray(trayItem.partialDocuments) &&
      trayItem.partialDocuments.some((doc: any) => String(doc?.fileName || doc?.file_name || "").trim())
    ) {
      return true;
    }

    return (this.state.base || []).some((doc: any) => {
      if (!this.doesBaseDocBelongToQuery(doc, query, index)) return false;
      return Boolean(doc?.base_url || doc?.base || doc?.doc_name);
    });
  };

  getUnhandledPendingUploadQueries = (
    trayItems: any[] = this.state.queryTrayItems || [],
    queryTableData: any[] = this.state.queryTableData || []
  ) =>
    this.getActivePendingUploadQueries(trayItems, queryTableData).filter(
      (query: any, index: number) => !this.hasPendingQueryBeenAddressed(query, index, trayItems)
    );

  hasUploadableBaseDocs = (baseDocs: any[] = this.state.base || []) =>
    (baseDocs || []).some((doc: any) => Boolean(doc?.base_url || doc?.base));

  buildGroupedPendingUploadQueries = (queryTableData: any[] = []) => {
    return Object.values(
      (queryTableData || [])
        .filter((query: any) => {
          const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
          return !this.isCompletedQueryStatus(status);
        })
        .reduce((acc: any, query: any) => {
          const key = `${String(query?.title || "").toLowerCase()}|${String(query?.reason || "").toLowerCase()}|${String(query?.location || "").toLowerCase()}`;
          if (!acc[key]) {
            acc[key] = { ...query, groupedCount: 1 };
          } else {
            acc[key].groupedCount = (acc[key].groupedCount || 1) + 1;
            const existingTime = moment(acc[key]?.created_date, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", moment.ISO_8601], true);
            const currentTime = moment(query?.created_date, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", moment.ISO_8601], true);
            if (!existingTime.isValid() || (currentTime.isValid() && currentTime.isAfter(existingTime))) {
              acc[key] = { ...acc[key], ...query, groupedCount: acc[key].groupedCount };
            }
          }
          return acc;
        }, {})
    ).sort((a: any, b: any) => {
      const aTime = moment(a?.created_date, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", moment.ISO_8601], true);
      const bTime = moment(b?.created_date, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", moment.ISO_8601], true);
      return (bTime.isValid() ? bTime.valueOf() : 0) - (aTime.isValid() ? aTime.valueOf() : 0);
    });
  };

  getPendingQueriesForTrayMail = (queryTableData: any[] = [], trayItems: any[] = []) => {
    return this.buildGroupedPendingUploadQueries(queryTableData).filter((query: any) => {
      const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
      if (this.isCompletedQueryStatus(status)) return false;
      if (this.isQuerySavedInTray(query, trayItems)) return false;
      return !this.isQueryReceivedQueryStatus(status);
    });
  };

  buildUploadPendingQueryMailItem = (query: any) => {
    const queryId = parentIdForRaise(query);
    const created_date = moment().format("DD-MM-YYYY HH:mm:ss");
    return {
      query: query?.title || "",
      review: query?.reason || "",
      query_id: queryId,
      location: query?.location || "",
      created_date,
      filter_date: moment().format("DD-MM-YYYY HH:mm:ss.SSS"),
    };
  };

  loadOfficeUsersForTrayMail = () => {
    if ((this.state.remote_users || []).length) {
      return Promise.resolve(this.state.remote_users);
    }
    return callApi("POST", "office_details.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        const remote_users = (response.data || []).map((user: any) => ({ email: user.email, name: user.name }));
        this.setState({ office_users: response.data, remote_users, remote_cc_users: remote_users });
        return remote_users;
      })
      .catch(() => []);
  };

  checkAndShowTrayPendingMailModal = async (trayItemsFromSave?: any[]) => {
    const queryTableData = await this.getLatestQueryTableDataForValidation();
    const trayItems = trayItemsFromSave || this.state.queryTrayItems || [];
    const pendingForMail = this.getPendingQueriesForTrayMail(queryTableData, trayItems);
    if (!pendingForMail.length) {
      return;
    }
    await this.loadOfficeUsersForTrayMail();
    this.setState({
      queryTableData,
      trayPendingMailModalOpen: true,
      trayPendingMailQueries: pendingForMail,
      trayPendingMailBlockActive: true,
    });
    $("#upload-modal").modal({ backdrop: "static", keyboard: false, show: true });
  };

  cleanupStaleModalOverlays = () => {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.querySelectorAll(".ant-modal-mask").forEach((el) => el.remove());
    document.querySelectorAll(".ant-modal-wrap").forEach((el) => el.remove());
    document.querySelectorAll(".ant-modal-root").forEach((el) => {
      if (!el.querySelector(".ant-modal")) {
        el.remove();
      }
    });
    document.querySelectorAll(".modal.show").forEach((el) => {
      el.classList.remove("show");
      el.setAttribute("aria-hidden", "true");
      (el as HTMLElement).style.display = "none";
    });
  };

  closeTrayPendingMailModal = (options?: { closeUploadModal?: boolean }) => {
    this.setState({
      trayPendingMailModalOpen: false,
      trayPendingMailQueries: [],
      trayPendingMailSending: false,
      trayPendingMailBlockActive: false,
    }, () => {
      const runCleanup = () => this.cleanupStaleModalOverlays();

      if (options?.closeUploadModal) {
        const $uploadModal = $("#upload-modal");
        $uploadModal.off("hidden.bs.modal.trayMailCleanup");
        $uploadModal.one("hidden.bs.modal.trayMailCleanup", () => {
          runCleanup();
          setTimeout(runCleanup, 100);
        });
        $uploadModal.modal("hide");
        this.setState({ base: [] });
        setTimeout(runCleanup, 450);
      } else {
        runCleanup();
        setTimeout(runCleanup, 100);
      }
    });
  };

  sendTrayPendingQueriesMail = (): void => {
    const { trayPendingMailQueries, remote_users, remote_cc_users } = this.state;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const process_office_id: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");
    const querydetail = (trayPendingMailQueries || []).map((query: any) =>
      sanitizeMultiSelectedQueryItem(this.buildUploadPendingQueryMailItem(query))
    );
    if (!querydetail.length) {
      this.closeTrayPendingMailModal();
      return;
    }
    const payload: any = {
      querydetail,
      remote_users: remote_users || [],
      remote_cc_users: remote_cc_users || [],
      user_idfk: userId,
      fod_fk: this.props.match.params.id,
      base: [],
      tray_mail: true,
    };
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    const mailToBank: any = localStorage.getItem("mail-bank");
    let apiPath;
    if (userDGrade === "D" || fileDGrade === "D") {
      apiPath = mailToBank === "true" ? "new_query_create.php" : "new_query_create_without_mail.php";
      this.deviationFileLog(this.props.match.params.id);
    } else {
      apiPath = "new_query_create.php";
    }
    this.setState({ trayPendingMailSending: true });
    callApi("POST", apiPath, payload)
      .then((res) => res.data)
      .then((response) => {
        const blockedMessage = String(response?.message || "").toLowerCase();
        const isQueryBlocked = blockedMessage.includes("cannot raise a query");
        if (response.success == true && !isQueryBlocked) {
          localStorage.setItem("query_raised_status", JSON.stringify(true));
          if (process_office_id == userid1) {
            this.timeUpdate(this.props.match.params.id, "query raise");
          }
          ToastsStore.success("Pending queries sent by mail successfully.");
          this.closeTrayPendingMailModal({ closeUploadModal: true });
          this.refreshQueryManagementTable();
          this.getQueryReceivedDocs();
          this.getQueryTrayItems();
        } else {
          this.setState({ trayPendingMailSending: false });
          ToastsStore.error(response.message || "Unable to send pending queries by mail.");
        }
      })
      .catch(() => {
        this.setState({ trayPendingMailSending: false });
        ToastsStore.error("Something went wrong while sending mail. Please try again.");
      });
  };

  getUploadQueryRowId = (query: any, index: number) => String(query?.id || `upload-row-${index}`);

  isUploadQuerySelected = (queryId: string) => (this.state.uploadSelectedQueryIds || []).includes(queryId);

  toggleUploadQuerySelection = (queryId: string) => {
    this.setState((prevState: any) => {
      const selected = new Set(prevState.uploadSelectedQueryIds || []);
      if (selected.has(queryId)) selected.delete(queryId);
      else selected.add(queryId);
      return { uploadSelectedQueryIds: Array.from(selected) };
    });
  };

  toggleAllUploadQuerySelection = (queries: any[]) => {
    const allIds = queries.map((query, index) => this.getUploadQueryRowId(query, index));
    const currentSelected = this.state.uploadSelectedQueryIds || [];
    const allSelected = allIds.length > 0 && allIds.every((id) => currentSelected.includes(id));
    this.setState({ uploadSelectedQueryIds: allSelected ? [] : allIds });
  };

  getTrayQueryRowId = (query: any, index: number) => String(query?.id || `tray-row-${index}`);

  isTrayQuerySelected = (trayRowId: string) => (this.state.uploadTraySelectedIds || []).includes(trayRowId);

  toggleTrayQuerySelection = (trayRowId: string) => {
    this.setState((prevState: any) => {
      const selected = new Set(prevState.uploadTraySelectedIds || []);
      if (selected.has(trayRowId)) selected.delete(trayRowId);
      else selected.add(trayRowId);
      return { uploadTraySelectedIds: Array.from(selected) };
    });
  };

  toggleAllTrayQuerySelection = (trayQueries: any[]) => {
    const allIds = trayQueries.map((query, index) => this.getTrayQueryRowId(query, index));
    const currentSelected = this.state.uploadTraySelectedIds || [];
    const allSelected = allIds.length > 0 && allIds.every((id) => currentSelected.includes(id));
    this.setState({ uploadTraySelectedIds: allSelected ? [] : allIds });
  };

  handleMoveTrayToProcess = () => {
    const selectedIds = this.state.uploadTraySelectedIds || [];
    if (!selectedIds.length) {
      ToastsStore.warning("Select at least one query from tray to move to process.");
      return;
    }
    this.setState((prevState: any) => ({
      queryTrayItems: (prevState.queryTrayItems || []).filter(
        (item: any) => !selectedIds.includes(String(item?.id || ""))
      ),
      uploadTraySelectedIds: [],
    }));
    ToastsStore.success(`${selectedIds.length} query(s) moved to process. (Design preview — no API call)`);
  };

  buildQueryTrayItemFromQuery = (query: any, queryRowId: string, index: number) => {
    const partialDocs = (this.state.base || []).filter(
      (doc: any) => String(doc?.query_id || "") === String(query?.id || queryRowId)
    );
    const mappedPartialDocuments = partialDocs.length
      ? partialDocs.map((doc: any) => ({
          category: doc?.category || "Title Deed",
          documentType: doc?.doc_type || doc?.type || "Partial Document",
          docNoYear: doc?.doc_no || doc?.docNoYear || "-",
          particular: doc?.particular || "Xerox",
          fileName: doc?.base || "",
        }))
      : [
          {
            category: "Title Deed",
            documentType: "Partial Document",
            docNoYear: "-",
            particular: "Xerox",
            fileName: "",
          },
        ];
    return {
      id: `tray-${Date.now()}-${index}`,
      queryId: String(query?.id || queryRowId),
      title: query?.title || "Unknown Query",
      location: query?.location || "-",
      reason: query?.reason || "-",
      groupedCount: mappedPartialDocuments.length || query?.groupedCount || 1,
      created_date: query?.created_date || "",
      savedOn: moment().format("DD-MM-YYYY hh:mm A"),
      status: "2",
      partialDocuments: mappedPartialDocuments,
    };
  };

  handleSaveToTrayFromFooter = (pendingQueries: any[]) => {
    if (!this.canShowSaveToTrayButton()) {
      return;
    }
    const trayEntry = this.getTrayStagedUploadEntry();
    if (trayEntry?.stagedDoc && String(trayEntry.stagedDoc?.tray_query_id || "").trim()) {
      if (this.isTrayStagedDocumentReady(trayEntry.stagedDoc)) {
        this.saveDocumentToQueryTray(trayEntry.trayId, trayEntry.baseIndex);
        return;
      }
      ToastsStore.warning("Please complete category, document type, particulars, and upload the file before saving.");
      return;
    }

    const trayItems = this.state.queryTrayItems || [];
    const fromBase = this.buildTraySaveItemsFromPending(pendingQueries);
    const fromReceived = this.buildTraySaveItemsFromReceivedDocs(pendingQueries, trayItems);
    const fromExtra = this.buildTraySaveItemsFromExtraDocs();
    const saveItems = this.enrichTraySaveItemsWithHints(
      this.mergeTraySaveItems(this.mergeTraySaveItems(fromBase, fromReceived), fromExtra),
      pendingQueries,
      trayItems
    );
    if (!saveItems.length) {
      const hasStagedButIncomplete = (this.state.base || []).some(
        (doc: any) =>
          !String(doc?.tray_query_id || "").trim() &&
          Boolean(doc?.base_url || doc?.base || doc?.doc_name) &&
          !this.isTrayStagedDocumentReady(doc)
      );
      showFitContentWarning(
        hasStagedButIncomplete
          ? "Complete category, document type, particulars, and file upload for staged documents before saving to tray."
          : "Upload and fill document details (category, type, file) or add hints for at least one query before saving to tray."
      );
      return;
    }

    const savedQueryIds = new Set(saveItems.map((item: any) => String(item.query_id || "")));
    const savedExtraDocs = savedQueryIds.has("extra-document");
    this.persistQueryTraySave(saveItems, [
      (doc: any) =>
        savedQueryIds.has(String(doc?.query_id || "")) &&
        !String(doc?.tray_query_id || "").trim() &&
        this.isTrayStagedDocumentReady(doc),
      (doc: any) =>
        savedExtraDocs &&
        !String(doc?.query_id || "").trim() &&
        !String(doc?.tray_query_id || "").trim() &&
        this.isTrayStagedDocumentReady(doc),
    ]).then((response) => {
      if (response?.result) {
        const docCount = saveItems.reduce(
          (count: number, item: any) => count + (item.documents || []).length,
          0
        );
        const hintCount = saveItems.reduce((count: number, item: any) => count + (item.hints || []).length, 0);
        const parts: string[] = [];
        if (docCount) parts.push(`${docCount} document(s)`);
        if (hintCount) parts.push(`${hintCount} hint(s)`);
        ToastsStore.success(
          parts.length
            ? `${parts.join(" and ")} saved in query tray.`
            : `${saveItems.length} query item(s) saved in tray.`
        );
        this.getQueryHints();
        this.checkAndShowTrayPendingMailModal(response.data || []);
      }
    });
  };

  handleSaveSelectedQueriesInTray = (pendingQueries: any[]) => {
    const selectedIds = this.state.uploadSelectedQueryIds || [];
    if (!selectedIds.length) {
      ToastsStore.warning("Select at least one query to save in tray.");
      return;
    }
    const newTrayItems = selectedIds.map((selectedId, index) => {
      const queryIndex = pendingQueries.findIndex(
        (query, rowIndex) => this.getUploadQueryRowId(query, rowIndex) === selectedId
      );
      const query = pendingQueries[queryIndex] || {};
      return this.buildQueryTrayItemFromQuery(query, selectedId, index);
    });
    this.setState((prevState: any) => ({
      queryTrayItems: [...newTrayItems, ...(prevState.queryTrayItems || [])],
      uploadSelectedQueryIds: [],
    }));
    ToastsStore.success(`${newTrayItems.length} query document(s) saved in tray.`);
  };

  handleSendMailForSelectedQueries = (pendingQueries: any[]) => {
    const selectedIds = this.state.uploadSelectedQueryIds || [];
    if (!selectedIds.length) {
      ToastsStore.warning("Select at least one query to send mail.");
      return;
    }
    const selectedQueries = selectedIds
      .map((selectedId) => {
        const queryIndex = pendingQueries.findIndex(
          (query, rowIndex) => this.getUploadQueryRowId(query, rowIndex) === selectedId
        );
        return pendingQueries[queryIndex];
      })
      .filter(Boolean);
    this.setState({
      uploadSendMailPreviewOpen: true,
      uploadSendMailPreviewQueries: selectedQueries,
    });
  };

  confirmUploadSendMailPreview = () => {
    const count = (this.state.uploadSendMailPreviewQueries || []).length;
    this.setState({
      uploadSendMailPreviewOpen: false,
      uploadSendMailPreviewQueries: [],
      uploadSelectedQueryIds: [],
    });
    ToastsStore.success(`Mail prepared for ${count} selected query(s). (Design preview — no API call)`);
  };

  removeQueryTrayDocument = (trayId: string, docIndex: number) => {
    const trayItem = (this.state.queryTrayItems || []).find(
      (item: any) => String(item?.id || "") === String(trayId)
    );
    const doc = trayItem?.partialDocuments?.[docIndex];
    const docId = doc?.id;

    if (!docId) {
      ToastsStore.warning("Unable to remove document.");
      return;
    }

    this.setState({ isTraySaving: true });
    callApi("POST", "query_tray_remove_document.php", {
      file_id: this.props.match.params.id,
      tray_id: trayId,
      doc_id: docId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response?.result) {
          this.setState({
            queryTrayItems: response.data || [],
            isTraySaving: false,
          });
          ToastsStore.info("Document removed from query tray.");
          return;
        }
        this.setState({ isTraySaving: false });
        ToastsStore.error(response?.message || "Unable to remove document.");
      })
      .catch(() => {
        this.setState({ isTraySaving: false });
        ToastsStore.error("Unable to remove document.");
      });
  };

  renderUploadModalQueryRows = (queries: any[]) => {
    return queries.map((query: any, index: number) => {
      const queryRowId = this.getUploadQueryRowId(query, index);
      const expandKey = String(query?.id || index);
      const isExpanded = this.state.uploadPendingExpandedId === expandKey;
      const isReceivedStatus = this.isQueryReceivedForUploadModal(query);
      const mappedUploadDocs =
        Array.isArray(this.state.base)
          ? this.state.base
              .map((document: any, docIndex: number) => ({ document, docIndex }))
              .filter(({ document }: any) => this.doesBaseDocBelongToQuery(document, query, index))
          : [];

      return (
        <React.Fragment key={`pending-upload-query-${queryRowId}`}>
          <tr className="query-client-row">
            <td className="query-upload-sl-col">
              <div className="query-upload-sl-cell">
                <span className="query-upload-sl-num">{index + 1}</span>
                <span className={`query-row-dot ${isReceivedStatus ? "dot-received" : "dot-pending"}`}></span>
              </div>
            </td>
            <td className="query-upload-query-col">
              <div className="query-client-main">{query?.title || "-"}</div>
              {query?.location && String(query.location).trim() && String(query.location).trim() !== "-" ? (
                <div className="query-client-sub">{query.location}</div>
              ) : null}
            </td>
            <td>{query?.reason || "-"}</td>
            <td>{query?.groupedCount || 1}</td>
            <td>
              <div className="query-client-main">
                {query?.created_date ? moment(query.created_date).format("DD-MM-YYYY") : "-"}
              </div>
              <div className="query-client-sub">
                {query?.created_date ? moment(query.created_date).format("hh:mm A") : "-"}
              </div>
            </td>
            <td>
              {isReceivedStatus ? (
                <span className="query-client-pill query-client-pill-received">Query Received</span>
              ) : (
                <span className="query-client-pill query-client-pill-pending">Pending</span>
              )}
            </td>
            <td>
              <div className="query-client-actions">
                <button
                  type="button"
                  className="query-client-requery-btn query-upload-action-btn query-upload-action-upload"
                  title="Map Query For Upload"
                  onClick={() => this.addUploadDocument(query)}
                >
                  Upload
                </button>
                <button
                  type="button"
                  className="query-client-requery-btn query-upload-action-btn query-upload-action-hint"
                  title="Add Hint"
                  onClick={() =>
                    this.setState({
                      uploadHintQuery: query,
                      uploadHintText: "",
                    })
                  }
                >
                  Hint
                </button>
                <button
                  type="button"
                  className="icon-btn query-upload-expand-btn"
                  title="Expand"
                  onClick={() =>
                    this.setState((prevState: any) => ({
                      uploadPendingExpandedId:
                        prevState.uploadPendingExpandedId === expandKey ? "" : expandKey,
                    }))
                  }
                >
                  <i className={`fa ${isExpanded ? "fa-angle-up" : "fa-angle-down"}`} aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
          {isExpanded ? (
            <tr className="query-client-expanded-row">
              <td colSpan={7}>
                <div className="query-client-expanded">
                  <>
                      <div className="query-client-expanded-timeline" style={{ display: "block", width: "100%" }}>
                        <table className="table query-client-given-table" style={{ marginBottom: 0, tableLayout: "fixed", width: "100%" }}>
                          <thead>
                            <tr>
                              <th style={{ width: "25%" }}>Raised Date &amp; Time</th>
                              <th style={{ width: "25%" }}>Received Date &amp; Time</th>
                              <th style={{ width: "25%" }}>Query Raised By</th>
                              <th style={{ width: "25%" }}>Query Received By</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ width: "25%" }}>{query?.created_date ? `1] ${moment(query.created_date).format("DD-MM-YYYY hh:mm A")}` : "-"}</td>
                              <td style={{ width: "25%" }}>
                                {this.resolveUploadModalQueryReceivedAt(query)
                                  ? `1] ${moment(this.resolveUploadModalQueryReceivedAt(query)).format("DD-MM-YYYY hh:mm A")}`
                                  : "-"}
                              </td>
                              <td style={{ width: "25%" }}>{this.resolveUploadModalQueryRaisedBy(query) || "-"}</td>
                              <td style={{ width: "25%" }}>{this.resolveUploadModalQueryReceivedBy(query) || "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {Array.isArray(this.state.base) && this.state.base.filter((doc: any) => String(doc?.query_id || "") === String(query?.id || "") && !!doc?.base).length > 0 ? (
                        <div style={{ marginTop: "12px", border: "1px solid #dbeafe", borderRadius: "10px", background: "#f8fbff", overflow: "hidden" }}>
                          <div style={{ padding: "8px 12px", background: "#eff6ff", borderBottom: "1px solid #dbeafe", fontWeight: 600, color: "#1e40af" }}>
                            Staged Documents (Before Save)
                          </div>
                          <div style={{ padding: "8px 12px" }}>
                            {this.state.base
                              .filter((doc: any) => String(doc?.query_id || "") === String(query?.id || "") && !!doc?.base)
                              .map((doc: any, docIndex: number) => (
                                <div key={`staged-doc-${query?.id}-${docIndex}`} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 10px", border: "1px solid #bfdbfe", borderRadius: "8px", marginBottom: "6px", background: "#fff" }}>
                                  <div>
                                    <div style={{ fontWeight: 600 }}>{docIndex + 1}. {doc?.base || "-"}</div>
                                    <div style={{ fontSize: "12px", color: "#64748b" }}>Mapped Query Upload</div>
                                  </div>
                                  <button
                                    type="button"
                                    className="icon-btn"
                                    title="View"
                                    data-toggle="modal"
                                    data-target="#preview-document"
                                    onClick={() => this.previewDoc(doc?.base_url || doc?.doc_url || "")}
                                  >
                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                  </button>
                                </div>
                              ))}
                          </div>
                        </div>
                      ) : null}
                      {this.state?.queryHintMap?.[String(query?.id || "")] ? (
                        <div style={{ marginTop: "12px", border: "1px solid #eef0f4", borderRadius: "10px", background: "#fcfdff", overflow: "hidden" }}>
                          <div style={{ padding: "8px 12px", background: "#f5f7fb", borderBottom: "1px solid #eef0f4", fontWeight: 600, color: "#4b5563" }}>
                            Query Hints
                          </div>
                          <div style={{ padding: "8px 12px" }}>
                            {(this.state.queryHintMap[String(query?.id || "")] || []).map((hint: string, hintIndex: number) => (
                              <div
                                key={`hint-${query?.id}-${hintIndex}`}
                                style={{ padding: "6px 10px", borderRadius: "8px", background: "#ffffff", border: "1px solid #edf1f6", marginBottom: hintIndex === this.state.queryHintMap[String(query?.id || "")].length - 1 ? 0 : "6px" }}
                              >
                                <span style={{ fontWeight: 600, marginRight: "6px", color: "#6b7280" }}>{hintIndex + 1}.</span>
                                <span style={{ color: "#111827" }}>{hint}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      {Array.isArray(this.state?.queryReceivedDocMap?.[String(query?.id || "")]) &&
                      this.state.queryReceivedDocMap[String(query?.id || "")].length > 0 ? (
                        <div style={{ marginTop: "12px", border: "1px solid #e8edf5", borderRadius: "10px", background: "#fff", overflow: "hidden" }}>
                          <div style={{ padding: "8px 12px", background: "#f5f7fb", borderBottom: "1px solid #e8edf5", fontWeight: 600 }}>
                            Uploaded Query Documents
                          </div>
                          <div style={{ padding: "8px 12px" }}>
                            {this.state.queryReceivedDocMap[String(query?.id || "")].map((doc: any, docIndex: number) => (
                              <div key={`query-doc-${query?.id}-${doc?.id || docIndex}`} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 10px", border: "1px solid #edf1f6", borderRadius: "8px", marginBottom: docIndex === this.state.queryReceivedDocMap[String(query?.id || "")].length - 1 ? 0 : "6px" }}>
                                <div>
                                  <div style={{ fontWeight: 600, color: "#374151" }}>{docIndex + 1}. {doc?.doc_name || "-"}</div>
                                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                    Query Received Time: {doc?.created_date ? moment(doc.created_date).format("DD-MM-YYYY hh:mm A") : "-"}
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="icon-btn"
                                  title="View"
                                  data-toggle="modal"
                                  data-target="#preview-document"
                                  onClick={() => this.previewDoc(doc?.doc_url || doc?.base_url || "")}
                                >
                                  <i className="fa fa-eye" aria-hidden="true"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                  </>
                </div>
              </td>
            </tr>
          ) : null}
          {mappedUploadDocs.map(({ document, docIndex }: any) => (
              <React.Fragment key={`mapped-upload-row-${query?.id || index}-${docIndex}`}>
                <tr className="query-client-expanded-row">
                  <td colSpan={7}>
                    <DashUploadDocument
                      key={docIndex}
                      baseDetails={document}
                      handleDocumentDetailsChange={this.handleDocumentDetailsChange}
                      handleDocumentFilesChange={this.handleDocumentFilesChange1}
                      deleteDocumentDetails={this.deleteDocumentDetails}
                      deleteFile={this.deleteFile}
                      deedList={this.state.deeds}
                      previewDoc={this.previewDoc}
                      categoriesList={this.state.categoriesList}
                      index={docIndex}
                      newfile={this.state.isNewFile}
                      path="filedashboard"
                      state={this.state}
                      isbtnload={this.state.isbtnload}
                    />
                  </td>
                </tr>
              </React.Fragment>
            ))}
        </React.Fragment>
      );
    });
  };

  addHintForUploadPendingQuery = (query: any) => {
    const queryId = String(query?.id || "");
    const hint = this.state.uploadHintText;
    if (!hint || !hint.trim()) {
      ToastsStore.error("Please enter hint");
      return;
    }
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "query_hint_save.php", {
      file_id: this.props.match.params.id,
      query_id: queryId,
      hint: hint.trim(),
      user_id: userId,
    })
      .then((res) => res.data)
      .then(() => {
        this.setState({ uploadPendingMenuQuery: null, uploadHintQuery: null, uploadHintText: "" });
        this.getQueryTable();
        this.getQueryTree();
        this.getQueryHints();
        window.dispatchEvent(new CustomEvent("query-hint-updated"));
        ToastsStore.success("Hint added successfully");
      })
      .catch(() => {
        ToastsStore.error("Unable to add hint");
      });
  };

  render() {
    const assessmentMarkList = [{ label: "0", value: 0 }, { label: "1", value: 1 }, { label: "2", value: 2 }, { label: "3", value: 3 }];
    const editCss = { marginTop: "-10px", width: "fit-content", padding: "7px", borderRadius: "13px" };
    const fileurl: any = localStorage.getItem("url");
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const roleType = user ? JSON.parse(user)["roleType"] : "";
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const {
      info, showTitle, selectVal, multiSelectedQuery, queryLoading, queryQues, quesSubmitted,
      updateDownloadData, isAutoMailLogShown, isCheckListLogShown, isReasonForDownloadShown,
      isUpdateDownloadShown, uploadFile, reason, setResponse, workfileEnable, initialTimeInMinutes,
      isRaiseQueryShown, newQueryList, isReplyRaiseQueryShown, replyQueryList, Rectify_files, isFileRefresh,
    } = this.state;

    const filterTemp = role_label !== "Admin" && role_label !== "Super Admin"
      ? this.state.bank_templates.filter((temp: any) =>
        temp?.bank_id === this.state?.info?.org_bank_id &&
        temp?.product_id === this.state?.info?.productId &&
        Array.isArray(temp?.lawhands_branch) &&
        temp.lawhands_branch.includes(this.state?.info?.lawhands_branch)
      )
      : this.state.bank_templates;
    const banktemplatesoption = filterTemp.map((opt: any) => ({ ...opt, label: `${opt.name}-${opt.bank_name}-${opt.product_name}`, value: opt.id }));
    const process_officer: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");
    let RemainingTime: any = localStorage.getItem("updatedRemainingTime");
    const take_file: any = localStorage.getItem("takenfile_id");
    const getfileId: any = localStorage.getItem("currentfileId");
    let initialtime = (initialTimeInMinutes && initialTimeInMinutes > 0 && take_file == getfileId) ? initialTimeInMinutes : RemainingTime;
    const mailToBank: any = localStorage.getItem("mail-bank");
    const fromDeviation: any = localStorage.getItem("from_deviation");
    const accentStyle = { "--accent-color": "#5bc0de" } as React.CSSProperties;
    const greenStyle = { "--accent-color": "#28a745" } as React.CSSProperties;
    const grayStyle = { "--accent-color": "gray" } as React.CSSProperties;
    const loginStyle = { "--accent-color": ["-1"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 1 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const QueueStyle = { "--accent-color": ["0", "8"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 2 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const wipStyle = { "--accent-color": ["2"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 3 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const QRStyle = { "--accent-color": ["7"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 4 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const QreceiveStyle = { "--accent-color": ["8"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 5 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const TCStyle = { "--accent-color": ["6"].includes(info.file_status) && info.vtaken_status == "0" && info.taken_status == "0" ? accentStyle["--accent-color"] : this.state.step >= 6 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const VwipStyle = { "--accent-color": ["6"].includes(info.file_status) && info.vtaken_status == "1" && info.taken_status == "0" ? accentStyle["--accent-color"] : this.state.step >= 7 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const HoldStyle = { "--accent-color": ["3"].includes(info.file_status) ? accentStyle["--accent-color"] : this.state.step >= 7 && info.hold_date != "" ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const VcStyle = { "--accent-color": ["5"].includes(info.file_status) && info.vtaken_status == "0" && info.taken_status == "0" ? accentStyle["--accent-color"] : this.state.step >= 8 ? greenStyle["--accent-color"] : grayStyle["--accent-color"] } as React.CSSProperties;
    const takenfile_id: any = localStorage.getItem("takenfile_id");
    const currentfile_Id: any = localStorage.getItem("currentfileId");
    let takenfile = null;
    try { takenfile = JSON.parse(takenfile_id); } catch (error) { }
    const currentfile = JSON.parse(currentfile_Id);
    const fileWorkType = this.state.blockdownload == "true" && this.state.info.opinion_type == "1" ? "Software task" : "Manual task";
    const autoMail = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Report Shared Manually" && page.status == true);

    const filterBankLHBranch: any = this.state.bankWithLawhadnsBranch.find((bank: any) =>
      bank?.bank_id == this.state?.info?.org_bank_id &&
      bank?.product_id == this.state?.info?.bank_product &&
      bank?.lawhands_branch == this.state?.info?.lawhands_branch
    );
    const isAutoMail = filterBankLHBranch?.autoMail === '1';
    const preliminaryPDF = filterBankLHBranch?.preliminaryPDF === '1';
    const pendingUploadQueries = this.buildGroupedPendingUploadQueries(this.state.queryTableData || []);
    const displayQueryTrayItems = this.state.queryTrayItems || [];
    const displayPendingUploadQueries = pendingUploadQueries
      .filter((query: any) => {
        const status = this.normalizeQueryStatus(this.getQueryStatusValue(query));
        if (this.isCompletedQueryStatus(status)) return false;
        return !this.isQuerySavedInTray(query, displayQueryTrayItems);
      });
    const eligiblePendingTrayQueries = this.getPendingQueriesForTrayMail(
      this.state.queryTableData || [],
      displayQueryTrayItems
    );
    // console.log("isAutoMail, preliminaryPDF", isAutoMail, preliminaryPDF, filterBankLHBranch);

    return (
      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header" style={{ padding: "12px" }}>
                          {/* ── Timer ─────────────────────────────────────────── */}
                          <div className="row">
                            <div className="col-md-12">
                              {process_officer == userid1 && initialtime && initialtime > 0 && take_file == getfileId && (
                                <CountdownTimer initialTime={initialtime} updatedTime={(time) => this.updatedRemainingTime(time)} ref={(ref) => (this.countdownTimerRef = ref)} />
                              )}
                            </div>
                          </div>
                          {/* ── File info ─────────────────────────────────────── */}
                          <div className="row">
                            <div className="col-md-9">
                              <div className="d-flex">
                                <h5>File No - {this.state.info.file_name}</h5>
                                {!isEmpty(this.state.info.vetting_file_no) && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>Vetting File No - {this.state.info.vetting_file_no}</h5></>)}
                                <h5 style={{ marginLeft: "1%" }}>|</h5>
                                <h5 style={{ marginLeft: "1%" }}>Login Date - {this.state.info.login_time}</h5>
                              </div>
                              <div className="d-flex" style={{ marginTop: "2%" }}>
                                <h5>Bank Name - {this.state.info.bank_name} {this.state.info.product_name ? <>({this.state.info.product_name})</> : ""}</h5>
                              </div>
                              <div className="d-flex" style={{ marginTop: "2%" }}>
                                <h5>PO - {this.state.info.process_officer}</h5>
                                {!isEmpty(this.state.info.query_validation_officer_name) && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>QVO - {this.state.info.query_validation_officer_name}</h5></>)}
                                {!isEmpty(this.state.info.all_query_validation_officer_names) && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>QVO's - {this.state.info.all_query_validation_officer_names}</h5></>)}
                                {!isEmpty(this.state.info.verify_officer) && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>VO - {this.state.info.verify_officer}</h5></>)}
                                {!isEmpty(this.state.info.dverify_officer) && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>DVO - {this.state.info.dverify_officer}</h5></>)}
                                {!isEmpty(this.state.info.deviation_officer) && this.state.info.deviation_officer != '0' && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>DO - {this.state.info.deviation_officer}</h5></>)}
                                {!isEmpty(this.state.info.rectify_officer) && this.state.info.rectify_officer != '0' && (<><h5 style={{ marginLeft: "1%" }}>|</h5><h5 style={{ marginLeft: "1%" }}>RO - {this.state.info.rectify_officer}</h5></>)}
                              </div>
                              <div style={{ display: "flex", marginTop: "2%", gap: "5px" }}>
                                <h5>App Id:</h5>
                                <div style={editCss}>
                                  <b className="appidShow" style={{ fontSize: "16px", color: "#111", fontWeight: 500 }}>{this.state.info.app_id}</b>
                                  <input type="text" className="form-control appidEdit" placeholder="AppId" id="appid" name="app_id" style={{ width: "fit-content", display: "none", border: "1px solid gray", height: "30px", marginRight: "10px" }} onChange={(e) => this.handleChange1(e)} onBlur={() => this.AppidSave("appId")} value={this.state.info.app_id} />
                                  <span><FaRegEdit onClick={() => this.editOption("appId")} style={{ marginBottom: "6px" }} className="editicon" /></span>
                                </div>
                                <h5 style={{ marginLeft: "1%" }}>|</h5>
                                <h5 style={{ marginLeft: "1%" }}>Property Address:</h5>
                                <div style={editCss}>
                                  <b className="propertyAddressShow" style={{ fontSize: "16px", color: "#111", fontWeight: 500 }}>{this.state.info.propertyAddress}</b>
                                  <input type="text" className="form-control propertyAddressEdit" placeholder="propertyAddress" id="propertyAddress" name="propertyAddress" style={{ width: "fit-content", display: "none", border: "1px solid gray", height: "30px" }} onChange={(e) => this.handleChange1(e)} onBlur={() => this.AppidSave("propertyAddress")} value={this.state.info.propertyAddress} />
                                  <span><FaRegEdit onClick={() => this.editOption("propertyAddress")} style={{ marginBottom: "6px" }} className="propertyAddressediticon" /></span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div style={{ display: "flex", gap: "15px" }}>
                                {!isEmpty(this.state.info.vetting_complete_status) && (<span className="badge badge-success f-14" style={{ fontSize: "15px" }}>{this.state.info.vetting_complete_status}</span>)}
                                {this.state.info.file_grade == "E" && (<span className="badge badge-warning f-14" style={{ fontSize: "15px", marginTop: "3%" }}>Emergent</span>)}
                              </div>
                              <div style={{ display: "flex", gap: "15px", marginTop: "5px" }}>
                                <span className="badge badge-primary f-14" style={{ fontSize: "15px", marginTop: "3%" }}>{getFileStatus(this.state.info.file_status)}</span>
                                {this.state.info.rectify_status != "" && this.state.info.file_status == "9" && (
                                  <span className="badge f-14 text-white" style={{ fontSize: "15px", marginTop: "3%", background: "linear-gradient(45deg, #e8321f, #e74c3c)" }}>{this.state.info.rectify_status}</span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* ── Action buttons ────────────────────────────────── */}
                          <div style={{ marginTop: "2%" }}>
                            {roleType !== "7" && roleType !== "8" && (
                              <button style={{ margin: "auto" }} className="ml2 btn btn-primary btnupload float-right" data-toggle="modal" data-target="#upload-modal" onClick={this.openUploadModal}>Upload</button>
                            )}
                            {roleType == "7" && takenfile == currentfile && (
                              <button style={{ margin: "auto" }} className="ml2 btn btn-primary btnupload float-right" data-toggle="modal" data-target="#upload-modal" onClick={this.openUploadModal}>Upload</button>
                            )}
                            <button onClick={() => this.handlePopState("back")} className="btn btn-square float-right" style={{ color: "black", border: "1px solid black", borderRadius: "5px" }}>Back</button>
                            {this.state.info.isShowDeviationSummary && (
                              <button data-toggle="modal" data-target="#deviationSummary" style={{ margin: "auto", marginRight: "1%" }} className="btn btn-primary btnupload float-right">Deviation Summary</button>
                            )}
                            {workfileEnable ? (
                              <>
                                {role_id !== FRONTOFFICE_ROLE ? (
                                  <>
                                    {this.state.info.opinion_type != "1" && this.state.info.opinion_type != "0" && this.state.info.opinion_type != null ? (
                                      this.state.info.file_status === "6" ? (
                                        <button className="btn btn-success" data-toggle="modal" data-target="#confirm-complete" onClick={() => this.processComplete("verify")} style={{ marginTop: "0px", float: "right" }}>Verification Completed</button>
                                      ) : this.state.info.file_status != "5" ? (
                                        <button onClick={() => this.processComplete("process")} data-toggle="modal" data-target="#confirm-complete" type="button" className="btn btn-primary" style={{ marginTop: "0px", float: "right" }}>Typing Completed</button>
                                      ) : ""
                                    ) : ""}
                                    {this.state.info.file_status === "9" && (<button className="btn btn-success" onClick={() => this.processComplete("rectify")} style={{ marginTop: "0px", float: "right" }}>Complete</button>)}
                                    <button className="ml2 btn btn-success btnupload float-right" onClick={() => this.OPenToaster()}>Work File</button>
                                    <button className="ml2 btn btn-success btnupload float-right" disabled={this.state.isFlowChartUploading} onClick={() => this.props.history.push("/sale-deed/" + this.props.match.params.id)}>Flowchart</button>
                                    {this.state.query_tree_length < 1 && (<Link to={"/query/add/0/" + this.props.match.params.id} className="btn btn-square btn-info float-right">Raise Query</Link>)}
                                    <button style={{ margin: "auto", marginRight: "1%" }} className="btn btn-primary btnupload float-right" onClick={() => this.getHold()}>Hold Reason</button>
                                  </>
                                ) : (
                                  <>
                                    {role_id == FRONTOFFICE_ROLE && (<><Link to={"/work-file/7/" + this.props.match.params.id} className="btn btn-square btn-success float-right">Work File</Link><button className="ml2 btn btn-success btnupload float-right" onClick={() => this.props.history.push("/sale-deed/" + this.props.match.params.id)}>Flowchart</button></>)}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {role_id !== FRONTOFFICE_ROLE ? (
                                  <>
                                    {this.state.info.opinion_type != "1" && this.state.info.opinion_type != "0" ? (
                                      this.state.info.file_status === "6" ? (
                                        <button className="btn btn-success" data-toggle="modal" data-target="#confirm-complete" onClick={() => this.processComplete("verify")} style={{ marginTop: "0px", float: "right" }}>Verification Completed</button>
                                      ) : this.state.info.file_status != "5" ? (
                                        <button onClick={() => this.processComplete("process")} data-toggle="modal" data-target="#confirm-complete" type="button" className="btn btn-primary" style={{ marginTop: "0px", float: "right" }}>Typing Completed</button>
                                      ) : ""
                                    ) : ""}
                                    {this.state.info.file_status === "9" && (<button className="btn btn-success" onClick={() => this.processComplete("rectify")} style={{ marginTop: "0px", float: "right" }}>Complete</button>)}
                                    <Link to={"/work-file/7/" + this.props.match.params.id} className="btn btn-square btn-success float-right">Work File</Link>
                                    <button className="ml2 btn btn-success btnupload float-right" onClick={() => this.props.history.push("/sale-deed/" + this.props.match.params.id)}>Flowchart</button>
                                    {this.state.query_tree_length < 1 && (<Link to={"/query/add/0/" + this.props.match.params.id} className="btn btn-square btn-info float-right">Raise Query</Link>)}
                                    <button style={{ margin: "auto", marginRight: "1%" }} className="ml2 btn btn-primary btnupload float-right" onClick={() => this.getHold()}>Hold Reason</button>
                                  </>
                                ) : (
                                  <>
                                    {(roleType === "10" || role_id == FRONTOFFICE_ROLE) && (<Link to={"/work-file/7/" + this.props.match.params.id} className="btn btn-square btn-success float-right">Work File</Link>)}
                                    {(roleType === "9" || role_id == FRONTOFFICE_ROLE) && (<Link to={"/work-file/7/" + this.props.match.params.id} className="btn btn-square btn-success float-right">Work File</Link>)}
                                    {role_id == FRONTOFFICE_ROLE && (<button className="ml2 btn btn-success btnupload float-right" onClick={() => this.props.history.push("/sale-deed/" + this.props.match.params.id)}>Flowchart</button>)}
                                  </>
                                )}
                              </>
                            )}
                            {(this.state.info?.file_status === "2" && this.state.info?.query_taken_status == "1" && this.state.query_tree_length > 0) && (
                              <button type="button" className="btn btn-info btnupload float-right" onClick={this.handleFullyQueryReceived}>Fully Query Received</button>
                            )}
                            {(this.state.info?.file_status === "2" && this.state.info?.query_taken_status == "1" && this.state.query_tree_length == 0 && this.state.info.noquery_status == "0") && (
                              <button type="button" className="btn btn-info btnupload float-right" onClick={this.handleMoveToQueue}>Move File to Queue</button>
                            )}
                            <button className="ml2 btn btn-success btnupload float-right" onClick={() => this.props.history.push({ pathname: `/received-query-details/${this.props.match.params.id}`, state: { fileDetails: this.state.mailDetails, fromFileDashboard: true } })}>Mail Details</button>
                            {role_id !== FRONTOFFICE_ROLE && (
                              <div className="template-select" style={{ width: "20em" }}>
                                <Select options={banktemplatesoption} name="bank_id" value={banktemplatesoption.find((o: any) => o.value === this.state.bank_id)} onChange={(e) => this.handleChange(e, "bank_id", "singleselect")} />
                              </div>
                            )}
                            {this.state.info?.is_marked_file && (<span className="badge badge-success f-14" style={{ fontSize: "15px", marginTop: "1%" }}>Marked File</span>)}
                          </div>
                        </div>

                        <div className="card-body">
                          {/* ── Rectification banner ──────────────────────────── */}
                          {isFileRefresh && Rectify_files && Rectify_files.length > 0 ? (
                            <div className="p-3 m-2 mb-5 rectification-container" style={{ background: Rectify_files[0].rectify_status == "2" ? "linear-gradient(45deg, #28a745, #218838)" : "linear-gradient(45deg, #e8321f, #e74c3c)", borderRadius: "10px", boxShadow: "0 0 20px rgba(0,0,0,0.5)", transition: "transform 0.3s, box-shadow 0.3s" }}>
                              <h2 className="text-center font-weight-bold" style={{ color: "white", fontSize: "2rem", marginBottom: "10px", textShadow: "2px 2px 4px rgba(0,0,0,1.8)" }}>Rectification - {Rectify_files[0].count}</h2>
                              <div style={{ color: "white" }}>
                                <div className="row d-flex justify-content-between pl-3 pr-3">
                                  <p style={{ fontSize: "1.3rem", marginBottom: "12px", color: "white" }}>Reason - {Rectify_files[0].reason}</p>
                                  <h4 className="text-center font-weight-bold" style={{ color: "white", fontSize: "1.2rem", marginBottom: "10px", textShadow: "2px 2px 4px rgba(0,0,0,1.8)" }}>{fileWorkType}</h4>
                                </div>
                                <div className="row"><div className="col-md-12">{Rectify_files && Rectify_files[0]?.whatWrong && <p style={{ fontSize: "1.2rem", marginBottom: "12px", color: "white" }}>What's Wrong - {Rectify_files[0].whatWrong}</p>}</div></div>
                                <div className="row"><div className="col-md-12">{Rectify_files && Rectify_files[0]?.whatChange && <p style={{ fontSize: "1.2rem", marginBottom: "12px", color: "white" }}>What to do Change - {Rectify_files[0].whatChange}</p>}</div></div>
                                <div className="row mt-5">
                                  <div className="col-md-4">{Rectify_files[0].created_dt && <p style={{ fontSize: "1rem", marginBottom: "5px" }}><span style={{ fontWeight: "bold" }}>Received date:</span> {Rectify_files[0].created_dt}</p>}</div>
                                  <div className="col-md-4">{Rectify_files[0].completed_dt && <p style={{ fontSize: "1rem", marginBottom: "5px" }}><span style={{ fontWeight: "bold" }}>Completed date:</span> {Rectify_files[0].completed_dt}</p>}</div>
                                  <div className="col-md-2"></div>
                                  <div className="col-md-2">{Rectify_files.length > 0 && <p data-toggle="modal" data-target="#rectify-modal" className="read-more-link">Read more... <i className="fa fa-info-circle" style={{ marginLeft: "5px", fontSize: "1.2rem" }}></i></p>}</div>
                                </div>
                              </div>
                            </div>
                          ) : ""}

                          {(roleType != "16" || (roleType == "16" && fromDeviation == "false")) && (
                            <>
                              {/* ── Status stepper ─────────────────────────────── */}
                              <div className="file-status-container">
                                <ul className="file-status-queue">
                                  <li style={loginStyle}><div className="icon">1</div><div className="title">Login</div></li>
                                  <li style={QueueStyle}><div className="icon">2</div><div className="title">Queue</div></li>
                                  <li style={wipStyle}><div className="icon">3</div><div className="title">W.I.P</div></li>
                                  <li style={QRStyle}><div className="icon">4</div><div className="title">Q.Raised</div></li>
                                  <li style={QreceiveStyle}><div className="icon">5</div><div className="title">Q.Received</div></li>
                                  <li style={TCStyle}><div className="icon">6</div><div className="title">T.Completed</div></li>
                                  <li style={VwipStyle}><div className="icon">7</div><div className="title">V.W.I.P</div></li>
                                  <li style={HoldStyle}><div className="icon">8</div><div className="title">Hold</div></li>
                                  <li style={VcStyle}><div className="icon">9</div><div className="title">V.Completed</div></li>
                                </ul>
                              </div>
                              <div className="row">
                                <DocumentNumber documentdetail={this.state.other} categoryname={"Document"} />
                                <DocumentNumber documentdetail={this.state.ec_doc} categoryname={"EC"} />
                                <DocumentNumber documentdetail={this.state.rev_rec_doc} categoryname={"Revenue Record"} />
                              </div>

                              {/* ── Log accordions ─────────────────────────────── */}
                              <div className="row" style={{ marginBottom: "20px" }}>
                                <div className="col-md-4">
                                  <div className="accordion" id="check-list-log">
                                    <div className="card addon-card">
                                      <a className="accordion-toggle addon-accordion" style={{ backgroundColor: "white" }} data-toggle="collapse" data-parent="#check-list-log" href="#checkListLog">
                                        <div className="card-header" style={{ borderBottomWidth: "0px", padding: "0px", justifyContent: "space-between", display: "flex" }} onClick={async () => { await this.getcheckListLogData(); this.setState({ isCheckListLogShown: !isCheckListLogShown }); }}>
                                          <h5 style={{ paddingLeft: "5px", paddingRight: "5px", fontWeight: "bold" }}>Check List</h5>
                                          <i className={`icon feather icon-${isCheckListLogShown ? "minus" : "plus"}`} style={{ color: "black", fontSize: "17px", fontWeight: "bold" }} />
                                        </div>
                                      </a>
                                      <div id="checkListLog" className="panel-body collapse" style={{ maxHeight: "475px", height: "auto", overflowX: "hidden" }}>
                                        <div className="card-body">{this.renderDetailsCard("CHECKLIST", this.state.checkListLog)}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="accordion" id="download-reason">
                                    <div className="card addon-card">
                                      <a className="accordion-toggle addon-accordion" style={{ backgroundColor: "white" }} data-toggle="collapse" data-parent="#download-reason" href="#downloadReason" onClick={() => this.getUpdateReasonData()}>
                                        <div className="card-header" style={{ borderBottomWidth: "0px", padding: "0px", justifyContent: "space-between", display: "flex" }} onClick={() => this.setState({ isReasonForDownloadShown: !isReasonForDownloadShown })}>
                                          <h5 style={{ paddingLeft: "5px", paddingRight: "5px", fontWeight: "bold" }}>Reason for download</h5>
                                          <i className={`icon feather icon-${isReasonForDownloadShown ? "minus" : "plus"}`} style={{ color: "black", fontSize: "17px", fontWeight: "bold" }} />
                                        </div>
                                      </a>
                                      <div id="downloadReason" className="panel-body collapse" style={{ maxHeight: "475px", height: "auto", overflowX: "hidden" }}>
                                        <div className="card-body">{this.renderDetailsCard("DOWNLOAD", updateDownloadData.reasonForDownload)}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {updateDownloadData ? (
                                  <div className="col-md-4">
                                    <div className="accordion" id="update-details">
                                      <div className="card addon-card">
                                        <a className="accordion-toggle addon-accordion" style={{ backgroundColor: "white" }} onClick={() => this.getUpdateReasonData()} data-toggle="collapse" data-parent="#update-details" href="#updateDetails">
                                          <div className="card-header" style={{ borderBottomWidth: "0px", padding: "0px", justifyContent: "space-between", display: "flex" }}>
                                            <h5 style={{ paddingLeft: "5px", paddingRight: "5px", fontWeight: "bold" }} onClick={() => this.setState({ isUpdateDownloadShown: !isUpdateDownloadShown })}>Updated Details</h5>
                                            <div>
                                              {this.state.blockdownload == "false" && (<button className="btn btn-outline-dark btn-sm" onClick={() => this.actionHandle("upload")} data-toggle="modal" data-target="#reason-modal1">Upload Report <i className="fa fa-upload" /></button>)}
                                              <i className={`icon feather icon-${isUpdateDownloadShown ? "minus" : "plus"}`} style={{ color: "black", fontSize: "17px", fontWeight: "bold" }} />
                                            </div>
                                          </div>
                                        </a>
                                        <div id="updateDetails" className="panel-body collapse" style={{ maxHeight: "475px", height: "auto", overflowX: "hidden" }}>
                                          <div className="card-body">{this.renderDetailsCard("UPDATE", updateDownloadData.updatedDetails)}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="row" style={{ marginBottom: "20px" }}>
                                <div className="col-md-4">
                                  <div className="accordion" id="mail-trigger-log">
                                    <div className="card addon-card">
                                      <a className="accordion-toggle addon-accordion" style={{ backgroundColor: "white" }} data-toggle="collapse" data-parent="#mail-trigger-log" href="#autoMailTriggerLog">
                                        <div className="card-header" style={{ borderBottomWidth: "0px", padding: "0px", justifyContent: "space-between", display: "flex" }} onClick={async () => { await this.getAutoMailTriggerLogData(); this.setState({ isAutoMailLogShown: !isAutoMailLogShown }); }}>
                                          <h5 style={{ paddingLeft: "5px", paddingRight: "5px", fontWeight: "bold" }}>Auto Mail Trigger Log</h5>
                                          <i className={`icon feather icon-${isAutoMailLogShown ? "minus" : "plus"}`} style={{ color: "black", fontSize: "17px", fontWeight: "bold" }} />
                                        </div>
                                      </a>
                                      <div id="autoMailTriggerLog" className="panel-body collapse" style={{ maxHeight: "475px", height: "auto", overflowX: "hidden" }}>
                                        <div className="card-body">{this.renderAutoMailTriggerLogCard("CHECKLIST", this.state.autoMailTriggerLog)}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4"></div><div className="col-md-4"></div>
                              </div>

                              {/* ── Stats row ──────────────────────────────────── */}
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="card table-card">
                                    <div className="row-table">
                                      <div className={`card-body-big br ${autoMail ? 'col-sm-3' : 'col-sm-4'}`}>
                                        <div className="row"><div className="col-sm-2"><i className="icon feather icon-eye text-c-green mb-1 d-block" /></div><div className="col-sm-10 text-md-center"><h5>Original verification</h5><span>{this.state.info.verify}</span></div></div>
                                      </div>
                                      <div className={`card-body-big br ${autoMail ? 'col-sm-3' : 'col-sm-4'}`}>
                                        <div className="row"><div className="col-sm-2"><i className="icon feather icon-file-text text-c-red mb-1 d-block" /></div><div className="col-sm-10 text-md-center"><h5>Report Status</h5><span>{this.state.info.report_status}</span></div></div>
                                      </div>
                                      <div className={`card-body-big br ${autoMail ? 'col-sm-3' : 'col-sm-4'}`}>
                                        <div className="row"><div className="col-sm-2"><i className="icon feather icon-help-circle text-c-yellow mb-1 d-block" /></div><div className="col-sm-10 text-md-center"><h5>Query Request</h5><span className="text-c-red">Pending - {this.state.info.pending}</span><span className="text-c-green"> / Closed - {this.state.info.closed}</span><span className="text-c-info"> / Total - {this.state.info.total}</span></div></div>
                                      </div>
                                      {autoMail && (
                                        <div className="col-sm-3 card-body-big">
                                          <div className="row">
                                            <div className="col-sm-12 text-md-center">
                                              <div className="d-flex justify-content-center align-items-center mb-2" style={{ gap: "15px" }}>
                                                <h6>Report Shared Manually</h6>
                                                <button onClick={this.showUploadConfirmation} disabled={!this.state.hasCheckedItem} style={{ padding: '5px', backgroundColor: !this.state.hasCheckedItem ? '#cccccc' : '#1890ff', color: 'white', border: 'none', borderRadius: '4px', cursor: !this.state.hasCheckedItem ? 'not-allowed' : 'pointer', opacity: !this.state.hasCheckedItem ? 0.5 : 1, fontSize: '14px' }}>Send Report</button>
                                              </div>
                                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, auto)', gap: '30px', justifyContent: 'center', marginTop: '20px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                {this.state.pageDynamic.map((page: any, index: any) => {
                                                  if (page.page_name === "Manual Mail Send PDF" && page.status == true) return (
                                                    <div key={`pdf-${index}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', opacity: this.state.selectedFiles.pdf ? 1 : 0.5 }} onClick={() => this.handleFileSelect('pdf')}>
                                                      <div style={{ position: 'relative' }}><FaRegFilePdf style={{ fontSize: "22px" }} />{this.state.selectedFiles.pdf && <div style={{ position: 'absolute', top: '-5px', right: '-5px', backgroundColor: '#1890ff', borderRadius: '50%', width: '15px', height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ color: 'white', fontSize: '10px' }}>✓</span></div>}</div>
                                                      <span style={{ fontSize: '10px', marginTop: '6px' }}>Send <br /> PDF</span>
                                                    </div>
                                                  );
                                                  else if (page.page_name === "Manual Mail Send Word" && page.status == true) return (
                                                    <div key={`word-${index}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', opacity: this.state.selectedFiles.word ? 1 : 0.5 }} onClick={() => this.handleFileSelect('word')}>
                                                      <div style={{ position: 'relative' }}><PiFileDocDuotone style={{ fontSize: "26px" }} />{this.state.selectedFiles.word && <div style={{ position: 'absolute', top: '-5px', right: '-5px', backgroundColor: '#1890ff', borderRadius: '50%', width: '15px', height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ color: 'white', fontSize: '10px' }}>✓</span></div>}</div>
                                                      <span style={{ fontSize: '10px', marginTop: '6px' }}>Send Word</span>
                                                    </div>
                                                  );
                                                  else if (this.state.info.file_status == "7" && page.page_name === "Manual Mail Send Preliminary PDF" && page.status == true) return (
                                                    <div key={`preliminary-${index}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', opacity: this.state.selectedFiles.preliminary ? 1 : 0.5 }} onClick={() => this.handleFileSelect('preliminary')}>
                                                      <div style={{ position: 'relative' }}><PiFileDocDuotone style={{ fontSize: "26px" }} />{this.state.selectedFiles.preliminary && <div style={{ position: 'absolute', top: '-5px', right: '-5px', backgroundColor: '#1890ff', borderRadius: '50%', width: '15px', height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ color: 'white', fontSize: '10px' }}>✓</span></div>}</div>
                                                      <span style={{ fontSize: '10px', marginTop: '6px' }}>Preliminary PDF</span>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {/* ── Flowchart preview ─────────────────────────────── */}
                          {this.state.flowChartPreview ? (
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="card query-card">
                                  <div className="card-header d-flex align-items-center justify-content-between">
                                    <h5>Flowchart</h5>
                                    <button className="ml2 btn btn-danger btnupload float-right" disabled={this.state.isFlowChartUploading} onClick={this.deleteFlowChart}>{this.state.isFlowChartUploading && <i className="fa fa-spinner fa-spin"></i>}Delete</button>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "center" }}><img src={this.state.flowChartPreview} className="img-fluid" alt="flowchart" style={{ padding: "5%" }} /></div>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {/* ── Query table & add ─────────────────────────────── */}
                          <div className="row">
                            <div className="col-md-12">
                              {isRaiseQueryShown && newQueryList && (
                                <div className="raise-query-style" style={{ marginTop: "4%", flex: 1 }}>
                                  <QueryAdd addnewQueryList={newQueryList} handleChange={this.handleChangequery} handleDetailsChange={this.handleDetailsChange} removeReply={this.removeReply} newaddrequery={this.newaddrequery} queryreason={this.state.reasons} />
                                </div>
                              )}
                              {this.state.queryTableData?.length > 0 && (
                                <QueryTable history={this.props.history} match={this.props.match} newaddrequery={this.newaddrequery} addrequery={this.addrequery} Completequery={this.CompleteConfirm} queryTableData={this.state.queryTableData} />
                              )}
                            </div>
                          </div>

                          {/* ── Query manage ──────────────────────────────────── */}
                          {(roleType != "16" || (roleType == "16" && fromDeviation == "false")) && (
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="card query-card">
                                  <div className="card-header d-flex justify-content-between">
                                    <h5>Query Management</h5>
                                    <div className="d-flex query-management-actions">
                                      {this.state.deviationTakenQuerys.length > 0 && (<button type="button" className="btn btn-info btn-sm" data-toggle="modal" data-target="#deviationModal">Request Deviation</button>)}
                                      {this.state.query_tree_length < 1 && this.state.info.noquery_status == "0" && (<button type="button" className="btn btn-info btn-sm" data-toggle="modal" data-target="#no-query">No Query</button>)}
                                      {this.state.info.file_status == "9" && this.state.info.rectify_noquery_status == "1" && (<button type="button" className="btn btn-info btn-sm" data-toggle="modal" data-target="#no-query">No Query</button>)}
                                      {this.state?.info?.total > '0' && (<button type="button" className="btn btn-sm query-management-btn query-management-btn-raise" onClick={this.addReplyQueryList}>Raise Query</button>)}
                                      <ReactFileReader fileTypes={[".pdf"]} base64={true} multipleFiles={true} handleFiles={(e) => this.handleFiles(e)}><button type="button" className="btn btn-sm query-management-btn query-management-btn-upload">Upload Document</button></ReactFileReader>
                                      <button type="button" className="btn btn-sm query-management-btn query-management-btn-submit" onClick={() => this.updateNewQueryList()}>Submit All</button>
                                    </div>
                                  </div>
                                  <div className="card-body p-0">
                                    <div>
                                      {this.state.queryBase && this.state.queryBase.length ? this.state.queryBase.map((itm: any, index: number) => (
                                        <div key={index}>
                                          <div className="card card-border-c-green">
                                            <span onClick={() => this.deleteDoc(itm, index)}><i className="feather icon-x cursor-pointer" /></span>
                                            <div className="card-body">
                                              <h5 className="card-title">
                                                <span className="mb-1 text-c-green"><i className="feather icon-file-text" /></span>
                                                <span style={{ fontSize: "14px" }}>{itm.fileName || ""}</span>
                                                <span style={{ float: "right" }} className="cursor-pointer" data-toggle="modal" data-target="#preview-document" onClick={() => this.previewDoc(itm)}><i className="fa fa-eye" /></span>
                                              </h5>
                                            </div>
                                          </div>
                                        </div>
                                      )) : ""}
                                    </div>
                                   
                                    <div className="mb-3" style={{ padding: "0 12px" }}>
                                      {/* <QueryTableComponent fod_fk={this.props.match.params.id} history={this.props.history} ref={this.query} setSelectedItem={(item) => this.setSelectedItem(item)} getRepliedQueries={this.repliedQueries} getDeviationQueryData={this.getDeviationQueryData} getnewquery={this.getNewQuery} queryreason={this.state.reasons} newQueryValidatedList={this.state.newQueryValidatedList} /> */}
                                      {/* <QueryTableDemoComponent fod_fk={this.props.match.params.id} /> */}
                                      {/* <QueryTableClientExpectedComponent fod_fk={this.props.match.params.id} getRepliedQueries={this.repliedQueries} queryreason={this.state.reasons} /> */}
                                      <QueryTableComponent
                                        fod_fk={this.props.match.params.id}
                                        getRepliedQueries={this.repliedQueries}
                                        queryreason={this.state.reasons}
                                        setSelectedItem={(item) => this.setSelectedItem(item)}
                                        getDeviationQueryData={this.getDeviationQueryData}
                                        pageDynamicList={this.state.pageDynamic}
                                        isReplyRaiseQueryShown={isReplyRaiseQueryShown}
                                        replyQueryList={replyQueryList}
                                        onReplyQueryChange={this.handleReplyQueryChange}
                                        onReplyDetailsChange={this.handleReplyDetailsChange}
                                        onReplyRemove={this.removeReplyQuery}
                                        onReplyAdd={this.addReplyQueryList}
                                      />
                                    </div>
                                    {/* <QueryTree fod_fk={this.props.match.params.id} history={this.props.history} ref={this.query} setSelectedItem={(item) => this.setSelectedItem(item)} getRepliedQueries={this.repliedQueries} getDeviationQueryData={this.getDeviationQueryData} getnewquery={this.getNewQuery} queryreason={this.state.reasons} newQueryValidatedList={this.state.newQueryValidatedList} /> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ════════════════════ UPLOAD MODAL ════════════════════════════════════ */}
        <div className="modal fade" id="upload-modal" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-lg" style={{ maxWidth: "1400px" }} role="document">
            <div className="modal-content" style={{ height: "90vh" }}>
              <div className="modal-header">
                <h5 className="modal-title">Upload File</h5>
                {!this.state.trayPendingMailBlockActive ? (
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                ) : null}
              </div>
              <div className="modal-body" style={{ height: "90vh", overflowY: "scroll" }}>
                <div className="mt-4 query-client-given-wrapper query-upload-modal-section">
                  <div className="query-upload-section-head query-upload-section-head-single">
                    <h6 className="mb-0">Pending Queries</h6>
                  </div>
                  <div className="table-responsive query-upload-table-wrap">
                    <table className="table query-client-given-table query-upload-modal-table">
                      <thead>
                        <tr>
                          <th className="query-upload-sl-col">SL</th>
                          <th className="query-upload-query-col">Query</th>
                          <th>Reason</th>
                          <th>Count</th>
                          <th>Raised On</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayPendingUploadQueries.length > 0 ? (
                          this.renderUploadModalQueryRows(displayPendingUploadQueries)
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center">No pending queries</td>
                          </tr>
                        )}
                        {Array.isArray(this.state.base) &&
                          this.state.base
                            .map((document: any, index: number) => ({ document, index }))
                            .filter(({ document }: any) => !String(document?.query_id || "").trim())
                            .map(({ document, index }: any) => (
                              <tr key={`extra-upload-row-${index}`} className="query-client-expanded-row">
                                <td colSpan={7}>
                                  <DashUploadDocument
                                    key={index}
                                    baseDetails={document}
                                    handleDocumentDetailsChange={this.handleDocumentDetailsChange}
                                    handleDocumentFilesChange={this.handleDocumentFilesChange1}
                                    deleteDocumentDetails={this.deleteDocumentDetails}
                                    deleteFile={this.deleteFile}
                                    deedList={this.state.deeds}
                                    previewDoc={this.previewDoc}
                                    categoriesList={this.state.categoriesList}
                                    index={index}
                                    newfile={this.state.isNewFile}
                                    path="filedashboard"
                                    state={this.state}
                                    isbtnload={this.state.isbtnload}
                                  />
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {this.state.isQueryTrayFeatureEnabled ? (
                  <QueryTray
                    items={displayQueryTrayItems}
                    base={this.state.base || []}
                    expandedId={this.state.uploadTrayExpandedId}
                    categoriesList={this.state.categoriesList}
                    deeds={this.state.deeds}
                    isNewFile={this.state.isNewFile}
                    isbtnload={this.state.isbtnload}
                    dashboardState={this.state}
                    onAddExtraDocument={() => this.addUploadDocument()}
                    onAddUploadDocumentForTray={this.addUploadDocumentForTray}
                    onToggleExpand={(expandKey) =>
                      this.setState((prevState: any) => ({
                        uploadTrayExpandedId:
                          prevState.uploadTrayExpandedId === expandKey ? "" : expandKey,
                      }))
                    }
                    onOpenHint={(query) =>
                      this.setState({ uploadHintQuery: query, uploadHintText: "" })
                    }
                    onRemoveTrayDocument={this.removeQueryTrayDocument}
                    onDocumentDetailsChange={this.handleDocumentDetailsChange}
                    onDocumentFilesChange={this.handleDocumentFilesChange1}
                    onDeleteDocumentDetails={this.deleteDocumentDetails}
                    onDeleteFile={this.deleteFile}
                    previewDoc={this.previewDoc}
                  />
                ) : null}

                {this.state.uploadHintQuery ? (
                  <div className="dialog-modal" role="dialog" aria-hidden="true" onClick={() => this.setState({ uploadHintQuery: null, uploadHintText: "" })}>
                    <div className="dialog-modal-body" role="document" onClick={(e) => e.stopPropagation()}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add Hint</h5>
                          <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ uploadHintQuery: null, uploadHintText: "" })}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="form-group mb-0">
                            <textarea
                              className="form-control"
                              rows={4}
                              placeholder="Type hint..."
                              value={this.state.uploadHintText}
                              onChange={(e) => this.setState({ uploadHintText: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" onClick={() => this.setState({ uploadHintQuery: null, uploadHintText: "" })}>Cancel</button>
                          <button type="button" className="btn btn-primary" onClick={() => this.addHintForUploadPendingQuery(this.state.uploadHintQuery)}>Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.state.uploadSendMailPreviewOpen ? (
                  <div className="dialog-modal" role="dialog" aria-hidden="true" onClick={() => this.setState({ uploadSendMailPreviewOpen: false, uploadSendMailPreviewQueries: [] })}>
                    <div className="dialog-modal-body" role="document" onClick={(e) => e.stopPropagation()}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Send Mail — Selected Queries</h5>
                          <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ uploadSendMailPreviewOpen: false, uploadSendMailPreviewQueries: [] })}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p className="text-muted mb-3">Design preview only — mail will not be sent until API integration is added.</p>
                          <ul className="query-tray-mail-preview-list">
                            {(this.state.uploadSendMailPreviewQueries || []).map((query: any, index: number) => (
                              <li key={`mail-preview-${query?.id || index}`}>
                                <strong>{query?.title || "Untitled Query"}</strong>
                                <span>{query?.reason || "-"}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" onClick={() => this.setState({ uploadSendMailPreviewOpen: false, uploadSendMailPreviewQueries: [] })}>Cancel</button>
                          <button type="button" className="btn btn-primary" onClick={this.confirmUploadSendMailPreview}>Confirm Send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.state.trayPendingMailModalOpen ? (
                  <div className="dialog-modal" role="dialog" aria-hidden="false" style={{ zIndex: 2000 }}>
                    <div className="dialog-modal-body" role="document" style={{ maxWidth: "560px" }} onClick={(e) => e.stopPropagation()}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Send Pending Queries</h5>
                        </div>
                        <div className="modal-body">
                          <p>
                            Uploaded documents are saved in tray. The following pending queries will be sent by mail.
                            Please click Send to continue.
                          </p>
                          <ul className="query-tray-mail-preview-list">
                            {(this.state.trayPendingMailQueries || []).map((query: any, index: number) => (
                              <li key={`tray-pending-mail-${query?.id || index}`}>
                                <strong>{query?.title || "Untitled Query"}</strong>
                                <span>{query?.reason || "-"}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.trayPendingMailSending}
                            onClick={() => this.sendTrayPendingQueriesMail()}
                          >
                            {this.state.trayPendingMailSending ? (
                              <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Sending...</>
                            ) : (
                              "Send"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="modal-footer query-upload-footer" style={{ border: "none" }}>
                  <div className="query-upload-footer-actions">
                    <button
                      type="button"
                      className="btn query-upload-footer-btn query-upload-footer-btn-cancel"
                      data-dismiss={this.state.trayPendingMailBlockActive ? undefined : "modal"}
                      disabled={this.state.trayPendingMailBlockActive}
                      onClick={this.closeuploadfile}
                    >
                      <i className="fa fa-times-circle" aria-hidden="true"></i>
                      <span>Cancel</span>
                    </button>
                    {this.canShowMoveToProcessButton() ? (
                      <button
                        type="button"
                        className="btn query-upload-footer-btn query-upload-footer-btn-process"
                        disabled={this.state.uploadbtn || this.state.isTraySaving || this.state.trayPendingMailBlockActive}
                        onClick={() => this.handleMoveToProcessFromFooter()}
                      >
                        {this.state.uploadbtn ? <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> : <i className="fa fa-arrow-right" aria-hidden="true"></i>}
                        <span>Move to Process</span>
                      </button>
                    ) : null}
                    {this.canShowSaveToTrayButton() ? (
                      <button
                        type="button"
                        className="btn query-upload-footer-btn query-upload-footer-btn-save"
                        disabled={this.state.isTraySaving || this.state.uploadbtn || this.state.trayPendingMailBlockActive}
                        onClick={() => this.handleSaveToTrayFromFooter(eligiblePendingTrayQueries)}
                      >
                        {this.state.isTraySaving ? <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> : <i className="fa fa-inbox" aria-hidden="true"></i>}
                        <span>Save to Tray</span>
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* All remaining modals — kept exactly as original ─────────────────────── */}
        <div className="modal fade" id="deviationSummary" tabIndex={-1} role="dialog" aria-labelledby="deviationSummaryLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog" role="document"><div className="modal-content">
            <div className="modal-header"><h5>Deviation Summary</h5></div>
            <div className="modal-body">
              <div className="form-group">
                <label>Devition Taken <span style={{ color: "red" }}>*</span></label>
                <div className="d-flex align-items-center mt-2">
                  <div className="form-check me-3"><input type="radio" className="form-check-input" id="dtYes" name="deviationTaken" value="Yes" onChange={(e) => this.handleDeviationChange(e.target.value, "deviationTaken")} checked={this.state.deviationSummaryDetails.deviationTaken === "Yes"} /><label className="form-check-label" htmlFor="dtYes">Yes</label></div>
                  <div className="form-check" style={{ marginLeft: "10px" }}><input type="radio" className="form-check-input" id="dtNo" name="deviationTaken" value="No" onChange={(e) => this.handleDeviationChange(e.target.value, "deviationTaken")} checked={this.state.deviationSummaryDetails.deviationTaken === "No"} /><label className="form-check-label" htmlFor="dtNo">No</label></div>
                </div>
                {isEmpty(this.state.deviationSummaryDetails.deviationTaken) && this.state.deviationSummaryDetails.deviationRequired && (<div className="invalid-feedback d-block">*Required Field</div>)}
              </div>
              {this.renderSelectOrInput("Deviation Sumarry", "deviationSummary", this.state.deviationSummaryList, 'multiselect')}
              <div className="form-group">
                <label>Knowledge Assessment Mark <span style={{ color: "red" }}>*</span></label>
                <Select options={assessmentMarkList} className={this.state.deviationSummaryDetails?.deviationRequired && this.state.deviationSummaryDetails.knowledgeAssessment === "" ? "form-select is-invalid" : "form-select"} value={assessmentMarkList.find((o: any) => o.value == this.state?.deviationSummaryDetails?.knowledgeAssessment) || null} onChange={(e) => this.handleDeviationChange((e as any).value, "knowledgeAssessment", "singleselect")} />
                <div className="invalid-feedback">*Required Field</div>
              </div>
              <div className="form-group">
                <label>Training Needed <span style={{ color: "red" }}>*</span></label>
                <div className="d-flex align-items-center mt-2">
                  <div className="form-check me-3"><input type="radio" className="form-check-input" id="tnYes" name="trainingNeeded" value="Yes" onChange={(e) => this.handleDeviationChange(e.target.value, "trainingNeeded")} checked={this.state.deviationSummaryDetails.trainingNeeded === "Yes"} /><label className="form-check-label" htmlFor="tnYes">Yes</label></div>
                  <div className="form-check" style={{ marginLeft: "10px" }}><input type="radio" className="form-check-input" id="tnNo" name="trainingNeeded" value="No" onChange={(e) => this.handleDeviationChange(e.target.value, "trainingNeeded")} checked={this.state.deviationSummaryDetails.trainingNeeded === "No"} /><label className="form-check-label" htmlFor="tnNo">No</label></div>
                </div>
                {isEmpty(this.state.deviationSummaryDetails.trainingNeeded) && this.state.deviationSummaryDetails.deviationRequired && (<div className="invalid-feedback d-block">*Required Field</div>)}
              </div>
              {this.renderSelectOrInput("Traing to whom", "trainingToWhom", this.state.deviationTrainingToWhomList, 'multiselect')}
              {this.renderSelectOrInput("Training Area", "trainingArea", this.state.deviationTrainingAreaList, 'multiselect')}
              <div className="form-group">
                <label>Special File Need Training for process Team <span style={{ color: "red" }}>*</span></label>
                <div className="d-flex align-items-center mt-2">
                  <div className="form-check me-3"><input type="radio" className="form-check-input" id="sfYes" name="specialFileNeeded" value="Yes" onChange={(e) => this.handleDeviationChange(e.target.value, "specialFileNeeded")} checked={this.state.deviationSummaryDetails.specialFileNeeded === "Yes"} /><label className="form-check-label" htmlFor="sfYes">Yes</label></div>
                  <div className="form-check" style={{ marginLeft: "10px" }}><input type="radio" className="form-check-input" id="sfNo" name="specialFileNeeded" value="No" onChange={(e) => this.handleDeviationChange(e.target.value, "specialFileNeeded")} checked={this.state.deviationSummaryDetails.specialFileNeeded === "No"} /><label className="form-check-label" htmlFor="sfNo">No</label></div>
                </div>
                {isEmpty(this.state.deviationSummaryDetails.specialFileNeeded) && this.state.deviationSummaryDetails.deviationRequired && (<div className="invalid-feedback d-block">*Required Field</div>)}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.clearDeviationSummaryState()}>Cancel</button>
              <button type="button" className="btn btn-primary" onClick={() => this.deviationSummarySubmit()}>{this.state.isDeviationSummaryLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}</button>
            </div>
          </div></div>
        </div>

        {/* preview-checklist, preview-pdf, processComplete, complete-process, confirm-complete, rectify-modal, no-query, view-reasson, reason-modal, reason-modal1, send-mail, preview-tempdocToPreview, preview-document, in_time, another-reason, deviationModal, showPopup dialog, file_not_complete_modal — all kept exactly as original */}
        <div className="modal fade" id="preview-checklist" role="dialog" aria-hidden="true"><div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1400px" }}><div className="modal-content" style={{ height: "90vh" }}><div className="modal-header"><h5 className="modal-title">Preview Checklist</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div className="modal-body" style={{ height: "calc(90vh - 120px)", overflowY: "auto", overflowX: "hidden" }}>{this.state.selectedChecklistItem && <PreviewChecklist data={this.state.selectedChecklistItem} />}</div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.setState({ selectedChecklistItem: null })}>Close</button></div></div></div></div>
        <div className="modal fade" id="preview-pdf" role="dialog" aria-hidden="true"><div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1400px" }}><div className="modal-content" style={{ height: "90vh" }}><div className="modal-header"><h5 className="modal-title">Document Preview</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div className="modal-body"><iframe width="100%" height="100%" src={this.state.pdfToPreview}></iframe></div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.setState({ pdfToPreview: "" })}>Close</button></div></div></div></div>
        <div className="modal hide fade in" id="processComplete" data-backdrop="static" data-keyboard="false"><div className="modal-dialog"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}><div className="modal-body"><h5 style={{ textAlign: "center" }}>Thanks For Complete Your File:{this.props.match.params.id}</h5></div><div className="modal-footer">{showTitle ? null : (<button type="button" className="btn btn-success" onClick={() => this.close()} style={{ width: "50%", fontSize: "17px", margin: "auto" }}>Ok</button>)}</div></div></div></div>
        <div className="modal" id="complete-process"><div className="modal-dialog"><div className="modal-content"><div className="modal-body"><h3>Without upload document you can't complete the file</h3></div><div className="modal-footer"><button type="button" className="btn btn-primary" data-dismiss="modal">Ok</button></div></div></div></div>
        <div className="modal" id="confirm-complete" role="dialog" aria-hidden="true"><div className="modal-dialog modal-lg" role="document"><div className="modal-content"><div className="modal-header"><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div className="modal-body d-flex" style={{ justifyContent: "center" }}><h5 className="modal-title">Are You Sure You Want to Complete this File?</h5></div><div className="modal-footer">{this.state.isprocesscomplete ? (<button type="button" className="btn btn-primary" onClick={() => this.confirmComplete("6", "typing")}>Yes</button>) : this.state.isverifycomplete ? (<button type="button" className="btn btn-primary" onClick={() => this.confirmComplete("5", "verification")}>Yes</button>) : this.state.isrectifycomplete ? (<button type="button" className="btn btn-primary" onClick={() => this.confirmComplete("5", "rectify")}>Yes</button>) : null}<button type="button" className="btn btn-primary" data-dismiss="modal">No</button></div></div></div></div>
        <div className="modal fade bd-example-modal-lg" id="rectify-modal" tabIndex={-1} role="dialog" aria-hidden="true"><div className="modal-dialog" style={{ maxWidth: "1400px", maxHeight: "660px", overflow: "hidden" }} role="document"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}><div className="modal-header" style={{ backgroundColor: "#007bff", color: "white", borderBottom: "none", borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}><h5 className="modal-title" style={{ textAlign: "center", color: "white" }}>Rectification Details</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ color: "white" }}>&times;</span></button></div><div className="modal-body" style={{ backgroundColor: "#f8f9fa", padding: "20px", borderRadius: "8px", maxHeight: "670px", overflowY: "scroll" }}><div className="dt-responsive table-responsive"><table className="table table-striped table-bordered table-hover"><thead className="thead sticky-table-header" style={{ background: "#d9d9d9" }}><tr style={{ fontSize: "14px" }}><th scope="col" className="text-center th">S.no</th><th scope="col" className="text-center th">Received Date & Time</th><th scope="col" className="text-center th">Completed Date & Time</th><th scope="col" className="text-center th">Reason</th><th scope="col" className="text-center th">What's Wrong</th><th scope="col" className="text-center th">What to do Change</th></tr></thead><tbody className="tbody">{Rectify_files && Rectify_files.map((rectify: any, index: any) => (<tr key={index}><td className="text-center td">{index + 1}</td><td className="text-center td" style={{ width: "10%", padding: "1%" }}>{rectify.created_dt}</td><td className="text-center td" style={{ width: "10%", padding: "1%" }}>{rectify.completed_dt}</td><td className="text-center td" style={{ width: "30%", padding: "1%" }}>{rectify.reason}</td><td className="text-center td" style={{ width: "30%", padding: "1%" }}>{rectify.whatWrong}</td><td className="text-center td" style={{ width: "90%", padding: "1%" }}>{rectify.whatChange}</td></tr>))}</tbody></table></div></div><div className="modal-footer" style={{ border: "none", backgroundColor: "#f8f9fa", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}></div></div></div></div>
        <div className="modal" id="no-query"><div className="modal-dialog"><div className="modal-content"><div className="modal-body"><div className="row"><div className="col-md-12"><h4 className="modal-title">Are you sure?</h4></div></div></div><div className="modal-footer"><button type="button" className="btn btn-danger" data-dismiss="modal">No</button><button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => { this.noRaiseQuery(); }}>Yes</button></div></div></div></div>
        <div className="modal fade bd-example-modal-lg" id="view-reasson" tabIndex={-1} role="dialog" aria-hidden="true"><div className="modal-dialog" style={{ maxWidth: "1400px", maxHeight: "660px", overflow: "hidden" }} role="document"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}><div className="modal-header" style={{ backgroundColor: "#007bff", color: "white", borderBottom: "none", borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}><h5 className="modal-title" style={{ textAlign: "center", color: "white" }}>Hold & Unhold Details</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ color: "white" }}>&times;</span></button></div><div className="modal-body" style={{ backgroundColor: "#f8f9fa", padding: "20px", borderRadius: "8px", maxHeight: "670px", overflowY: "scroll" }}><div className="dt-responsive table-responsive"><table className="table table-striped table-bordered table-hover"><thead className="thead sticky-table-header" style={{ background: "#d9d9d9" }}><tr style={{ fontSize: "14px" }}><th scope="col" className="text-center th">S.no</th><th scope="col" className="text-center th">Hold Data</th><th scope="col" className="text-center th">Hold By</th><th scope="col" className="text-center th">Hold Reason</th><th scope="col" className="text-center th">Unhhold Data</th><th scope="col" className="text-center th">Unhold By</th><th scope="col" className="text-center th">Unhold Reason</th></tr></thead><tbody className="tbody">{this.state.holdDetails && this.state.holdDetails.map((data: any, index: any) => (<tr key={index}><td className="text-center td">{index + 1}</td><td className="text-center td">{data.hold_dt}</td><td className="text-center td">{data.hold_by}</td><td className="text-center td" style={{ width: "25%", padding: "1%" }}>{data.hold_reason}</td><td className="text-center td">{data.unhold_dt}</td><td className="text-center td">{data.unhold_by}</td><td className="text-center td" style={{ width: "25%", padding: "1%" }}>{data.unhold_reason}</td></tr>))}</tbody></table></div></div><div className="modal-footer" style={{ border: "none", backgroundColor: "#f8f9fa", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}><button type="button" className="btn btn-secondary" data-dismiss="modal">close</button></div></div></div></div>
        <div className="modal fade" id="reason-modal" role="dialog" aria-hidden="true"><div className="modal-dialog" role="document"><div className="modal-content"><div className="modal-header"><h5 className="modal-title">Confirm Status</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div className="modal-body"><div className="form-group"><textarea name="reason" className="form-control" onChange={(e) => this.handleChange(e)} value={this.state.reason} placeholder="Reason" /></div></div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button><button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.submitReason}>Confirm</button></div></div></div></div>
        <div className="modal" id="reason-modal1"><div className="modal-dialog"><div className="modal-content"><div className="modal-header"><h5 className="modal-title">Reason For Upload</h5><button type="button" className="close" data-dismiss="modal">&times;</button></div><div className="modal-body"><div><React.Fragment><label>Enter Updated Informations*</label><ReactFileReader fileTypes={[".doc", ".docx"]} base64={true} handleFiles={(e) => this.uploadFile(e)}><button className="ml2 btn btn-success btnupload">Select File</button></ReactFileReader><span>{uploadFile.fileList[0].name}</span></React.Fragment><textarea className="form-control mt-10" name="reason" value={reason} onChange={this.handleReasonChange}></textarea></div></div><div className="modal-footer"><button type="button" className="btn" data-dismiss="modal">Cancel</button><button type="button" className="btn btn-primary" onClick={this.validateReason}>Upload</button></div></div></div></div>
        <div className="modal" id="send-mail"><div className="modal-dialog modal-lg"><div className="modal-content"><div className="modal-header"><h4 className="modal-title">Send Mail</h4><button type="button" className="close" data-dismiss="modal">&times;</button></div><div className="modal-body">{!quesSubmitted && (<div className="query-question"><div className="row">{queryQues.map((ques: any, index) => (<div className="col-md-6" key={index}><div className="question"><p>{ques.query_question}</p><div className="row"><div className="col-md-3"><div className="custom-control custom-checkbox"><input type="radio" className="" name={`answer-${index}`} checked={ques.answer} onChange={() => this.handleAnswerChange(index, true)} /><label className="">Yes</label></div></div><div className="col-md-3"><div className="custom-control custom-checkbox"><input type="radio" className="" name={`answer-${index}`} checked={!ques.answer} onChange={() => this.handleAnswerChange(index, false)} /><label className="">No</label></div></div></div></div></div>))}</div><div><button type="button" className="btn btn-info" onClick={this.saveQueryQuestion}><span>Submit</span></button></div></div>)}{quesSubmitted && (<div className="row"><div className="col-md-6"><label>To:</label><div className="form-group">{this.state.office_users && this.state.office_users.length ? this.state.office_users.map((user: any, index) => (<div className="custom-control custom-checkbox" key={index}><input type="checkbox" className="" onChange={(e) => this.selectUser(e, user)} defaultChecked /><label className="">{user.name + " - " + user.email}</label></div>)) : (<button onClick={this.addItem} className="btn btn-primary m-b-20">+ Add User</button>)}</div></div><div className="col-md-6"><label>Cc:</label><div className="form-group">{this.state.office_users && this.state.office_users.length ? this.state.office_users.map((user: any, index) => (<div className="custom-control custom-checkbox" key={index}><input type="checkbox" className="" onChange={(e) => this.selectCcUser(e, user)} defaultChecked /><label className="">{user.name + " - " + user.email}</label></div>)) : (<button onClick={this.addItem} className="btn btn-primary m-b-20">+ Add User</button>)}</div></div></div>)}</div>{quesSubmitted && (<div className="modal-footer"><button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => this.setState({ quesSubmitted: false })}>Close</button><button type="button" className="btn btn-info" disabled={queryLoading} onClick={this.saveQuery}>{queryLoading ? (<div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div>) : (<span>Send</span>)}</button></div>)}</div></div></div>
        <div className="modal fade" id="preview-tempdocToPreview" role="dialog" aria-hidden="true"><div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1200px" }}><div className="modal-content"><div className="modal-header"><h5 className="modal-title">Preview</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div className="modal-body"><iframe width="100%" height="500px" src={this.state.tempdocToPreview}></iframe></div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.setState({ tempdocToPreview: "" })}>Close</button></div></div></div></div>
        <div className={`modal ${this.state.previewDoc ? "open" : ""}`} id="preview-document" role="dialog" aria-hidden={this.state.previewDoc === ""} {...(this.state.previewDoc === "" && { inert: "" })}><div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1400px" }}><div className="modal-content" style={{ height: "90vh" }}><div className="modal-header"><h5 className="modal-title">Document Preview</h5><button type="button" className="close cursor-pointer" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ previewDoc: "" })}><span aria-hidden={this.state.previewDoc === ""}>&times;</span></button></div><div className="modal-body"><iframe width="100%" height="100%" src={this.state.previewDoc}></iframe></div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.setState({ previewDoc: "" })}>Close</button></div></div></div></div>
        <div className="modal hide fade in" id="in_time" data-backdrop="static" data-keyboard="false"><div className="modal-dialog"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}><div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}><h5>Please Select a Reason To Open File.No: {this.props.match.params.id}</h5><div className="form-group" style={{ width: "74%", margin: "auto" }}><select className="custom-select" name="in_reason" value={this.state.in_reason.trimStart()} onChange={(e) => this.onchangeReason(e)} required style={{ marginTop: "24px" }}><option value="select">Select.</option><option value="New Login">New Login</option><option value="Manual">Manual</option><option value="Query Received">Query Received</option><option value="Previous Login Pending">Previous Login Pending</option><option value="Previous Query Pending">Previous Query Pending</option><option value="Re-Assign">Re-Assign</option><option value="Doubts&Clarification">Doubts/Clarification</option><option value="Verification">Verification</option><option value="Data Entry">Data Entry</option><option value="Vetting">Vetting</option><option value="other">Others</option></select>{selectVal ? (<p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>Please Select Your Reason </p>) : null}</div></div><div className="modal-footer"><button type="button" className="btn btn-primary" onClick={() => this.SubmitREsponse()} disabled={this.state.isLoading} style={{ width: "76px", fontSize: "17px" }}>{this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}</button><button type="button" className="btn btn-outline" onClick={() => this.previousPage("back")} style={{ width: "76px", fontSize: "17px", border: "1px solid black" }}>Back</button></div></div></div></div>
        <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false"><div className="modal-dialog"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}><h5 style={{ marginTop: "31px", textAlign: "center" }}>Please Type a Reason To Open File.No: {this.props.match.params.id}</h5><div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}>{this.state.showModal && (<div className="form-group" style={{ width: "98%", margin: "auto" }}><textarea typeof="text" className="form-control" placeholder="Type Your Reason" name="in_reason" onChange={this.onchange} ref={this.textareaRef} autoFocus={true} />{selectVal ? (<p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>Please Type Your Reason </p>) : null}</div>)}</div><div className="modal-footer"><button type="button" className="btn btn-primary" onClick={() => this.SubmitREsponse()} disabled={this.state.isLoading} style={{ width: "76px", fontSize: "17px" }}>{this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}</button><button type="button" className="btn btn-outline" onClick={() => this.previousPop()} style={{ width: "76px", fontSize: "17px", border: "1px solid black" }}>Back</button></div></div></div></div>
        <div className="modal fade" id="deviationModal" tabIndex={-1} role="dialog" aria-labelledby="deviationLabel" aria-hidden="true"><div className="modal-dialog" role="document"><div className="modal-content"><div className="modal-header"><h5>Are you sure you want to request for deviation?</h5></div><div className="modal-body"><p style={{ textAlign: "center", color: "black" }}>Please Type a Reason To deviation request for this query</p><div className="form-group" style={{ width: "98%", margin: "auto" }}><textarea className="form-control" placeholder="Type Your Reason" onChange={(e) => this.handleDeviationReasonChange(e)} value={this.state.deviationReason} name="deviationReason" />{isEmpty(this.state.deviationReason) ? (<p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>Please type your reason </p>) : null}</div></div><div className="modal-footer"><button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.closeDeviationModal()}>No</button><button type="button" className="btn btn-primary" onClick={() => this.submitRequeryDeviation()}>{this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Yes"}</button></div></div></div></div>
        {this.state.showPopup && (<div className="dialog-modal" role="dialog" aria-hidden="true"><div className="dialog-modal-body" role="document"><div className="modal-content"><div className="modal-header"><h5 className="modal-title">{this.state.selectedQueryname}</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ showPopup: false })}><span aria-hidden="true">&times;</span></button></div><div className="modal-body"><p>{this.state.selectedQuerytitle}</p><div style={{ width: "100%", textAlignLast: "center" }}><button onClick={() => this.Completequery()} className="justify-content-center ml2 btn btn-success btnupload text-center">Complete</button></div></div></div></div></div>)}
        <div className="modal hide fade in" id="file_not_complete_modal" data-backdrop="static" data-keyboard="false"><div className="modal-dialog"><div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}><div className="modal-body"><h5 style={{ textAlign: "left" }} dangerouslySetInnerHTML={this.state.fileNotCompleteMsg}></h5></div><div className="modal-footer"><button type="button" className="btn btn-success" data-dismiss="modal" style={{ width: "50%", fontSize: "17px", margin: "auto" }}>Ok</button></div></div></div></div>
        <Modal title="Confirm Upload" visible={this.state.isUploadModalVisible} onOk={this.sendUploadPayload} onCancel={this.hideUploadConfirmation} okText="Yes, Upload" cancelText="Cancel" okButtonProps={{ loading: this.state.uploading, disabled: this.state.uploading, type: 'primary', style: { backgroundColor: '#1890ff' } }}>
          <div style={{ padding: '10px 0' }}>
            <p>Are you sure you want to upload with the following selections?</p>
            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}><span>File Type</span><span>Status</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e8e8e8' }}><span>Send PDF</span><span style={{ color: this.state.selectedFiles.pdf ? '#52c41a' : '#ff4d4f' }}>{this.state.selectedFiles.pdf ? '✓ Selected' : '✗ Not Selected'}</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e8e8e8' }}><span>Send Word</span><span style={{ color: this.state.selectedFiles.word ? '#52c41a' : '#ff4d4f' }}>{this.state.selectedFiles.word ? '✓ Selected' : '✗ Not Selected'}</span></div>
              {this.state.info.file_status == "7" && (<div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Preliminary PDF</span><span style={{ color: this.state.selectedFiles.preliminary ? '#52c41a' : '#ff4d4f' }}>{this.state.selectedFiles.preliminary ? '✓ Selected' : '✗ Not Selected'}</span></div>)}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default FileDashboard;